<template>
  <div :class="columnClassName" data-component-type="receipt">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" :floatingcolumn="floatingcolumn" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="'receipt-container' + (!showVatFreePrices ? ' only-vat' : '') + (locked ? ' locked' : '')" style="width: 100%" ref="container">
      <div :class="'receipt-header' + (headerExpanded ? ' expanded' : '')" v-if="isReceiptHeaderVisible">
        <div class="row">
          <div class="col-xs-12">
            <div class="header-content">
              <div v-if="!selectedCustomer && !selectedBillingcustomer" v-on:click="customerSelectorDialog" class="no-customer clickable">
                <span class="header-title">{{ _('No customer selected') }}</span>
                <button class="header-button select-customer btn btn-success">{{ _('Select') }}</button>
              </div>
              <div v-else class="has-customer">
                <div class="header-tabs">
                  <a v-on:click="setPrivateCustomer" :class="'header-tab header-tab-privatecustomer'+ (isPrivateCustomer ? ' active' : '')">{{ _('Private customer') }}</a>
                  <a v-on:click="setCorporateCustomer" :class="'header-tab header-tab-corporatecustomer'+ (isCorporateCustomer ? ' active' : '')">{{ _('Company or organization') }}</a>
                  <a v-on:click="clearCustomer" class="clear-customer">{{ _('Clear') }}</a>
                </div>
                <div class="header-customers-wrap">
                  <div class="customer-container">
                    <div class="billingcustomer" v-if="isCorporateCustomer">
                      <div class="customer-icon"><i class="fa fa-fw fa-briefcase"/></div>
                      <div class="customer-details" v-if="selectedBillingcustomer">
                        <div class="billingcustomer-name header-data-title">{{ selectedBillingcustomer.company }}</div>
                        <div class="billingcustomer-department header-data-subtitle" v-if="selectedBillingcustomer.department">{{ selectedBillingcustomer.department }}</div>
                        <a class="customer-edit" v-on:click="editBillingcustomer">{{ _('Edit billing customer info') }}</a>
                      </div>
                      <div class="customer-details" v-else>
                        <div class="billingcustomer-name header-data-title">{{ _('Not selected') }}</div>
                      </div>
                    </div>
                    <div class="customer">
                      <div class="customer-icon"><i class="fa fa-fw fa-user"/></div>
                      <div class="customer-details" v-if="selectedCustomer">
                        <div class="customer-name header-data-title">{{ selectedCustomer.name }}</div>
                        <div class="customer-email header-data-detail" v-if="selectedCustomer.email">{{ selectedCustomer.email }}</div>
                        <a class="customer-edit" v-on:click="editCustomer">{{ _('Edit client info') }}</a>
                      </div>
                    </div>
                  </div>
                  <div class="button-wrap">
                    <button class="header-button change-customer btn btn-sm btn-default" v-on:click="customerSelectorDialog">{{ _('Change') }}</button>
                  </div>
                </div>
              </div>
              <div v-if="headerExpanded" class="header-extras">
                <div v-if="isPrivateCustomer && selectedCustomer" class="customer-data data-row">
                  <div class="data-column">
                    <div class="data-item">
                      <div class="data-label header-data-title">{{ _('Address') }}</div>
                      <div class="data-value header-data-detail">
                        {{ selectedCustomer.address }}<br/>
                        {{ selectedCustomer.zip }} {{ selectedCustomer.city }}, {{ selectedCustomer.country}}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="isCorporateCustomer && selectedBillingcustomer" class="customer-data data-row">
                  <div class="data-column">
                    <div class="data-item">
                      <div class="data-label header-data-title">{{ _('E-Invoice Address') }}</div>
                      <div class="data-value header-data-detail">{{ selectedBillingcustomer.evoice }}</div>
                    </div>
                    <div class="data-item">
                      <div class="data-label header-data-title">{{ _('E-Invoice Intermediary') }}</div>
                      <div class="data-value header-data-detail">{{ selectedBillingcustomer.evoiceint }}</div>
                    </div>
                    <div class="data-item">
                      <div class="data-label header-data-title">{{ _('Billing email') }}</div>
                      <div class="data-value header-data-detail">{{ selectedBillingcustomer.billingemail }}</div>
                    </div>
                  </div>
                  <div class="data-column">
                    <div class="data-item">
                      <div class="data-label header-data-title">{{ _('Billing address') }}</div>
                      <div class="data-value header-data-detail">
                        {{ selectedBillingcustomer.company }}<br/>
                        {{ selectedBillingcustomer.address }}<br/>
                        {{ selectedBillingcustomer.zip }} {{ selectedBillingcustomer.city }}, {{ selectedBillingcustomer.country }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bill-data">
                  <div class="data-row">
                    <div class="data-column">
                      <div class="data-item">
                        <div class="data-label header-data-title">{{ _('Payment due') }}</div>
                        <div class="data-value header-data-detail">
                          {{ _('automatic') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="data-row">
                    <div class="data-column">
                      <div class="data-item">
                        <div class="data-label header-data-title">{{ _('Payment term') }}</div>
                        <div class="data-value header-data-detail">
                          <div class="input-group">
                            <input type="number" data-android-inputmode="decimal" class="form-control" step="any" v-model="paymentterm" :placeholder="defaultPaymentterm" />
                            <span class="input-group-addon">{{ _('days') }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="data-item">
                        <div class="data-label header-data-title">{{ _('Late payment interest') }}</div>
                        <div class="data-value header-data-detail">
                          <div class="input-group">
                            <input type="number" data-android-inputmode="decimal" class="form-control"  step="any" v-model="interest" :placeholder="defaultInterest" />
                            <span class="input-group-addon">%</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="data-column">
                      <div class="data-item">
                        <div class="data-label header-data-title">{{ _('Your reference') }}</div>
                        <div class="data-value header-data-detail">
                          <input type="text" class="form-control" v-model="yourreference" />
                        </div>
                      </div>
                      <div class="data-item">
                        <div class="data-label header-data-title">{{ _('Mark') }}</div>
                        <div class="data-value header-data-detail">
                          <input type="text" class="form-control" v-model="mark" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="data-row">
                    <div class="data-column">
                      <div class="data-label header-data-title">{{ _('Additional information') }}</div>
                      <div class="data-value header-data-detail">
                        <textarea class="form-control" v-model="more" wrap="virtual"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedCustomer" v-on:click="toggleReceiptHeader" class="expand-toggle"><i :class="'fa fa-fw fa-chevron-' + (headerExpanded ? 'up' : 'down')" /></div>
      </div>
      <div :class="'receipt-wrap' + ((basketEmpty && !isProductPickerVisible && !isFreeformEditorVisible && !activeOrder) ? ' no-items' : '')">
        <div :class="'receipt-items' + ((basketEmpty && !isProductPickerVisible && !isFreeformEditorVisible && !activeOrder) ? ' no-items' : '')">
          <div class="alert alert-warning unrestored-order" v-if="unrestoredOrder">
            <p><i class="fa fa-fw fa-spinner fa-spin"></i> <strong>{{ _('Returning the products of the cancelled sale to the receipt.') }}</strong></p>
            <p>{{ _('Waiting for the connection to the server. Do not start a new sale on this receipt until the products are back.') }}</p>
            <button type="button" class="btn btn-default" :disabled="restoringOrder" v-on:click="scheduleOrderRestore(0)">{{ _('Try again now') }}</button>
          </div>
          <div class="empty-basket" v-else-if="isEmptyBasketVisible">
            <i class="fa fa-fw fa-4x fa-shopping-basket"></i>
            <p class="empty-basket-text">{{ _('The basket is empty.') }}</p>
            <div class="js-cart-product-content new-item-buttons" v-if="isNewItemButtonVisible">
              <button type="button" class="btn btn-info" v-on:click="addProduct"><i class="fa fa-fw fa-plus"></i> {{ _('Add product') }}</button>
              <button type="button" class="btn btn-info" v-on:click="addFreeform"><i class="fa fa-fw fa-pencil"></i> {{ _('Add freeform item') }}</button>
            </div>
          </div>
          <div :class="'open-title-row' +  (isConfirmedOrder ? ' bg-warning' : ' bg-info')" v-if="isOpenOrder && activeOrder">
            <h4 v-if="isConfirmedOrder">{{ _('Confirmed order') }}: {{ activeOrder.id }}</h4>
            <h4 v-else>{{ _('Open order') }}: {{ activeOrder.id }}</h4>
            <button class="btn btn-default" v-on:click="save" v-if="false && !isSaveButtonVisible">{{ _('Save') }}</button>
            <div class="folio-split-actions" v-if="isFolioSplitAvailable && !paySelectedMode">
              <button type="button" class="btn btn-default btn-sm folio-split-trigger" :title="_('Pay selected')" v-on:click="togglePaySelectedMode"><i class="fa fa-fw fa-code-fork"></i><span class="sr-only">{{ _('Pay selected') }}</span></button>
            </div>
          </div>
          <div class="folio-select-banner" v-if="paySelectedMode">
            <div class="folio-select-banner-text">
              <strong>{{ _('Pay selected') }}</strong>
              <span v-if="selectedFolioItemIds.length">{{ $filters.currency(folioPaymentBase, basketCurrency) }}</span>
              <span class="text-muted" v-if="paidFolios.length">{{ _('Paid folios') }}: {{ paidFolios.length }}</span>
            </div>
            <button type="button" class="btn btn-sm btn-default" v-on:click="togglePaySelectedMode"><i class="fa fa-fw fa-close"></i> {{ _('Cancel') }}</button>
          </div>
          <div class="row" v-if="isOpenOrder && !numBasketItems && uiLocked" style="margin-bottom: 10px">
            <div class="cart-column-wrap">
              <div style="margin-left: 12px; display: inline-block" class="fa fa-fw fa-refresh fa-spin"></div><span> {{ _('Loading...') }}</span>
            </div>
          </div>
          <div class="cart-column-wrap">
            <div class="js-cart-col" v-if="!numBasketItems && activeOrder && isNewItemButtonVisible">
              <div>
                <div class="js-cart-product-content new-item-buttons">
                  <button type="button" class="btn btn-info" v-on:click="addProduct"><i class="fa fa-fw fa-plus"></i> {{ _('Add product') }}</button>
                  <button type="button" class="btn btn-info" v-on:click="addFreeform"><i class="fa fa-fw fa-pencil"></i> {{ _('Add freeform item') }}</button>
                </div>
              </div>
            </div>
            <template v-if="!hasShipments">
              <div class="js-cart-col" :data-shop="basketShopId" v-for="(items, basketShopId) in basketsWithItems">
                <cart-item :has-shipments="hasShipments" :shipments="shipments[basketShopId]" :deliverymethods="shopDeliveryMethods[basketShopId]" :allItems="items" :receiptData="data" :index="index" :readonly="isConfirmedOrder" :settings="shopSettings(basketShopId)" :shopId="basketShopId" :masterShopId="shopId" :baseDomain="baseDomain" :locale="locale" :currItem="item" v-for="item in items" :key="item.id" :billingCustomer="selectedBillingcustomer" leftcolwidth="0" rightcolwidth="12" context="page" :accounts="netvisorAccounts" :isVatVisible="isVatVisible" :folio-select-mode="paySelectedMode" :folio-selectable="isFolioSplitAvailable && paySelectedMode && isFolioItemSelectable(item)" :folio-selected="isFolioItemInSelection(item)" :folio-locked="isFolioSelectionLocked" v-if="item && !item.valuecard_id" v-on:itemModificationStart="enableItemModification" v-on:itemModificationEnd="disableItemModification" v-on:folioToggle="toggleFolioItem(item)"></cart-item>
                <cart-item :has-shipments="hasShipments" :shipments="shipments[basketShopId]" :deliverymethods="shopDeliveryMethods[basketShopId]" :allItems="items" :receiptData="data" :index="index" :readonly="isConfirmedOrder" :settings="shopSettings(basketShopId)" :shopId="basketShopId" :masterShopId="shopId" :baseDomain="baseDomain" :locale="locale" :currItem="emptyItem" key="new" :billingCustomer="selectedBillingcustomer" leftcolwidth="0" rightcolwidth="12" context="page" :accounts="netvisorAccounts" :isVatVisible="isVatVisible" v-if="basketShopId === shopId && isFreeformEditorVisible" v-on:itemModificationStart="enableItemModification" v-on:itemModificationEnd="disableItemModification"></cart-item>
                <div class="js-cart-product row" v-if="basketShopId === shopId && isProductPickerVisible">
                  <div class="col-md-12 flex-row">
                    <v-select :options="filteredProducts" v-model="selectedProduct" v-on:option:selected="addProductItem" label="name" keys="['name']" :placeholder="_('Type to search products')" :create-item="false">
                      <template v-slot:no-options="{ searching }">
                        <template v-if="searching">
                          {{ _('No results found.') }}
                        </template>
                        <template v-else>{{ _('Type to search products') }}</template>
                      </template>
                      <template v-slot:option="option">
                        <span>{{ option.name }}<template v-if="option.shopid !== shopId"> ({{ option.shopid }})</template></span><span class="item-type to-right">{{ productType(option) }}</span>
                      </template>
                    </v-select>
                    <button type="button" class="btn btn-default" v-on:click="cancelAddProduct">{{ _('Cancel') }}</button>
                  </div>
                </div>
                <div v-if="basketShopId === shopId && isNewItemButtonVisible">
                  <div class="js-cart-product-content new-item-buttons">
                    <button type="button" class="btn btn-info" v-on:click="addProduct"><i class="fa fa-fw fa-plus"></i> {{ _('Add product') }}</button>
                    <button type="button" class="btn btn-info" v-on:click="addFreeform"><i class="fa fa-fw fa-pencil"></i> {{ _('Add freeform item') }}</button>
                  </div>
                </div>
                <div class="js-cart-merchant" v-if="shouldShowMerchantDetails">
                  <div class="js-cart-merchant-title">{{ _('Merchant') }}</div>
                  <div class="row">
                    <div class="col-md-6 js-cart-merchant-left">
                      <span class="js-cart-merchant-name js-cart-merchant-detail">{{ shopSettings(basketShopId).companyname }}</span>
                      <span class="js-cart-merchant-phone js-cart-merchant-detail">{{ shopSettings(basketShopId).companyphone }}</span>
                      <span class="js-cart-merchant-www js-cart-merchant-detail"><a :href="'http://' + shopSettings(basketShopId).companyurl" target="_blank">{{ shopSettings(basketShopId).companyurl }}</a></span>
                    </div>
                    <div class="col-md-6 js-cart-merchant-right">
                      <span class="js-cart-merchant-companyid js-cart-merchant-detail">{{ shopSettings(basketShopId).companyid }}</span>
                      <span class="js-cart-merchant-email js-cart-merchant-detail">{{ shopSettings(basketShopId).companyemail }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="!numBasketItems && (isProductPickerVisible || isFreeformEditorVisible)">
                <div class="js-cart-col" v-if="isProductPickerVisible">
                  <div class="js-cart-product row">
                    <div class="col-md-12 flex-row">
                      <v-select :options="filteredProducts" v-model="selectedProduct" v-on:option:selected="addProductItem" label="name" keys="['name']" :placeholder="_('Type to search products')" :create-item="false">
                        <template v-slot:no-options="{ searching }">
                          <template v-if="searching">
                            {{ _('No results found.') }}
                          </template>
                          <template v-else>{{ _('Type to search products') }}</template>
                        </template>
                        <template v-slot:option="option">
                          <span>{{ option.name }}<template v-if="option.shopid !== shopId"> ({{ option.shopid }})</template></span><span class="item-type to-right">{{ productType(option) }}</span>
                        </template>
                      </v-select>
                      <button type="button" class="btn btn-default" v-on:click="cancelAddProduct">{{ _('Cancel') }}</button>
                    </div>
                  </div>
                </div>
                <div class="js-cart-col" v-else-if="isFreeformEditorVisible">
                  <cart-item :has-shipments="hasShipments" :shipments="shipments[shopId]" :deliverymethods="shopDeliveryMethods[shopId]" :allItems="items" :receiptData="data" :index="index" :readonly="isConfirmedOrder" :settings="shopSettings(shopId)" :shopId="shopId" :masterShopId="shopId" :baseDomain="baseDomain" :locale="locale" :currItem="emptyItem" key="new" :billingCustomer="selectedBillingcustomer" leftcolwidth="0" rightcolwidth="12" context="page" :accounts="netvisorAccounts" v-on:itemModificationStart="enableItemModification" v-on:itemModificationEnd="disableItemModification" v-on:deliveryChanged="deliveryChanged(shopId, item, $event)"></cart-item>
                </div>
              </template>
            </template>
            <div v-else v-for="(items, basketShopId) in basketsWithItems">
              <div v-for="(shipment, index) in shipments[basketShopId]" :class="'shipment-wrap' + (shipment.active ? ' active' : '')" v-on:click="activateShipment(basketShopId, shipment)">
                <div class="shipment-header" v-if="!isShipmentHeaderActive(basketShopId, shipment)" v-on:click="activateShipmentHeader(basketShopId, shipment)">
                  <span class="shipment-title">{{ _('Delivery') }} {{ shipment.number }}<template v-if="shipment.deliverymethod">: {{ shipment.deliverymethod.name }}</template><template v-if="shipment.delivery && shipment.delivery.ts && parseInt(shipment.delivery.manualtime)"> ({{ DateTime.fromSeconds(Number(shipment.delivery.ts), { zone: timezone }).toFormat(dateFormat) }} {{ _('at') }} {{ DateTime.fromSeconds(Number(shipment.delivery.ts), { zone: timezone }).toFormat(timeFormat) }})</template></span>
                  <button type="button" class="add-shipment btn btn-xs btn-default" v-if="!paySelectedMode"><i class="fa fa-fw fa-pencil"></i></button>
                </div>
                <div class="shipment-header-open" v-else>
                  <div class="item-modify-row">
                    <div class="item-modify-shipment has-float-label">
                      <select class="form-control" v-model="shipment.deliverymethod">
                        <option v-for="deliveryMethod in shopDeliveryMethods[basketShopId]" :value="deliveryMethod">{{ deliveryMethod.name }} <template v-if="parseInt(deliveryMethod.shipit_pricing)">- Shipit<template v-if="parseFloat(deliveryMethod.shipit_margin)"> + {{ deliveryMethod.shipit_margin }}%</template></template><template v-else-if="!parseInt(deliveryMethod.internal)">- {{ $filters.currency(deliveryMethod.price, basketCurrency) }}</template><template v-else>- {{ _('Internal') }}</template></option>
                      </select>
                      <label>{{ _('Delivery method') }}</label>
                    </div>
                    <div class="item-modify-shipmentcost" v-if="shipment.delivery && shipment.deliverymethod && !parseInt(shipment.deliverymethod.internal)">
                      <div class="input-group has-float-label">
                        <input type="number" data-android-inputmode="decimal" step="any" :lang="locale" class="form-control" v-model="shipment.delivery.manualprice">
                        <label>{{ _('Delivery costs') }}</label>
                        <span class="input-group-addon">{{ $filters.currencySymbol(basketCurrency) }}</span>
                      </div>
                      <div class="shipmentcost-tax"><span>{{ _('inc. vat') }}</span></div>
                    </div>
                    <div class="item-modify-deliverytime" v-if="shipment.delivery && shipment.deliverymethod">
                      <button class="btn btn-info" v-on:click="scheduleDeliveryDialog(shipment)"><i class="fa fa-fw fa-calendar"></i></button>
                    </div>
                  </div>
                  <div class="item-modify-row item-confirm-buttons">
                    <div class="item-modify-ok"><button class="btn btn-primary" v-on:click="shipmentDataChanged(basketShopId, shipment)">{{ _('OK') }}</button></div>
                    <div class="item-modify-cancel"><button class="btn btn-default" v-on:click="deactivateShipmentHeader(basketShopId)">{{ _('Cancel') }}</button></div>
                  </div>
                </div>
                <div class="shipment-items">
                  <div class="js-cart-col" :data-shop="basketShopId">
                    <template v-for="item in shipment.items">
                      <cart-item :has-shipments="hasShipments" :shipments="shipments[basketShopId]" :deliverymethods="shopDeliveryMethods[basketShopId]" :allItems="shipment.items" :receiptData="data" :index="index" :readonly="isConfirmedOrder" :settings="shopSettings(basketShopId)" :shopId="basketShopId" :masterShopId="shopId" :baseDomain="baseDomain" :locale="locale" :currItem="item" :key="item.id" :billingCustomer="selectedBillingcustomer" leftcolwidth="0" rightcolwidth="12" context="page" :accounts="netvisorAccounts" :isVatVisible="isVatVisible" :folio-select-mode="paySelectedMode" :folio-selectable="isFolioSplitAvailable && paySelectedMode && isFolioItemSelectable(item)" :folio-selected="isFolioItemInSelection(item)" :folio-locked="isFolioSelectionLocked" v-if="item && !item.valuecard_id" v-on:itemModificationStart="enableItemModification" v-on:itemModificationEnd="disableItemModification" v-on:folioToggle="toggleFolioItem(item)"></cart-item>
                    </template>
                    <cart-item :has-shipments="hasShipments" :shipments="shipments[basketShopId]" :deliverymethods="shopDeliveryMethods[basketShopId]" :allItems="shipment.items" :receiptData="data" :index="index" :readonly="isConfirmedOrder" :settings="shopSettings(basketShopId)" :shopId="basketShopId" :masterShopId="shopId" :baseDomain="baseDomain" :locale="locale" :currItem="emptyItem" key="new" :billingCustomer="selectedBillingcustomer" leftcolwidth="0" rightcolwidth="12" context="page" :accounts="netvisorAccounts" :isVatVisible="isVatVisible" v-if="basketShopId === shopId && isFreeformEditorVisible && shipment.active" v-on:itemModificationStart="enableItemModification" v-on:itemModificationEnd="disableItemModification"></cart-item>
                    <div class="js-cart-product row" v-if="basketShopId === shopId && isProductPickerVisible && shipment.active">
                      <div class="col-md-12 flex-row">
                        <v-select :options="filteredProducts" v-model="selectedProduct" v-on:option:selected="addProductItem" label="name" keys="['name']" :placeholder="_('Type to search products')" :create-item="false">
                          <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                              {{ _('No results found.') }}
                            </template>
                            <template v-else>{{ _('Type to search products') }}</template>
                          </template>
                          <template v-slot:option="option">
                            <span>{{ option.name }}<template v-if="option.shopid !== shopId"> ({{ option.shopid }})</template></span><span class="item-type to-right">{{ productType(option) }}</span>
                          </template>
                        </v-select>
                        <button type="button" class="btn btn-default" v-on:click="cancelAddProduct">{{ _('Cancel') }}</button>
                      </div>
                    </div>
                    <div v-if="basketShopId === shopId && (isNewItemButtonVisible || (isPrintManifestAvailable && !paySelectedMode)) && shipment.active">
                      <div class="js-cart-product-content new-item-buttons">
                        <button type="button" class="btn btn-info" v-if="isNewItemButtonVisible" v-on:click="addProduct"><i class="fa fa-fw fa-plus"></i> {{ _('Add product') }}</button>
                        <button type="button" class="btn btn-info" v-if="isNewItemButtonVisible" v-on:click="addFreeform"><i class="fa fa-fw fa-pencil"></i> {{ _('Add freeform item') }}</button>
                        <button type="button" class="btn btn-primary" v-if="isPrintManifestAvailable && !paySelectedMode" v-on:click="printDeliveryManifest(shipment)"><i class="fa fa-fw fa-print"></i> {{ _('Print delivery manifest') }}</button>
                      </div>
                    </div>
                    <div class="js-cart-merchant" v-if="shouldShowMerchantDetails">
                      <div class="js-cart-merchant-title">{{ _('Merchant') }}</div>
                      <div class="row">
                        <div class="col-md-6 js-cart-merchant-left">
                          <span class="js-cart-merchant-name js-cart-merchant-detail">{{ shopSettings(basketShopId).companyname }}</span>
                          <span class="js-cart-merchant-phone js-cart-merchant-detail">{{ shopSettings(basketShopId).companyphone }}</span>
                          <span class="js-cart-merchant-www js-cart-merchant-detail"><a :href="'http://' + shopSettings(basketShopId).companyurl" target="_blank">{{ shopSettings(basketShopId).companyurl }}</a></span>
                        </div>
                        <div class="col-md-6 js-cart-merchant-right">
                          <span class="js-cart-merchant-companyid js-cart-merchant-detail">{{ shopSettings(basketShopId).companyid }}</span>
                          <span class="js-cart-merchant-email js-cart-merchant-detail">{{ shopSettings(basketShopId).companyemail }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="shipment-footer" v-if="shipment.deliverymethod && !parseInt(shipment.deliverymethod.internal)">
                  <div class="shipmentcost">
                    <span class="shipmentcost-name shipmentcost-item"><span class="shipmentcost-label">{{ _('Delivery costs') }}</span></span>
                    <template v-if="shipment.deliverymethod.shipit_id && !parseFloat(shipment.deliverymethod.price)">
                      <span class="shipmentcost-value shipmentcost-item"><span class="shipmentcost-amount"><i class="fa fa-fw fa-exclamation-triangle"></i>ShipIt</span></span>
                    </template>
                    <template v-else>
                      <span class="shipmentcost-vatfree shipmentcost-item"><span class="shipmentcost-amount">{{ $filters.currency(getShipmentVatFree(basketShopId, shipment), basketCurrency) }}</span><span class="shipmentcost-desc">{{ _('vat') }} 0%</span></span>
                      <span class="shipmentcost-value shipmentcost-item"><span class="shipmentcost-amount">{{ $filters.currency(getShipmentPrice(basketShopId, shipment), basketCurrency) }}</span><span if="true" class="shipmentcost-desc">{{ _('VAT share') }} {{ $filters.currency(getShipmentVat(basketShopId, shipment), basketCurrency) }}</span></span>
                    </template>
                  </div>
                </div>
              </div>
              <div class="js-cart-col" v-if="!myBasketItems[shopId].length">
                <cart-item :has-shipments="hasShipments" :shipments="shipments[shopId]" :deliverymethods="shopDeliveryMethods[shopId]" :allItems="items" :receiptData="data" :index="index" :readonly="isConfirmedOrder" :settings="shopSettings(shopId)" :shopId="shopId" :masterShopId="shopId" :baseDomain="baseDomain" :locale="locale" :currItem="emptyItem" key="new" :billingCustomer="selectedBillingcustomer" leftcolwidth="0" rightcolwidth="12" context="page" :accounts="netvisorAccounts" :isVatVisible="isVatVisible" v-if="isFreeformEditorVisible" v-on:itemModificationStart="enableItemModification" v-on:itemModificationEnd="disableItemModification"></cart-item>
                <div class="js-cart-product row" v-if="isProductPickerVisible">
                  <div class="col-md-12 flex-row">
                    <v-select :options="filteredProducts" v-model="selectedProduct" v-on:option:selected="addProductItem" label="name" keys="['name']" :placeholder="_('Type to search products')" :create-item="false">
                      <template v-slot:no-options="{ searching }">
                        <template v-if="searching">
                          {{ _('No results found.') }}
                        </template>
                        <template v-else>{{ _('Type to search products') }}</template>
                      </template>
                      <template v-slot:option="option">
                        <span>{{ option.name }}<template v-if="option.shopid !== shopId"> ({{ option.shopid }})</template></span><span class="item-type to-right">{{ productType(option) }}</span>
                      </template>
                    </v-select>
                    <button type="button" class="btn btn-default" v-on:click="cancelAddProduct">{{ _('Cancel') }}</button>
                  </div>
                </div>
                <div v-if="isNewItemButtonVisible">
                  <div class="js-cart-product-content new-item-buttons">
                    <button type="button" class="btn btn-info" v-on:click="addProduct"><i class="fa fa-fw fa-plus"></i> {{ _('Add product') }}</button>
                    <button type="button" class="btn btn-info" v-on:click="addFreeform"><i class="fa fa-fw fa-pencil"></i> {{ _('Add freeform item') }}</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="pos-delivery-wrap" v-if="posDeliveryAvailable">
              <button type="button" :class="'btn btn-sm ' + (posDeliveryActive ? ' btn-primary active' : 'btn-default')" v-on:click="togglePosDelivery">
                <i :class="'fa fa-fw ' + (posDeliveryActive ? 'fa-check-square-o' : 'fa-square-o')"></i>
                <span v-if="!posDeliveryActive">{{ _('Use POS delivery') }}</span>
                <span v-else>{{ _('POS delivery in use') }}</span>
              </button>
              <span class="spacer"></span>
            </div>
          </div>
        </div>
        <div class="receipt-footer">
          <div :class="'js-cart-totals cart-totals-singlerow' + (isPaySelectedSplit ? ' folio-selected-totals' : '')" v-if="!basketEmpty && hasVisiblePricing">
            <span class="cart-price-wrap cart-total-wrap" v-if="hasVisiblePricing">
              <span class="cart-total-price cart-total-priceitem"><span class="cart-total-amount">{{ isPaySelectedSplit ? _('Pay selected') : _('Total') }}</span><span class="cart-total-desc folio-remaining-desc" v-if="isPaySelectedSplit">{{ _('Left on the order') }} {{ $filters.currency(folioRemainingTotal, basketCurrency) }}</span></span>
              <span class="cart-total-price-vatfree cart-total-priceitem"><span class="cart-total-amount">{{ $filters.currency(footerTotalVatFree, basketCurrency) }}</span><span class="cart-total-desc">{{ _('vat') }} 0%</span></span>
              <span class="cart-total-pricetotal cart-total-priceitem"><span class="cart-total-amount">{{ $filters.currency(footerTotal, basketCurrency) }}</span><span if="true" class="cart-total-desc">{{ _('VAT share') }} {{ $filters.currency(footerTotalVat, basketCurrency) }}</span></span>
            </span>
            <div class="folio-split-actions" v-if="paySelectedMode || (isFolioSplitAvailable && !(isOpenOrder && activeOrder))">
              <button type="button" :class="'btn btn-default btn-sm folio-split-trigger' + (paySelectedMode ? ' folio-split-cancel' : '')" :title="paySelectedMode ? _('Cancel') : _('Pay selected')" v-on:click="togglePaySelectedMode"><i :class="'fa fa-fw ' + (paySelectedMode ? 'fa-close' : 'fa-code-fork')"></i><span class="sr-only">{{ paySelectedMode ? _('Cancel') : _('Pay selected') }}</span></button>
            </div>
          </div>
          <div class="payments-list" v-if="payments.length || virtualPayments.length">
            <div class="payment-parts">
              <div class="well well-sm">
                <div class="payment-part" v-for="payment in payments">
                  <div class="payment-title">
                    <button v-if="isPaymentRemovable(payment)" type="button" class="remove-payment-part btn btn-danger btn-xs" v-on:click="removePayment(payment)"><span class="fa fa-fw fa-close"></span></button>
                    <button v-if="isPaymentRefundable(payment)" type="button" class="remove-payment-part btn btn-danger btn-xs" v-bind:disabled="isPaymentRefunding(payment)" v-on:click="refundPayment(payment)"><span class="fa fa-fw fa-close"></span></button>
                    <button v-if="payment.resolved" type="button" class="resolved-payment-part btn btn-success btn-xs"><span class="fa fa-fw fa-check"></span></button>
                    {{ getPaymentTitle(payment.type) }} 
                    <template v-if="payment.type === 'mobilepay' && settings.pay_option18_msn_pos">
                      <span v-if="payment.mobilepayNumber">({{ formatMobilepayPhoneNumber(payment.mobilepayNumber) }})</span>
                      <span v-else-if="payment.mobilepayToken">({{ _('Customer scanned') }})</span>
                      <span v-else><button style="margin-left: 10px" class="btn btn-info btn-xs" v-on:click="showMobilepayIdentificationDialog(payment.id)"><i class="fa fa-fw fa-mobile-phone"></i> {{ _('Select payer') }}</button></span>
                    </template>
                    <span v-if="selectedBillingcustomer">({{ selectedBillingcustomer.company }})</span>
                  </div>
                  <div class="payment-amount">
                    {{ $filters.currency(payment.amount, basketCurrency) }} <button type="button" class="resolve-payment btn btn-info btn-xs" v-if="isUnresolved(payment) && (bamboraPayments.length > 1 || vivaPayments.length > 1)" v-on:click="resolveSingleCardPayment(payment)"><span class="fa fa-fw fa-credit-card-alt"></span></button>
                  </div>
                </div>
                <div class="payment-part" v-for="payment in virtualPayments">
                  <div class="payment-title">
                    <button type="button" class="remove-payment-part btn btn-danger btn-xs" v-on:click="removeVirtualPayment(payment)"><span class="fa fa-fw fa-close"></span></button>
                    {{ payment.type }}
                    <button v-if="isValuecard(payment)" type="button" class="payment-info btn btn-info btn-xs" v-on:click="loadValuecardDetails(payment)"><span class="fa fa-fw fa-info"></span></button>
                  </div>
                  <div class="payment-amount">
                    {{ $filters.currency(payment.amount, basketCurrency) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="addingPayment">
            <div class="payment-parts">
              <div class="well well-sm">
                <div class="payment-part">
                  <div class="payment-title">
                    <button type="button" class="remove-payment-part btn btn-default btn-xs"><div class="fa fa-fw fa-refresh fa-spin"></div></button> {{ _('Adding payment...') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="'js-cart-totals cart-total-due '+ (due === 0 ? 'nothing-due' : '')" v-if="!basketEmpty && (payments.length || virtualPayments.length)">
            <div class="totals-row" v-if="hasVisiblePricing">
              <div class="totals-label label-duesum">{{ _('Due') }}</div>
              <div class="totals-value value-duesum">{{ $filters.currency(due, basketCurrency) }}</div>
            </div>
            <div class="totals-row" v-if="returnable > 0 && hasVisiblePricing">
              <div class="totals-label label-giveback">{{ _('Give back') }}</div>
              <div class="totals-value value-giveback">{{ $filters.currency(returnable, basketCurrency) }}</div>
            </div>
          </div>
          <div class="receipt-footer-buttons" v-if="locked">
            <lock-info :locked="locked" :lockStatus="lockStatus" :cancel="true" v-on:forceLock="getComponentLock(true)" v-on:cancel="clearReceipt()" />
          </div>
          <div class="receipt-footer-buttons" v-else>
            <div class="receipt-footer-row footer-button-wrapper" v-if="isDiscountRowVisible">
              <discount-selector :settings="shopSettings(shopId)" :allItems="myBasketItems[shopId]" :billingCustomer="selectedBillingcustomer" :locale="locale" :shopId="shopId" :baseDomain="baseDomain" v-if="isDiscountAvailable" />
              <Dropdown buttonClass="btn-default" direction="up" v-if="isVoucherAvailable">
                <template #trigger>
                  {{ _('Voucher') }} &nbsp;<span class="caret"></span>
                </template>
                <template v-for="voucher in vouchers">
                  <li v-if="!parseInt(voucher.valuecard)"><a href="javascript:;" v-on:click="initVoucher(voucher)">{{ voucher.name }}</a></li>
                </template>
                <li style="border-top: 1px #ccc solid"><a href="javascript:;" v-on:click="useACodeDialog">{{ _('Use a code') }}</a></li>
                <!--
                <li v-for="voucher in vouchers" v-if="!parseInt(voucher.valuecard)"><a href="javascript:;" v-on:click="initVoucher(voucher)">{{ voucher.name }}</a></li>
                <li style="border-top: 1px #ccc solid"><a href="javascript:;" v-on:click="useACodeDialog">{{ _('Use a code') }}</a></li>
                -->
              </Dropdown>
              <button v-else type="button" class="btn btn-default" v-on:click="useACodeDialog">{{ _('Use a code') }}</button>
              <template v-if="!isConfirmButtonVisible && !this.isConfirmedOrder">
                <div v-if="selectedBillingcustomer" class="btn-group">
                  <button type="button" class="btn btn-default" v-on:click="initPayment('billing', selectedBillingcustomer)">{{ _('Billing') }}</button>
                </div>
                <Dropdown v-else-if="hasBillingCustomers" buttonClass="btn-default" direction="up">
                  <template #trigger>
                    {{ _('Billing') }} &nbsp;<span class="caret"></span>
                  </template>
                  <li v-for="billingCustomer in selectedCustomer.sharedBillingcustomer"><a href="javascript:;" v-on:click="initPayment('billing', billingCustomer)">{{ billingCustomer.company }}</a></li>
                  <li><a href="javascript:;" v-on:click="initPayment('billing')">{{ _('Other') }}</a></li>
                </Dropdown>
                <button type="button" class="btn btn-default" v-on:click="initPayment('billing')" v-else-if="isBillingAvailable && !hasBillingCustomers">{{ _('Billing') }}</button>
                <div v-if="isOpenOrderAvailable" class="btn-group">
                  <button type="button" class="btn btn-default" v-on:click="initPayment('open', selectedBillingcustomer)">{{ _('Open order') }}</button>
                </div>
                <Dropdown v-else-if="hasOpenCustomers" buttonClass="btn-default" direction="up">
                  <template #trigger>
                    {{ _('Open order') }} &nbsp;<span class="caret"></span>
                  </template>
                  <li v-for="billingCustomer in selectedCustomer.sharedBillingcustomer"><a href="javascript:;" v-on:click="initPayment('open', billingCustomer)">{{ billingCustomer.company }}</a></li>
                  <li><a href="javascript:;" v-on:click="initPayment('open')">{{ _('Other') }}</a></li>
                </Dropdown>
              </template>
              <button type="button" class="btn btn-default" v-on:click="initPayment('open')" v-else-if="isOpenAvailable && !isConfirmButtonVisible && !hasOpenCustomers">{{ _('Open order') }}</button>
              <Dropdown v-if="isMobilePaymentAvailable" buttonClass="btn-default" direction="up">
                <template #trigger>
                  {{ _('Mobile payment') }} &nbsp;<span class="caret"></span>
                </template>
                <li v-if="!settings.pay_option18_msn_pos"><a href="javascript:;" v-on:click="initPayment('mobilepay')">{{ _('MobilePay') }}</a></li>
                <li v-if="false"><a href="javascript:;" v-on:click="initPayment('pivo')">{{ _('Pivo') }}</a></li>
                <li v-if="isVismaPaySet"><a href="javascript:;" v-on:click="initPayment('siirto')">{{ _('Siirto') }}</a></li>
                <li v-if="isVismaPaySet"><a href="javascript:;" v-on:click="initPayment('virtualcard')">{{ _('Virtual card') }}</a></li>
              </Dropdown>
            </div>
            <div class="payment-methods" v-if="isPaymentAndSaveRowVisible">
              <div class="receipt-footer-row">
                <div class="footer-button-wrapper">
                  <button type="button" class="btn btn-lg btn-primary btn-vippsmobilepay mobilepay" v-on:click="initPayment('mobilepay')" v-if="isMobilePayAvailable" :disabled="!isMobilePayEnabled">MobilePay<i class="fa fa-fw fa-check" v-if="mobilepayPhoneNumber"></i></button>
                  <button type="button" class="btn btn-lg btn-success" v-on:click="initPayment('admincash')" v-if="isCashAvailable" :disabled="!isCashEnabled">{{ _('Cash') }}</button>
                  <button type="button" class="btn btn-lg btn-primary" v-on:click="initCardPayment()" v-if="isCardAvailable" :disabled="!isCardEnabled">{{ _('Card') }}</button>
                  <button v-if="isDeleteBasketAvailable" :disabled="approving" class="btn btn-danger btn-lg pull-right" v-on:click="deleteBasketItems"><span class="fa fa-fw fa-trash"></span><span class="hidden">{{ _('Empty the basket') }}</span></button>
                  <Dropdown v-if="isConfirmButtonVisible" buttonClass="btn-info btn-lg" direction="up">
                    <template #trigger>
                      {{ _('Approve') }} <span class="caret"></span>
                    </template>
                    <li><a href="javascript:;" class="invoiceCompleteButton" v-on:click="confirmDialog('bill')">{{ _('Invoice') }} <i></i></a></li>
                    <li><a href="javascript:;" class="invoiceCompleteButton" v-on:click="confirmDialog('none')">{{ _('Transaction without payments') }} <i></i></a></li>
                    <li v-if="!paySelectedMode && (!activeOrder || activeOrder.payment === 'open')" role="separator" class="divider"></li>
                    <li v-if="!paySelectedMode && (!activeOrder || activeOrder.payment === 'open')"><a href="javascript:;" class="invoiceCompleteButton" v-on:click="confirmDialog('confirm')">{{ _('Confirm order') }} <i></i></a></li>
                    <li><a href="javascript:;" class="invoiceCompleteButton" v-on:click="confirmDialog('adminnone')">{{ _('No charge') }} <i></i></a></li>
                  </Dropdown>
                  <button :disabled="!isSaveButtonEnabled" v-if="isSaveButtonVisible || isOpenOrder" type="button" class="btn btn-lg btn-success savebutton" v-on:click="save">{{ _('Save') }}</button>
                </div>
              </div>
            </div>
            <div class="receipt-footer-row footer-amount" v-if="selectedPayment">
              <phone-number-input ref="mobilepayphone" v-if="isMobilePayAvailable && selectedPayment === 'mobilepay' && !mobilepayPhoneNumber && !mobilepayToken" v-model="manualMobilepayPhoneNumber" :placeholder="_('Phone number')" />
              <div class="input-group">
                <decimal-input ref="amount" v-model="selectedAmount" :placeholder="_('Amount')" v-on:finish="addPayment"></decimal-input>
                <span class="input-group-btn"><button class="btn btn-primary" type="button" v-on:click="addPayment" :disabled="!isAddPaymentEnabled || addingPayment">{{ _('Add') }}</button></span>
                <span class="input-group-btn"><button class="btn btn-default" type="button" v-on:click="cancelPayment" :disabled="addingPayment">{{ _('Cancel') }}</button></span>
              </div>
            </div>
            <div class="receipt-footer-row footer-receipt" v-if="isPrintSelectorVisible">
              <div class="separator-column"></div>
              <div class="footer-button-wrapper">
                <Dropdown containerClass="receipt-ticket-print" buttonClass="btn-default" :buttonDisabled="approving" direction="up">
                  <template #trigger>
                    {{ receiptTypeText }} &nbsp;<span class="caret"></span>
                  </template>
                  <li><a href="javascript:;" v-on:click="selectReceiptType('print')"><span :class="'fa fa-fw ' + (receiptType == 'print' ? 'fa-check' : '')"></span><span class="dropdown-text">{{ _('Print receipt') }}</span></a></li>
                  <li><a href="javascript:;" v-on:click="selectReceiptType('email')"><span :class="'fa fa-fw ' + (receiptType == 'email' ? 'fa-check' : '')"></span><span class="dropdown-text">{{ _('Email receipt') }}</span></a></li>
                  <li><a href="javascript:;" v-on:click="selectReceiptType('none')"><span :class="'fa fa-fw ' + (receiptType == 'none' ? 'fa-check' : '')"></span><span class="dropdown-text">{{ _('No receipt') }}</span></a></li>
                </Dropdown>
                <Dropdown v-if="basketHasTickets || basketHasValuecards" containerClass="receipt-ticket-print" buttonClass="btn-default" :buttonDisabled="approving" direction="up">
                  <template #trigger>
                    {{ ticketTypeText }} &nbsp;<span class="caret"></span>
                  </template>
                  <li v-if="basketHasTickets"><a href="javascript:;" v-on:click="selectTicketType('separate')"><span :class="'fa fa-fw ' + (ticketType == 'separate' ? 'fa-check' : '')"></span>
                    <span class="dropdown-text" v-if="!basketHasValuecards">{{ _('Print separate tickets') }}</span>
                    <span class="dropdown-text" v-else>{{ _('Print codes and separate tickets') }}</span>
                  </a></li>
                  <li v-if="basketHasTickets"><a href="javascript:;" v-on:click="selectTicketType('separateemail')"><span :class="'fa fa-fw ' + (ticketType == 'separateemail' ? 'fa-check' : '')"></span>
                    <span class="dropdown-text" v-if="!basketHasValuecards">{{ _('Email separate tickets') }}</span>
                    <span class="dropdown-text" v-else>{{ _('Email codes and separate tickets') }}</span>
                  </a></li>
                  <li v-if="basketHasTickets" role="separator" class="divider"></li>
                  <li><a href="javascript:;" v-on:click="selectTicketType('combined')"><span :class="'fa fa-fw ' + (ticketType == 'combined' ? 'fa-check' : '')"></span>
                    <span class="dropdown-text" v-if="basketHasTickets && !basketHasValuecards">{{ _('Print combined tickets') }}</span>
                    <span class="dropdown-text" v-else-if="!basketHasTickets && basketHasValuecards">{{ _('Print codes') }}</span>
                    <span class="dropdown-text" v-else>{{ _('Print codes and combined tickets') }}</span>
                  </a></li>
                  <li><a href="javascript:;" v-on:click="selectTicketType('combinedemail')"><span :class="'fa fa-fw ' + (ticketType == 'combinedemail' ? 'fa-check' : '')"></span>
                    <span class="dropdown-text" v-if="basketHasTickets && !basketHasValuecards">{{ _('Email combined tickets') }}</span>
                    <span class="dropdown-text" v-else-if="!basketHasTickets && basketHasValuecards">{{ _('Email codes') }}</span>
                    <span class="dropdown-text" v-else>{{ _('Email codes and combined tickets') }}</span>
                  </a></li>
                </Dropdown>
              </div>
            </div>
            <div class="receipt-footer-row footer-email" v-if="isPrintSelectorVisible && (receiptType === 'email' || ticketType === 'separateemail' || ticketType === 'combinedemail')">
              <div class="form-group">
                <label for="receiptEmail">{{ _('Email') }}</label>
                <input type="email" id="receiptEmail" class="form-control" v-model="receiptEmail" />
              </div>
            </div>
            <div class="receipt-footer-row footer-buttons" v-if="isRegularApproveButtonVisible">
              <div class="footer-button-wrapper">
                <button :disabled="!isApprovable" type="button" class="btn btn-lg btn-primary approve-button" v-on:click="approve">{{ _('Approve') }}</button>
                <button :disabled="!isApprovable" type="button" class="btn btn-lg btn-success approve-button" v-on:click="approveWithPaymentLink" v-if="showPaymentLinkButton">{{ _('Approve and send payment link') }}</button>
                <button :disabled="!isApprovable" type="button" class="btn btn-lg btn-warning approve-button" v-on:click="approveWithConfirmationLink" v-if="showPaymentLinkButton">{{ _('Approve and send confirmation link') }}</button>
                <button v-if="isVivaManualUnlockAvailable" type="button" class="btn btn-lg btn-default approve-button" v-on:click="unlockStuckVivaReceipt" :title="_('The payment terminal already charged the customer. This only unlocks the receipt so you can try Approve again - it will not charge the customer twice and will not delete any products or payments.')">{{ _('Unlock receipt') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="ticketModal" :scrollable="true" height="auto" :minWidth="300" :maxWidth="600" :adaptive="true" v-if="!floatingReceipt || primary">
      <div class="ticketinfo-container container" style="width: 100%" v-if="isScannedTicketValid">
        <div class="row">
          <div class="col-sm-12">
            <h3>{{ scannedTicket.show.product.name }}</h3>
            <h4>{{ DateTime.fromSeconds(Number(scannedTicket.show.start_ts), { zone: timezone }).toFormat(dateFormat) }} {{ DateTime.fromSeconds(Number(scannedTicket.show.start_ts), { zone: timezone }).toFormat(timeFormat) }} {{ scannedTicket.show.resource.name }}</h4>
            <div class="alert alert-success">
              <p><strong>{{ _('Seats') }}</strong></p>
              <div class="seat-items">
                <span :class="'seat-item' + (parseInt(seat.status, 10) != 0 ? ' bg-danger' : '')" v-for="seat in scannedTicket.ticket.ownSeat_ticket">
                  {{ getSeatDescription(seat.seat) }}
                </span>
              </div>
            </div>
            <div class="ticketDetails">
              <span v-if="scannedTicket.ticket.order_id">{{_('Order')}}: <strong>{{ scannedTicket.ticket.order_id}}</strong></span>
              <span v-if="scannedTicket.ticket.bill_id">{{_('Transaction')}}: <strong>{{ scannedTicket.ticket.bill_id}}</strong></span>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal class="valuecardmodal" name="valuecardModal" :scrollable="true" height="auto" :minWidth="300" :maxWidth="600" :adaptive="true" @before-open="valuecardModalOpen = true" @before-close="valuecardModalOpen = false" v-if="!floatingReceipt || primary">
      <div class="valuecardinfo-container container" v-if="isScannedValuecardValid">
        <div class="row">
          <div class="col-sm-12">
            <h2 v-if="scannedValuecard.code">{{ $filters.addDashes(scannedValuecard.code) }}</h2>
            <h3><span v-if="scannedValuecard.shopTitle">{{ scannedValuecard.shopTitle }}: </span>{{ scannedValuecard.name }}</h3>
            <h4 v-if="parseInt(scannedValuecard.count,10) > 1">{{ _('Original uses') }}: {{ scannedValuecard.count }}. {{ _('Remaining uses') }}: {{ scannedValuecard.remainingcount }}</h4>
            <template v-if="isStandardValuecard">
              <h4>
                <template v-if="!scannedValuecard.singleuse && !scannedValuecard.singleorder">{{ _('Original value') }}</template><template v-else>{{ _('Value') }}</template> {{ $filters.currency(scannedValuecard.value, basketCurrency) }}<span v-if="selectedValuecard.count > 1"> x {{ scannedValuecard.count }}</span>
                <template v-if="!scannedValuecard.singleuse && !scannedValuecard.singleorder">{{ _('Remaining value') }}: {{ $filters.currency(scannedValuecard.remainingvalue, basketCurrency) }}<span v-if="scannedValuecard.count > 1"> x {{ scannedValuecard.remainingcount }}</span></template>
              </h4>
            </template>
            <template v-else>
              <h4>{{ _('Original uses') }}: {{ scannedValuecard.count }}. {{ _('Remaining uses') }}: {{ scannedValuecard.remainingcount }}</h4>
            </template>

            <div class="form-group form-inline">
              <multiselect v-model="selectedValuecardCount" style="width: 80px" v-if="parseInt(scannedValuecard.singleuse)" :custom-label="showRemainingSeatLabel" :options="valueCardRemainingCountValues" :multiple="false" :show-labels="false" :searchable="false" :allow-empty="false"></multiselect>
              <div class="input-group" v-else>
                <decimal-input ref="valuecardamount" v-model="selectedValuecardAmount" :placeholder="_('Amount')"></decimal-input>
                <span class="input-group-addon">{{ $filters.currencySymbol(basketCurrency) }}</span>
              </div>
              <span style="display: inline-block; margin-left: 10px; margin-right: 10px"><span v-if="isStandardValuecard"> ({{ $filters.currency(scannedValuecard.remainingvalue, basketCurrency) }})</span></span>
              <button class="btn btn-info" id="addValueCardButton" v-on:click="addValueCard()">{{ _('Add') }}</button>
            </div>
            <hr>
            <ul>
              <li v-if="parseInt(scannedValuecard.singleorder, 10) && parseInt(scannedValuecard.count,10) === 1">{{ _('This value card will be completely used on this order.') }}</li>
              <li v-else-if="parseInt(scannedValuecard.singleorder, 10) && parseInt(scannedValuecard.count,10) > parseInt(scannedValuecard.remainingcount,10) && parseInt(selectedValuecard.count,10) > 1">
                {{ _('This code contains multiple value cards. One of those value cards will be completely used on this order.') }}
              </li>
              <li v-else-if="parseInt(scannedValuecard.singleorder, 10) && parseInt(scannedValuecard.remainingcount,10) > 0 && parseInt(scannedValuecard.count,10) > 1">
                {{ _('This code contains multiple value cards. One of those value cards will be completely used on this order.') }}
              </li>
              <li v-else-if="parseInt(scannedValuecard.singleorder, 10) && parseInt(scannedValuecard.remainingcount,10) === 0 && parseInt(scannedValuecard.count,10) > 1">
                {{ _('This code originally contained multiple value cards. Last of those value cards will be completely used on this order.') }}
              </li>
              <li v-if="parseInt(scannedValuecard.singleuse, 10)">{{ _('This value card is applied to a single basket item.') }}</li>
              <li v-if="!parseInt(scannedValuecard.singleorder,10) && !parseInt(scannedValuecard.singleuse, 10)">{{ _('This value card can be applied to additional orders in the future.') }}</li>
              <li v-if="parseInt(scannedValuecard.validto, 10)">{{ _('Valid to') }}: {{ $filters.timestampToDate(scannedValuecard.validto, locale.split('_')[0]) }}</li>
              <li v-else>{{ _('No set expiration date.') }}</li>
            </ul>
          </div>
        </div>
      </div>
    </modal>
    <modal class="valuecardinfomodal" name="valuecardInfoModal" height="auto" :minWidth="300" :maxWidth="600" :adaptive="true" v-if="!floatingReceipt || primary">
      <div class="valuecardinfo-container container">
        <div class="row">
          <div class="col-sm-12">
            <h2 v-if="selectedValuecard.code">{{ $filters.addDashes(selectedValuecard.code, addDashes) }}</h2>
            <h3><span v-if="selectedValuecard.shopTitle">{{ selectedValuecard.shopTitle }}: </span>{{ selectedValuecard.name }}</h3>
            <div class="form-group form-inline" v-if="selectedValuecard.personal">
              <div class="well" style="width: 100%">
                {{ _('This value card is only usable by') }} {{ selectedValuecard.personal }}
              </div>
            </div>
            <template v-if="isSelectedValuecardStandard">
              <h4>
                {{ _('Original value') }}: {{ $filters.currency(selectedValuecard.value, basketCurrency) }}<span v-if="selectedValuecard.count > 1"> x {{ selectedValuecard.count }}</span>
                <template v-if="!selectedValuecard.singleuse">{{ _('Remaining value') }}: {{ $filters.currency(selectedValuecard.remainingvalue, basketCurrency) }}<span v-if="selectedValuecard.count > 1"> x {{ selectedValuecard.remainingcount }}</span></template>
              </h4>
            </template>
            <template v-else>
              <h4>{{ _('Original uses') }}: {{ selectedValuecard.count }}, {{ _('Remaining uses') }}: {{ selectedValuecard.remainingcount }}</h4>
            </template>
            <ul>
              <li v-if="parseInt(selectedValuecard.singleorder, 10) && parseInt(selectedValuecard.count,10) === 1">{{ _('This value card will be completely used on this order.') }}</li>
              <li v-else-if="parseInt(selectedValuecard.singleorder, 10) && parseInt(selectedValuecard.count,10) > parseInt(selectedValuecard.remainingcount,10) && parseInt(selectedValuecard.count,10) > 1">
                {{ _('This code contains multiple value cards. One of those value cards will be completely used on this order.') }}
              </li>
              <li v-else-if="parseInt(selectedValuecard.singleorder, 10) && parseInt(selectedValuecard.remainingcount,10) > 0 && parseInt(selectedValuecard.count,10) > 1">
                {{ _('This code contains multiple value cards. One of those value cards will be completely used on this order.') }}
              </li>
              <li v-else-if="parseInt(selectedValuecard.singleorder, 10) && parseInt(selectedValuecard.remainingcount,10) === 0 && parseInt(selectedValuecard.count,10) > 1">
                {{ _('This code originally contained multiple value cards. Last of those value cards will be completely used on this order.') }}
              </li>
              <li v-if="parseInt(selectedValuecard.singleuse, 10)">{{ _('This value card is applied to a single basket item.') }}</li>
              <li v-if="!parseInt(selectedValuecard.singleorder, 10) && !parseInt(selectedValuecard.singleuse, 10)">{{ _('This value card can be applied to additional orders in the future.') }}</li>
              <li v-if="parseInt(selectedValuecard.validto, 10)">{{ _('Valid to') }}: {{ $filters.timestampToDate(selectedValuecard.validto, locale.split('_')[0]) }}</li>
              <li v-else>{{ _('No set expiration date.') }}</li>
            </ul>
            <div class="valuecard-modal-buttons">
              <button type="button" class="btn btn-primary" @click="$modal.hide('valuecardInfoModal')">{{ _('Close')}}</button>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="valuecardErrorModal" :width="600" :height="300" v-if="!floatingReceipt || primary">
      <div class="valuecardinfo-container container">
        <div class="row">
          <div class="col-sm-12">
            <h3 v-if="scannedValuecard && scannedValuecard.name">{{ scannedValuecard.name }}</h3>
            <h3 v-else>{{ _('Error') }}</h3>
            <h4>{{ _('The value card is invalid.') }}</h4>
          </div>
        </div>
      </div>
    </modal>
    <div v-if="uiLocked && !currentReceiptIsFloatingButClosed" id="lockLayer"></div>
    <div id="paymentIframe" v-if="cardPaymentActive">
      <iframe scrolling="yes" :src="paymentIframeSrc" v-on:load="paymentIframeLoaded" :class="paymentIframeClass"></iframe>
    </div>
    <ReservableProductListItem v-if="productToAdd" :column="column" :activeComponent="component" :baseDomain="baseDomain" :key="productToAdd.id" :product="productToAdd" :productShopId="productToAddShopId" :auto="true" :allowResourceSelection="true" v-on:productModalClosed="productModalClosed">
      {{ productToAdd.name }}
    </ReservableProductListItem>
  </div>
</template>

<script>
  
import axios from 'axios'
import throttle from 'lodash/throttle'
import { DateTime } from 'luxon'
import basket from '~/lib/basket'
import { productNeedsModal } from '~/lib/products'
import constants from '~/lib/constants'
import components from '~/lib/components'
import modals from '~/lib/modals'
import netvisor from '~/lib/netvisor'
import settingshelpers from '~/lib/settingshelpers'
import vivaRecovery from '~/lib/vivaRecovery'
import debounce from 'lodash/debounce'
import memoize from 'lodash/memoize'
import { mapActions, mapGetters } from 'vuex'
import { BillingCustomerDetails, CustomerDetails, CustomerSelector, PaymentTerminal, MobilepayIdentification, MobilepayPaymentTerminal, VivaPaymentTerminal, DiscountSelector, ReservableProductListItem } from '#components'
import { Decimal } from 'decimal.js'
import PhoneNumberInput from '~/components/PhoneNumberInput'
import { normalizeMobilepayPhoneNumber } from '~/lib/phone'
import Multiselect from 'vue-multiselect'

// Visma Pay terminal payments: when to start asking Visma Pay for the result if the websocket hasn't delivered it,
// how often to ask, and when to give up
const BAMBORA_POLL_DELAY_MS = 5000
const BAMBORA_POLL_INTERVAL_MS = 3000
const BAMBORA_POLL_TIMEOUT_MS = 5 * 60 * 1000

export default {
  data () {
    return {
      basket: null,
      index: null,
      items: [],
      refundingPaymentIds: [],
      selectedPayment: false,
      selectedVoucher: null,
      selectedAmount: 0,
      approving: false,
      orderPosted: false,
      orderFailures: 0,
      orderSuccesses: 0,
      orderIds: {},
      terminalData: {},
      bamboraOrderNumber: false,
      bamboraOrderNumbers: {},
      vivaOrderNumber: false,
      vivaOrderNumbers: {},
      mobilepayReferences: {},
      unrestoredOrder: null,
      orderRestoreTimer: null,
      restoringOrder: false,
      customers: [],
      customerPropagated: false,
      billingcustomerPropagated: false,
      receiptType: 'print',
      ticketType: 'combined',
      receiptEmail: '',
      scannedTicket: {},
      scannedValuecard: {},
      selectedValuecard: {},
      DateTime: DateTime,
      selectedValuecardCount: 1,
      selectedValuecardAmount: 0,
      valuecardModalOpen: false,
      customer: {
        name: '',
        phone: '',
        email: '',
        company: '',
        address: '',
        zip: '',
        city: '',
        country: 'FI',
        paymentterm: '',
        ident: '',
        evoice: '',
        evoiceint: ''
      },
      cardPaymentActive: false,
      paymentIframeSrc: 'about:blank',
      paymentIframeClass: '',
      tmpOrder: {
        more: '',
        yourreference: '',
        mark: '',
        paymentterm: '',
        interest: '',
      },
      modifiedItems: [],
      paySelectedMode: false,
      selectedFolioItemIds: [],
      pendingFolioSplit: null,
      pendingSplitOrderId: null,
      totalPostedOrders: 0,
      productToAdd: null,
      productToAddShopId: null,
      isFreeformEditorVisible: false,
      isProductPickerVisible: false,
      products: [],
      filteredProducts: [],
      allProductTypes: [],
      selectedProduct: null,
      headerExpanded: false,
      backupBillingCustomer: null,
      addingPayment: false,
      activeShipmentHeader: {},
      shipitPriceCache: {},
      noDeliveryActive: false,
      uiLocked: false,
      terminalUseCounter: 0,
      terminalUseTimeout: null,
      resizeListener: null,
      triptype: null,
      reloadPaymentsDebounced: null,
      manualMobilepayPhoneNumber: null
    }
  },
  mixins: [basket, components, constants, modals, netvisor, settingshelpers, vivaRecovery],
  props: ['paymentterminal', 'defaulttickettype', 'primary', 'floatingcolumn', 'isAdminReceiptVisibleInLayout','isFloatingReceiptVisible'],
  computed: {
    ...mapGetters(['vouchers', 'activeDelivery', 'manifestprinter', 'posDeliveryActive', 'posDeliveryAvailable', 'selfService', 'contract', 'mobilepayPhoneNumber', 'mobilepayToken']),
    myComponentId() {
      if (this.floatingcolumn) {
        return 'floatingreceipt'
      }
      return this.column ? this.column.identifier + '-' + this.column.component.id : null
    },
    payments: {
      get () {
        return this.$store.state.payments[this.shopId + '-' + this.index] ? this.$store.state.payments[this.shopId + '-' + this.index] : []
      },
      set (newValue) {
        this.$store.dispatch('setPayments', { shopId: this.shopId, index: this.index, payments: newValue })
      }
    },
    isAddPaymentEnabled () {
      /*
      if (this.mobilepayPhoneNumber || this.mobilepayToken) {
        return true
      }
      if (this.isMobilePayAvailable && this.selectedPayment === 'mobilepay' && !this.manualMobilepayPhoneNumber) {
        return false
      }
      */
      return true
    },
    isReceiptHeaderVisible () {
      return !parseInt(this.selfService)
    },
    currentReceiptIsFloatingButClosed() {
      if (typeof this.isFloatingReceiptVisible === 'undefined') return false
      if (typeof this.floatingcolumn === 'undefined') return false
      return this.floatingcolumn && !this.isFloatingReceiptVisible
    },
    isOpenOrderAvailable () {
      if (this.payments && this.payments.length) {
        return false
      }
      return !!this.selectedCustomer
    },
    hasShipments () {
      if (!this.isFeatureEnabled('delivery2.0')) {
        return false
      }
      if (!this.numBasketItems) {
        return false
      }
      if (parseInt(this.selfService)) {
        return false
      }
      return true
    },
    deliverymethodIds () {
      const ret = {}
      for (let shopId in this.basketsWithItems) {
        const items = Array.isArray(this.basketsWithItems[shopId]) ? this.basketsWithItems[shopId] : []
        ret[shopId] = [...new Set(items.filter(i => i && i.delivery && i.delivery.deliverymethod_id).map(i => i.delivery.deliverymethod_id))]
      }
      return ret
    },
    shipitDeliverymethods () {
      const ret = {}
      if (!this.shopDeliveryMethods) {
        return ret
      }
      for (let shopId in this.deliverymethodIds) {
        if (this.shopDeliveryMethods[shopId] && this.shopDeliveryMethods[shopId].filter) {
          ret[shopId] = [...new Set(this.shopDeliveryMethods[shopId].filter(sdm => parseInt(sdm.shipit_id) && this.deliverymethodIds[shopId].includes(sdm.id)))]
        }
      }
      return ret
    },
    shipments: {
      get () {
        let ret = {}
        let number = 0
        for (let shopId in this.basketsWithItems) {
          ret[shopId] = []
          const deliveryItems = this.groupBy(this.basketsWithItems[shopId], 'delivery_id')
          for (let deliveryId in deliveryItems) {
            const delivery = deliveryItems[deliveryId][0] ? deliveryItems[deliveryId][0].delivery : null
            const deliverymethod = this.shopDeliveryMethods && this.shopDeliveryMethods[shopId] && delivery && delivery.deliverymethod_id ? this.shopDeliveryMethods[shopId].find(dm => parseInt(dm.id, 10) === parseInt(delivery.deliverymethod_id, 10)) : null
            const active = delivery ? parseInt(this.activeDelivery[shopId + '-' + this.index]) === parseInt(delivery.id) : this.noDeliveryActive && !this.activeDelivery[shopId + '-' + this.index]
            ret[shopId].push({
              active,
              delivery,
              deliverymethod,
              items: deliveryItems[deliveryId],
              number: ++number
            })
          }
        }
        return ret
      }
    },
    /*
    shopsWithActiveShipments () {
      let ret = []
      for (let shopId in this.shipments) {
        if (Object.prototype.hasOwnProperty.call(this.shipments, shopId)) {
          if (this.shipments[shopId].find(s => s.active)) {
            ret.push(shopId)
          }
        }
      }
      return ret
    },
    */
    isDiscountRowVisible () {
      if (!this.isProductPickerVisible && !this.isFreeformEditorVisible && !this.basketEmpty && !this.selectedPayment && this.due > 0 && !parseInt(this.selfService) && !this.basketHasFakeItems && !this.addingPayment) {
        return true
      }
      return false
    },
    isPaymentAndSaveRowVisible () {
      if (this.selectedPayment) {
        return false
      }
      if (this.basketEmpty && !this.isOpenOrder) {
        return false
      }
      if (this.due === 0 && this.payments.length) {
        return false
      }
      if (this.isProductPickerVisible || this.isFreeformEditorVisible) {
        return false
      }
      if (this.modifiedItems && this.modifiedItems.length) {
        return false
      }
      return true
    },
    isPrintSelectorVisible () {
      if (this.basketEmpty) {
        return false
      }
      if (parseInt(this.selfService)) {
        return false
      }
      if (this.due === 0 && (this.payments.length || this.basketTotal === 0)) {
        return true
      }
      return false
    },
    isRegularApproveButtonVisible () {
      if (this.basketEmpty) {
        return false
      }
      if (this.due === 0 && (this.payments.length || this.basketTotal === 0)) {
        return true
      }
      return false
    },
    emptyItem () {
      const item = {
        id: 'new',
        product_name: '',
        special: '',
        price: null,
        vat: 0,
        count: 1
      }
      if (this.isNetvisorConfigured) {
        item.netvisoraccount = '3000'
        item.netvisorvatcode = 'KOMY'
      }
      if (this.settings.pay_option17_loyalty) {
        item.loyalty = ''
      }
      return item
    },
    defaultCustomerType () {
      if (this.component && this.component.data) {
        const data = JSON.parse(this.component.data)
        if (data.defaultCustomerType) {
          return data.defaultCustomerType
        }
      }
      if(this.settings.customertype.includes('business')) {
        return 'billing'
      }
      if(this.settings.customertype.includes('private')) {
        return 'client'
      }
      return null
    },
    defaultTripType () {
      if (this.defaultCustomerType) {
        switch (this.defaultCustomerType) {
          case 'billing':
            return 'business'
          case 'client':
            return 'leisure'
        }
      }
      return 'leisure'
    },
    more: {
      get () {
        if (this.activeOrder) {
          return this.activeOrder.more
        }
        return this.tmpOrder.more
      },
      set (newValue) {
        if (this.activeOrder) {
          this.activeOrder.more = newValue
        } else {
          this.tmpOrder.more = newValue
        }
      }
    },
    yourreference: {
      get () {
        if (this.activeOrder) {
          return this.activeOrder.yourreference
        }
        return this.tmpOrder.yourreference
      },
      set (newValue) {
        if (this.activeOrder) {
          this.activeOrder.yourreference = newValue
        } else {
          this.tmpOrder.yourreference = newValue
        }
      }
    },
    mark: {
      get () {
        if (this.activeOrder) {
          return this.activeOrder.mark
        }
        return this.tmpOrder.mark
      },
      set (newValue) {
        if (this.activeOrder) {
          this.activeOrder.mark = newValue
        } else {
          this.tmpOrder.mark = newValue
        }
      }
    },
    interest: {
      get () {
        if (this.activeOrder) {
          return this.activeOrder.interest
        }
        return this.tmpOrder.interest
      },
      set (newValue) {
        if (this.activeOrder) {
          this.activeOrder.interest = newValue
        } else {
          this.tmpOrder.interest = newValue
        }
      }
    },
    paymentterm: {
      get () {
        if (this.activeOrder) {
          return this.activeOrder.pay_option1_duedays
        }
        return this.tmpOrder.paymentterm
      },
      set (newValue) {
        if (this.activeOrder) {
          this.activeOrder.pay_option1_duedays = newValue
        } else {
          this.tmpOrder.paymentterm = newValue
        }
      }
    },
    defaultPaymentterm () {
      return this._('default') + (this.selectedBillingcustomer && this.selectedBillingcustomer.paymentterm ? ' (' + this.selectedBillingcustomer.paymentterm + ')' : '')
    },
    defaultInterest () {
      return this._('default') + (this.settings && this.settings.interest ? ' (' + this.settings.interest + ')' : '')
    },
    isCorporateCustomer: {
      get () {
        return !!this.selectedBillingcustomer
      },
      set (newValue) {
        if (!newValue) {
          this.selectedBillingcustomer = null
        }
      }
    },
    isPrivateCustomer: {
      get () {
        return !this.isCorporateCustomer
      },
      set (newValue) {
        this.isCorporateCustomer = !newValue
      }
    },
    paymentTerminalId () {
      if (this.paymentterminal && this.paymentterminal.match && this.paymentterminal.match(/auto/)) {
        return this.paymentterminal.split('-')[0]
      }
      return this.paymentterminal
    },
    isBillingEnabled () {
      if (!this.data || !parseInt(this.data.enableBilling)) {
        return false
      }
      return true
    },
    isVatVisible () {
      if (!this.data) {
        return true
      }
      if (!this.data.displayVat || this.data.displayVat === 'always') {
        return true
      }
      if (this.data.displayVat === 'billingcustomer' && this.selectedBillingcustomer) {
        return true
      }
      return false
    },
    hasPayments () {
      return !!(this.payments.length + this.virtualPayments.length)
    },
    hasUnNumberedMobilepayPayments () {
      if (!parseInt(this.settings.pay_option18)) {
        return false
      }
      return this.payments ? this.payments.filter(p => p.type === 'mobilepay' && !p.mobilepayNumber && !p.mobilepayToken).length > 0 : false
    },
    isConfirmButtonEnabled () {
      if (this.hasUnNumberedMobilepayPayments) {
        return false
      }
      return this.selectedCustomer || this.selectedBillingcustomer
    },
    isConfirmButtonVisible () {
      return this.isBillingEnabled && !this.hasExternalProducts && !this.hasPayments
    },
    isSaveButtonVisible () {
      return this.isBillingEnabled && !this.hasExternalProducts && !this.hasPayments
    },
    isNewItemButtonVisible () {
      return this.isBillingEnabled && !this.isFreeformEditorVisible && !this.isProductPickerVisible && !this.isConfirmedOrder && !this.paySelectedMode
    },
    isEmptyBasketVisible () {
      return this.basketEmpty && !this.isFreeformEditorVisible && !this.isProductPickerVisible && !this.activeOrder
    },
    isStandardValuecard () {
      if (!this.scannedValuecard) {
        return false
      }
      if (parseInt(this.scannedValuecard.singleuse) === 1 && parseFloat(this.scannedValuecard.value) === 0 && parseInt(this.scannedValuecard.count) > 0) {
        return false
      }
      return true
    },
    isSelectedValuecardStandard () {
      if (!this.selectedValuecard) {
        return false
      }
      if (parseInt(this.selectedValuecard.singleuse) === 1 && parseFloat(this.selectedValuecard.value) === 0 && parseInt(this.selectedValuecard.count) > 0) {
        return false
      }
      return true
    },
    isBillingAvailable () {
      if (this.data && this.data.disablePayments && this.data.disablePayments.length && this.data.disablePayments.includes('billing')) {
        return false
      }
      return this.selectedCustomer && !this.payments.length
    },
    hasBillingCustomers () {
      return this.isBillingAvailable && this.selectedCustomer.sharedBillingcustomer && this.selectedCustomer.sharedBillingcustomer.length
    },
    hasOpenCustomers () {
      return this.isOpenAvailable && this.selectedCustomer.sharedBillingcustomer && this.selectedCustomer.sharedBillingcustomer.length
    },
    isOpenAvailable () {
      if (this.data && this.data.disablePayments && this.data.disablePayments.length && this.data.disablePayments.includes('open')) {
        return false
      }
      if (this.isConfirmedOrder) {
        return false
      }
      return this.selectedCustomer && !this.payments.length
    },
    valueCardRemainingCountValues () {
      let returnValues = []
      for (let i = 0; i < parseInt(this.scannedValuecard.remainingcount, 10); i++) {
        returnValues.push(i+1)
      }
      return returnValues
    },
    isDiscountAvailable () {
      if (this.data && this.data.disablePayments && this.data.disablePayments.length && this.data.disablePayments.includes('discount')) {
        return false
      }
      return true
    },
    isVoucherAvailable () {
      if (this.isChannelTransaction || !this.vouchers || !this.vouchers.length || this.due <= 0) {
        return false
      }
      if (this.data && this.data.disablePayments && this.data.disablePayments.length && this.data.disablePayments.includes('voucher')) {
        return false
      }
      return true
    },
    isMobilePayAvailable () {
      if (this.isChannelTransaction) {
        return false
      }
      if (this.due <= 0) {
        return false
      }
      if (parseInt(this.selfService)) {
        return false
      }
      if (!this.settings.pay_option18_msn_pos) {
        return false
      }
      if (this.data && this.data.disablePayments && this.data.disablePayments.length && this.data.disablePayments.includes('mobilepay')) {
        return false
      }
      return true
    },
    isCashAvailable () {
      if (this.isChannelTransaction) {
        return false
      }
      if (this.due <= 0) {
        return false
      }
      if (parseInt(this.selfService)) {
        return false
      }
      if (this.data && this.data.disablePayments && this.data.disablePayments.length && this.data.disablePayments.includes('cash')) {
        return false
      }
      return true
    },
    isCardAvailable () {
      if (!(this.paymentTerminalId && this.paymentTerminalId.trim())) {
        return false
      }
      if (this.isChannelTransaction && (this.bamboraPayments.length > 0 || this.paymentTerminalId === 'external')) {
        return false
      }
      if (this.due <= 0) {
        return false
      }
      if (this.data && this.data.disablePayments && this.data.disablePayments.length && this.data.disablePayments.includes('card')) {
        return false
      }
      return true
    },
    isMobilePaymentAvailable () {
      if (this.isChannelTransaction && this.bamboraPayments.length > 0) {
        return false
      }
      if (this.data && this.data.disablePayments && this.data.disablePayments.length && this.data.disablePayments.includes('mobile')) {
        return false
      }
      // Siirto, virtual card and the legacy MobilePay entry all go through Visma Pay (Bambora)
      return this.isVismaPaySet
    },
    isCashEnabled () {
      return !this.basketHasFakeItems && !this.addingPayment
    },
    isCardEnabled () {
      return !this.approving && !this.basketHasFakeItems && !this.addingPayment
    },
    isMobilePayEnabled () {
      return this.isCardEnabled
    },
    isBilling () {
      if (this.payments && this.payments[0] && this.payments[0].type === 'billing') {
        return true
      }
      return false
    },
    isOpen () {
      if (this.payments && this.payments[0] && this.payments[0].type === 'open') {
        return true
      }
      return false
    },
    isScannedTicketValid () {
      if (this.scannedTicket && this.scannedTicket.show && this.scannedTicket.ticket &&this.scannedTicket.show.product && this.scannedTicket.ticket.reservation && this.scannedTicket.ticket.ownSeat_ticket) {
        return true
      }
      return false
    },
    isScannedValuecardValid () {
      if (this.scannedValuecard && this.scannedValuecard.id) {
        return true
      }
      return false
    },
    isApprovable () {
      if (this.approving) {
        return false
      }
      if (this.unrestoredOrder) { // The cancelled sale's products are still on their way back to this receipt
        return false
      }
      if ((this.receiptType === 'email' || this.ticketType === 'separateemail' || this.ticketType === 'combinedemail') && !this.receiptEmail) {
        return false
      }
      if (this.bamboraPayments.length > 1 && this.unresolvedBamboraPayments.length > 0) {
        return false
      }
      if (this.vivaPayments.length > 1 && this.unresolvedVivaPayments.length > 0) {
        return false
      }
      if (this.settings.pay_option18_msn_pos && this.hasUnNumberedMobilepayPayments) {
        return false
      }
      if (this.modifiedItems.length) {
        return false
      }
      return true
    },
    // Last-resort manual escape hatch, off by default: only ever shown when a Viva terminal
    // payment already succeeded (so it's safe - the payment/basket are never touched here) but
    // the receipt is still locked from a stuck approve() attempt.
    isVivaManualUnlockAvailable () {
      return !!(this.data && parseInt(this.data.enableVivaManualUnlock) && this.approving && this.hasResolvedVivaPayment)
    },
    isForcedSinglePayment () {
      if (this.data && parseInt(this.data.singlePayment)) {
        return true
      }
      if (parseInt(this.selfService)) {
        return true
      }
      return false
    },
    receiptTypeStorageKey () {
      if (!this.shopId) {
        return null
      }
      return 'johku-pos-receipt-type-' + this.shopId
    },
    ticketTypeStorageKey () {
      if (!this.shopId) {
        return null
      }
      return 'johku-pos-ticket-type-' + this.shopId
    },
    receiptTypeText () {
      switch(this.receiptType) {
        case 'email':
          return this._('Email receipt')
          break
        case 'none':
          return this._('No receipt')
          break
        case 'print':
          return this._('Print receipt')
          break
      }
      return ''
    },
    ticketTypeText () {
      switch(this.ticketType) {
        case 'combined':
          if(this.basketHasTickets && this.basketHasValuecards) {
            return this._('Print codes and combined tickets')
          }
          if(this.basketHasTickets && !this.basketHasValuecards) {
            return this._('Print combined tickets')
          }
          if(!this.basketHasTickets && this.basketHasValuecards) {
            return this._('Print codes')
          }          
          break
        case 'separate':
          if(this.basketHasTickets && this.basketHasValuecards) {
            return this._('Print codes and separate tickets')
          }
          if(this.basketHasTickets && !this.basketHasValuecards) {
            return this._('Print separate tickets')
          }
          if(!this.basketHasTickets && this.basketHasValuecards) {
            return this._('Print codes')
          }          
          break
        case 'combinedemail':
          if(this.basketHasTickets && this.basketHasValuecards) {
            return this._('Email codes and combined tickets')
          }
          if(this.basketHasTickets && !this.basketHasValuecards) {
            return this._('Email combined tickets')
          }
          if(!this.basketHasTickets && this.basketHasValuecards) {
            return this._('Email codes')
          }
          break
        case 'separateemail':
          if(this.basketHasTickets && this.basketHasValuecards) {
            return this._('Email codes and separate tickets')
          }
          if(this.basketHasTickets && !this.basketHasValuecards) {
            return this._('Email separate tickets')
          }
          if(!this.basketHasTickets && this.basketHasValuecards) {
            return this._('Email codes')
          }
          break
      }
      return ''
    },
    selectedCustomer: {
      get () {
        if (!this.data) {
          return null
        }
        return this.allCustomers[this.data.index]
      },
      set (newValue) {
        this.$store.dispatch('setCustomer', {
          index: this.data.index,
          customer: newValue
        })
        if (!this.customerPropagated) {
          this.$socket.emit('message', {
            type: 'setCustomer',
            data: newValue,
            shopId: this.$store.state.shopId,
            pos: this.pos,
            index: this.index,
            clientid: this.clientid,
            tabid: this.tabid
          })
        }
      }
    },
    selectedBillingcustomer: {
      get () {
        if (!this.data) {
          return null
        }
        return this.allBillingcustomers[this.data.index]
      },
      set (newValue) {
        this.$store.dispatch('setBillingcustomer', {
          index: this.data.index,
          billingcustomer: newValue
        })
        if (!this.billingcustomerPropagated) {
          this.$socket.emit('message', {
            type: 'setBillingcustomer',
            data: newValue,
            shopId: this.$store.state.shopId,
            pos: this.pos,
            index: this.index,
            clientid: this.clientid,
            tabid: this.tabid
          })
        }
      }
    },
    paymentType () {
      let paymentType = 'admincash'
      // Filter out rounding payments so we don't get "multiple payments" on cash payments with rounding differences
      const filteredPayments = this.payments.filter(p => p.type !== 'rounding')
      if (filteredPayments.length > 1) {
        paymentType = 'multi'
      } else if (filteredPayments.length > 0) {
        paymentType = filteredPayments[0].type
      }
      return paymentType;
    },
    hasCountdown () {
      return this.firstExpirationTime !== 999999999999 && (this.hasReservations || this.hasProducts)
    },
    hasReservations () {
      return this.reservationCount > 0
    },
    hasProducts () {
      for (var shopId in this.myBasketIds) {
        if (Object.prototype.hasOwnProperty.call(this.myBasketIds, shopId)) {
          let items = this.myBasketIds[shopId]
          for (var i = 0; i < items.length; i++) {
            if (items[i].product_id) {
              return true
            }
          }
        }
      }
      return false
    },
    reservationCount () {
      let reservationCount = 0
      for (var shopId in this.myBasketIds) {
        if (Object.prototype.hasOwnProperty.call(this.myBasketIds, shopId)) {
          let items = this.myBasketIds[shopId]
          for (var i = 0; i < items.length; i++) {
            if (items[i].reservation_desc) {
              reservationCount++
            }
          }
        }
      }
      return reservationCount
    },
    shopTitle () {
      return this.settings.shoptitle || this.settings.companyname
    },
    profileImage () {
      return this.settings.profile_id ? this.baseDomain + this.shopId + '/files/' + this.settings.profile_id + '.' + this.settings.profile_ext : '/img/johku-profile.png'
    },
    basketId () {
      return this.basketIds ? this.basketIds[this.shopId] : null
    },
    locales () {
      if (this.allSettings[this.shopId + '-' + this.locale] && this.allSettings[this.shopId + '-' + this.locale].storefrontversions) {
        return this.allSettings[this.shopId + '-' + this.locale].storefrontversions.split(';') || {}
      }
      if (this.allSettings[Object.keys(this.allSettings)[0]] && this.allSettings[Object.keys(this.allSettings)[0]].storefrontversions) {
        return this.allSettings[Object.keys(this.allSettings)[0]].storefrontversions.split(';') || {}
      }
      return {}
    },
    virtualPayments () {
      // These are scanned value cards that are added to the cart as separate items. Let's pretend like they're regular payments
      let payments = []
      for (var shopId in this.myBasketItems) {
        if (Object.prototype.hasOwnProperty.call(this.myBasketItems, shopId)) {
          if (this.myBasketItems[shopId].length) {
            let items = this.myBasketItems[shopId]
            for (var i = 0; i < items.length; i++) {
              if (items[i].valuecard_id) {
                payments.push({
                  item: items[i],
                  type: items[i].product_name,
                  amount: items[i].count * (items[i].discountedprice ? items[i].discountedprice : items[i].price) * -1 // Value cards in the basket have a negative value
                })
              }
            }
          }
        }
      }
      return payments
    },
    totalOrders () {
      let total = 0
      for (var shopId in this.myBasketItems) {
        if (Object.prototype.hasOwnProperty.call(this.myBasketItems, shopId)) {
          if (this.myBasketItems[shopId].length || shopId === this.shopId) {
            total++
          }
        }
      }
      return total
    },
    folioBasketItems () {
      const items = this.myBasketItems[this.shopId] || []
      return items.filter(item => item && item.id && !item.valuecard_id && !item.voucher_id)
    },
    folioTopLevelItems () {
      return this.folioBasketItems.filter(item => this.isFolioItemSelectable(item))
    },
    isFolioSplitAvailable () {
      if (!this.isFeatureEnabled('folio') || this.isConfirmedOrder || this.totalOrders > 1 || this.folioTopLevelItems.length < 2) {
        return false
      }
      if (this.folioBasketItems.some(item => item.paymentplan)) {
        return false
      }
      if (!this.activeOrder) {
        return true
      }
      const order = this.activeOrder
      if (parseInt(order.subscription_renewal) || parseInt(order.paid) || parseInt(order.refunded) || parseInt(order.isrefund) || parseInt(order.hidden)) {
        return false
      }
      if (order.paymentplan || (order.identifier && String(order.identifier).indexOf('@') !== -1)) {
        return false
      }
      if (order.consolidate_id || parseInt(order.confirmed) === this.ORDER_CONSOLIDATED || parseInt(order.consolidated)) {
        return false
      }
      return order.payment === 'open' || parseInt(order.folio_eligible) === 1
    },
    selectedFolioItemTreeIds () {
      const selected = {}
      this.selectedFolioItemIds.forEach(id => {
        selected[parseInt(id, 10)] = true
      })
      this.folioBasketItems.forEach(item => {
        const parentId = parseInt(item.item_id, 10)
        const modifierId = parseInt(item.modifier_id, 10)
        if ((parentId && selected[parentId]) || (modifierId && selected[modifierId])) {
          selected[parseInt(item.id, 10)] = true
        }
      })
      return Object.keys(selected).map(id => parseInt(id, 10))
    },
    selectedFolioTotal () {
      let total = new Decimal(0)
      const selected = {}
      this.selectedFolioItemTreeIds.forEach(id => {
        selected[id] = true
      })
      this.folioBasketItems.forEach(item => {
        if (selected[parseInt(item.id, 10)]) {
          const price = parseFloat(item.price) || 0
          const count = parseFloat(item.count) || 0
          const resourceCount = parseInt(item.resource_count, 10) > 1 ? parseInt(item.resource_count, 10) : 1
          total = total.plus(new Decimal(price).times(count).times(resourceCount))
        }
      })
      return total.toDecimalPlaces(2).toNumber()
    },
    selectedFolioTotalVatFree () {
      let total = new Decimal(0)
      const selected = {}
      this.selectedFolioItemTreeIds.forEach(id => {
        selected[id] = true
      })
      this.folioBasketItems.forEach(item => {
        if (selected[parseInt(item.id, 10)] && item.vat !== null && item.vat !== 'null') {
          const price = parseFloat(item.price) || 0
          const count = parseFloat(item.count) || 0
          const resourceCount = parseInt(item.resource_count, 10) > 1 ? parseInt(item.resource_count, 10) : 1
          const vat = parseFloat(item.vat) || 0
          total = total.plus(new Decimal(price).times(count).times(resourceCount).dividedBy(1 + (vat / 100)))
        }
      })
      return total.toDecimalPlaces(2).toNumber()
    },
    // The footer shows the amount being paid: the selected items while paying selected, otherwise the whole order
    footerTotal () {
      return this.isPaySelectedSplit ? this.selectedFolioTotal : this.displayedTotal
    },
    footerTotalVatFree () {
      return this.isPaySelectedSplit ? this.selectedFolioTotalVatFree : this.displayedTotalVatFree
    },
    folioRemainingTotal () {
      return new Decimal(this.displayedTotal).minus(this.selectedFolioTotal).toDecimalPlaces(2).toNumber()
    },
    footerTotalVat () {
      return new Decimal(this.footerTotal).minus(this.footerTotalVatFree).toDecimalPlaces(2).toNumber()
    },
    isPaySelectedSplit () {
      if (!this.paySelectedMode || !this.selectedFolioItemIds.length) {
        return false
      }
      // Discount and delivery rows can't be moved, so they alone don't count as something left on the order
      const selected = this.selectedFolioItemTreeIds
      return this.folioBasketItems.some(item => selected.indexOf(parseInt(item.id, 10)) === -1 && !item.discount_id && !parseInt(item.isdelivery))
    },
    paidFolios () {
      const folio = this.activeOrder && this.activeOrder.folio
      const rows = folio && folio.items ? folio.items : (Array.isArray(folio) ? folio : [])
      return rows.filter(row => parseInt(row.paid))
    },
    folioPaymentBase () {
      if (this.isPaySelectedSplit) {
        return this.selectedFolioTotal
      }
      return this.basketTotal
    },
    // Payments taken while paying selected items cover exactly that selection, so it can't change afterwards
    isFolioSelectionLocked () {
      return this.paySelectedMode && this.payments.some(payment => payment.type !== 'rounding')
    },
    // The basket's rounding rows are calculated against the whole basket, so while paying selected items
    // they are ignored and the cash rounding difference is calculated against the selected total instead.
    // The backend adds the same rounding row to the folio.
    folioRoundingDiff () {
      if (!this.isPaySelectedSplit) {
        return 0
      }
      let paid = new Decimal(0)
      let hasCashPayments = false
      for (let i = 0; i < this.payments.length; i++) {
        if (this.payments[i].type === 'rounding') {
          continue
        }
        paid = paid.plus(new Decimal(this.payments[i].amount))
        if (this.payments[i].type === 'admincash') {
          hasCashPayments = true
        }
      }
      if (!hasCashPayments) {
        return 0
      }
      const diff = new Decimal(this.selectedFolioTotal).minus(paid).toDecimalPlaces(2).toNumber()
      if (diff > 0.02) {
        return 0
      }
      return new Decimal(diff).minus(this.roundToNearest5(diff)).toDecimalPlaces(2).toNumber()
    },
    paidTowardsDue () {
      let paid = new Decimal(this.folioRoundingDiff)
      for (let i = 0; i < this.payments.length; i++) {
        if (this.isPaySelectedSplit && this.payments[i].type === 'rounding') {
          continue
        }
        paid = paid.plus(new Decimal(this.payments[i].amount))
      }
      return paid
    },
    due () {
      const due = new Decimal(this.folioPaymentBase).minus(this.paidTowardsDue)
      if (due.toNumber() < 0) {
        return 0
      }
      return due.toDecimalPlaces(2).toNumber()
    },
    returnable () {
      const change = this.paidTowardsDue.minus(new Decimal(this.folioPaymentBase).toDecimalPlaces(2))
      if (change.toNumber() > 0) {
        return change.toDecimalPlaces(2).toNumber()
      }
      return 0
    },
    totalDomains () {
      let total = 0
      for (var shopId in this.myBasketIds) {
        if (Object.prototype.hasOwnProperty.call(this.myBasketIds, shopId)) {
          total++
        }
      }
      return total
    },
    isChannelTransaction () {
      let myShopId = this.$store.state.shopId
      for (var shopId in this.myBasketItems) {
        if (Object.prototype.hasOwnProperty.call(this.myBasketItems, shopId)) {
          if (shopId !== myShopId && this.myBasketItems[shopId].length) {
            return true
          }
        }
      }
      return false
    },
    voucherPayments () {
      let ret = []
      for (var i = 0; i < this.payments.length; i++) {
        if (this.payments[i].voucher) {
          ret.push(this.payments[i])
        }
      }
      return ret
    },
    showPaymentLinkButton () {
      return this.isOpen
    },
    isDeleteBasketAvailable () {
      if (this.activeOrder && parseInt(this.activeOrder.confirmed) === this.ORDER_CONFIRMED) {
        return false
      }
      return true
    },
    showVatPrices () {
      return true
    },
    showVatFreePrices () {
      return this.isVatVisible
    },
    isAdminReceiptVisible () {
      // Check if we have an admin-receipt (capable of billing) already visible in the layout. If there is, this is used to disable opening the floating receipt
      // Each Receipt component will trigger this check individually
      // Case 1: Receipt component is the floating receipt, but that one doesn't have activeLayout or any other data about the layouts, so we use a custom prop
      if (!this.activeLayout) {
        return this.isAdminReceiptVisibleInLayout
      }
      // Case 2: Receipt components in the layout should check the activeLayout and see if there are any visible (= parsedColumns[i].component) that have enableBilling = 1
      if (this.activeLayout && this.activeLayout.parsedColumns && this.activeLayout.parsedColumns.length) {
        for (let i = 0; i < this.activeLayout.parsedColumns.length; i++) {
          const component = this.activeLayout.parsedColumns[i].component
          if (component && component.type === 'Receipt') {
            const data = JSON.parse(component.data)
            if (data && parseInt(data.enableBilling)) {
              return true
            }
          }
        }
      }
      return false
    },
    isPrintManifestAvailable () {
      if (!this.isFeatureEnabled('manifestprinter') || !this.manifestprinter) {
        return false
      }
      if (!this.data || parseInt(this.data.disablePrintManifestButton)) {
        return false
      }
      return true
    },
    isStatisticsFinlandCompatible () {
      let hasCompatibleItem = false
      for (var shopId in this.basketItems) {
        if (Object.prototype.hasOwnProperty.call(this.basketItems, shopId)) {
          let items = this.basketItems[shopId]
          if (items.length) {
            for (let i = 0; i < items.length; i++) {
              let item = items[i]
              if (item.product && item.product.accommodationtype) {
                hasCompatibleItem = true
                break
              }
            }
          }
        }
      }
      return hasCompatibleItem
    }
  },
  methods: {
    ...mapActions([
      'setActiveOrder',
      'setPosDeliveryActive',
      'setMobilepayPhoneNumber',
      'setMobilepayToken'
    ]),
    lockCallback (locked) {
      if(locked) {
        this.clearReceipt()
      }
    },
    async getReceiptComponentLock() {
      let id = this.getComponentItemId()
      if (!id) {
        return
      }
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/locks/' + id + '.json?type=' + componentType + '&sid=' + this.clientid + '&timeout=' + this.lockTimeout + (force ? '&force=true' : '') + '&apikey=' + this.apiKey)
      } catch(e) {
        this.locked = true
        this.lockId = null
        this.lockStatus = e.response && e.response.data ? e.response.data.errorMessage : null
        return
      }
      this.lockId = response.data
      this.locked = false
      this.lockStatus = null
    },
    getComponentItemId () {
      let id
      if (this.activeOrder) {
        id = this.activeOrder.id
      }
      return id
    },
    async clearReceipt () {
      // Close receipt without saving
      await this.clearPayments()
      this.receiptEmail = ''
      if (this.ticketType === 'combinedemail') {
        this.selectTicketType('combined')
      }
      if (this.ticketType === 'separateemail') {
        this.selectTicketType('separate')
      }
      this.clearCustomer()
      this.resetTmpOrder()
      if (this.activeOrder) {
        this.EventBus.$emit('modifyOrder', {
          order: null
        })
      }
      this.modifiedItems = []
    },
    async clearPayments () {
      this.selectedBillingcustomer = null
      this.approving = false
      this.addingPayment = false
      this.setMobilepayPhoneNumber(null)
      this.setMobilepayToken(null)
      try {
        let orderIdentifierStr = ''
        if (this.activeOrder) {
          orderIdentifierStr = '&orderidentifier=' + this.activeOrder.identifier
        }
        const url = this.baseDomain + this.shopId + '/baskets/' + this.basketIds[this.shopId + '-' + this.index] + '/pospayments.json?apikey=' + this.apiKey + '&client=' + this.clientid + orderIdentifierStr
        await this.retryWithBackoff(() => axios.delete(url), 3, [1000, 3000])
        // A payment list requested before the clear must not bring the finished sale's payments back
        this.$store.dispatch('invalidatePayments', this.shopId + '-' + this.index)
      } catch(e) {
        // Card payments that are already on the bill are dismissed automatically on the next reload
        // (cleanupBillOwnedOrphanPayments), the rest the cashier can remove with the X button
        console.log('error removing payments', e)
        this.showError(this._('The sale was completed, but its payments could not be cleared from the receipt. Remove the remaining payments before the next sale.'))
      } finally {
        await this.reloadPayments(this.shopId + '-' + this.index)
      }
    },
    togglePosDelivery() {
      this.setPosDeliveryActive(!this.posDeliveryActive)
    },
    isShipmentHeaderActive (shopId, shipment) {
      if (!shipment) {
        return false
      }
      if (!shipment.delivery) {
        return this.activeShipmentHeader[shopId] === -1
      }
      return this.activeShipmentHeader[shopId] === shipment.delivery.id
    },
    activateShipment (shopId, shipment) {
      if (!shipment || shipment.active || this.paySelectedMode) {
        return
      }
      if (!shipment.delivery || !shipment.delivery.id) {
        this.noDeliveryActive = true
      }
      const data = {
        identifier: this.basketIds[shopId + '-' + this.index],
        delivery_id: shipment.delivery ? shipment.delivery.id : null
      }
      let orderIdentifierStr = ''
      if (this.activeOrder) {
        orderIdentifierStr = '&orderidentifier=' + this.activeOrder.identifier
      }
      axios.put(this.baseDomain + shopId + '/baskets/' + this.basketIds[shopId + '-' + this.index] + '.json?client=' + this.clientid + (shopId !== this.shopId ? '&shop=' + this.shopId : '') + orderIdentifierStr, data)
    },
    activateShipmentHeader (shopId, shipment) {
      if (!shipment || !shipment.active || this.paySelectedMode) {
        return
      }
      if (!shipment.delivery) {
        this.activeShipmentHeader[shopId] = -1
        return
      }
      this.activeShipmentHeader[shopId] = shipment.delivery.id
    },
    deactivateShipmentHeader (shopId) {
      this.activeShipmentHeader[shopId] = null
    },
    shipmentDataChanged(shopId, shipment) {
      this.shipmentDeliverymethodChanged(shopId, shipment)
      this.deactivateShipmentHeader(shopId)
    },
    async shipmentDeliverymethodChanged (shopId, shipment) {
      if (!shipment || !shipment.deliverymethod) {
        return
      }
      if (!shipment.delivery) {
        shipment.delivery = await this.createDeliveryForShipment(shopId, shipment)
      }
      if (!shipment.delivery) {
        return
      }
      const data = {
        id: shipment.delivery.id,
        deliverymethod_id: shipment.deliverymethod.id
      }
      if (shipment.delivery && shipment.delivery.manualprice !== undefined && shipment.delivery.manualprice !== null) { 
        data.manualprice = parseFloat(shipment.delivery.manualprice)
      }
      if (shipment.delivery && shipment.delivery.ts !== undefined && shipment.delivery.ts !== null) { 
        data.ts = shipment.delivery.ts
      }
      if (shipment.delivery && shipment.delivery.manualtime !== undefined && shipment.delivery.manualtime !== null) { 
        data.manualtime = shipment.delivery.manualtime
      }
      await axios.put(this.baseDomain + shopId + '/deliveries/' + shipment.delivery.id + '.json?client=' + this.clientid + (shopId !== this.shopId ? '&shop=' + this.shopId : ''), data)
      this.$store.dispatch('reloadBasket', shopId + '-' + this.index)
    },
    createDeliveryForShipment(shopId, shipment) {
      return new Promise(async (resolve, reject) => {
        if (!shipment.items || !shipment.items.length) {
          resolve(null)
          return
        }
        let response
        try {
          const data = {
            deliverymethod_id: shipment.deliverymethod.id
          }
          response = await axios.post(this.baseDomain + shopId + '/deliveries.json?client=' + this.clientid + (shopId !== this.shopId ? '&shop=' + this.shopId : ''), data)
        } catch (e) {
          resolve(null)
          return
        }
        const deliveryId = response.data
        for (let i = 0; i < shipment.items.length; i++) {
          const itemData = {
            id: shipment.items[i].id,
            delivery_id: deliveryId
          }
          axios.put(this.baseDomain + shopId + '/baskets/' + this.basketIds[shopId + '-' + this.index] + '/items/' + shipment.items[i].id + '.json?client=' + this.clientid + (shopId !== this.shopId ? '&shop=' + this.shopId : ''), itemData)
        }
      })
    },
    getShipmentPrice (shopId, shipment) {
      if (!shipment) {
        return 0
      }
      if (shipment.delivery && shipment.delivery.manualprice !== null && shipment.delivery.manualprice !== undefined) {
        return parseFloat(shipment.delivery.manualprice)
      }
      if (shipment.deliverymethod && shipment.deliverymethod.price) {
        if (parseFloat(shipment.deliverymethod.cutoffprice) && parseFloat(this.basketTotals[shopId]) >= parseFloat(shipment.deliverymethod.cutoffprice)) {
          return 0
        }
        return parseFloat(shipment.deliverymethod.price)
      }
      return 0
    },
    getShipmentVatFree (shopId, shipment) {
      if (!shipment || !shipment.deliverymethod || !shipment.items) {
        return 0
      }
      let price = shipment.deliverymethod.price
      if (shipment.delivery && shipment.delivery.manualprice !== null && shipment.delivery.manualprice !== undefined) {
        price = shipment.delivery.manualprice
      }
      if (parseFloat(shipment.deliverymethod.cutoffprice) && parseFloat(this.basketTotals[shopId]) >= parseFloat(shipment.deliverymethod.cutoffprice)) {
        return 0
      }
      let totals = {}
      let total = 0
      let vatFree = 0
      for (let i = 0; i < shipment.items.length; i++) {
        const item = shipment.items[i]
        if (!totals[item.vat]) {
          totals[item.vat] = 0
        }
        const amount = item.price * item.count * (item.resource_count ? item.resource_count : 1)
        totals[item.vat] += amount
        total += amount
      }
      for (let vat in totals) {
        vatFree += price * (totals[vat] / total) / ((100 + parseFloat(vat)) / 100)
      }
      return vatFree
    },
    getShipmentVat (shopId, shipment) {
      let price = shipment.deliverymethod.price
      if (shipment.delivery && shipment.delivery.manualprice !== null && shipment.delivery.manualprice !== undefined) {
        price = shipment.delivery.manualprice
      }
      if (parseFloat(shipment.deliverymethod.cutoffprice) && parseFloat(this.basketTotals[shopId]) >= parseFloat(shipment.deliverymethod.cutoffprice)) {
        return 0
      }
      return price - this.getShipmentVatFree(shopId, shipment)
    },
    enableItemModification (item) {
      this.modifiedItems.push(item.id)
    },
    disableItemModification (item) {
      this.modifiedItems = this.modifiedItems.filter(e => e !== item.id)
      this.isFreeformEditorVisible = false
    },
    // Safety net: if a cart-item instance is destroyed mid-edit (e.g. its underlying item was
    // replaced or removed by a basket recalculation) before it can emit itemModificationEnd,
    // its id would otherwise stay stuck in modifiedItems forever, permanently hiding the
    // payment/save row. Whenever the basket contents change, drop any ids that no longer
    // correspond to an item that actually exists in the basket. The 'new' freeform-item
    // placeholder id is excluded since it never appears in basketsWithItems.
    pruneModifiedItems () {
      if (!this.modifiedItems || !this.modifiedItems.length) {
        return
      }
      const existingIds = new Set()
      for (let shopId in this.basketsWithItems) {
        for (let item of this.basketsWithItems[shopId]) {
          existingIds.add(item.id)
        }
      }
      const pruned = this.modifiedItems.filter(id => id === 'new' || existingIds.has(id))
      if (pruned.length !== this.modifiedItems.length) {
        this.modifiedItems = pruned
      }
    },
    scheduleDeliveryDialog (shipment) {
      this.showDialog({
        title: this._('Schedule delivery'),
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('OK'),
            class: 'success',
            icon: 'check',
            handler: (data) => {
              let date = DateTime.fromJSDate(data.date, { zone: this.timezone })
              shipment.delivery.ts = date.toUnixInteger()
              shipment.delivery.manualtime = 1
            }
          }
        ],
        fields: [
          {
            title: this._('Delivery time'),
            type: 'datetime',
            name: 'date',
            defaultValue: shipment.delivery && shipment.delivery.ts ? DateTime.fromSeconds(Number(shipment.delivery.ts), { zone: this.timezone }).toJSDate() : null
          }
        ]
      })
    },
    customerSelectorDialog (mode) {
      if(typeof mode === 'object') { // In case we call this with v-on without using (), the first parameter is the event object
        mode = null
      }
      if (!mode) {
        mode = this.defaultCustomerType
      }
      if (!mode) {
        mode = this.isPrivateCustomer ? 'client' : 'billing'
      }
      this.showModal('customerselector', CustomerSelector, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          mode
        },
        events: {
          select: this.setCustomers
        },
        handlers: {},
        width: 1000
      })
    },
    setCustomers (data) {
      if (data.customer) {
        this.selectedCustomer = data.customer
      }
      this.backupBillingCustomer = null
      if (data.billingCustomer) {
        this.selectedBillingcustomer = data.billingCustomer
      }
    },
    async loadProductTypes () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/products.json?types=objects&apikey=' + this.apiKey)
      } catch(e) {}
      if (response) {
        this.allProductTypes = response.data
      }
    },
    productType (product) {
      if (!this.allProductTypes.length) {
        this.loadProductTypes()
      }
      let subtype = product.subtype ? product.subtype : 0
      let type = this.allProductTypes.find(type => type.type === parseInt(product.type) && type.subtype === parseInt(subtype))
      if (type) {
        return type.title
      } else {
        return ''
      }
    },
    searchProducts(text) {
      if (!text) {
        this.filteredProducts = []
        return
      }
      this.filteredProducts = this.products.filter(p => p.name && p.name.toLowerCase().includes(text.toLowerCase()))
    },
    viewportHandler: debounce((event) => {
      // Check if dropdown menu is outside of screen and adjust body transform if necessary

      let focusedInput = document.querySelector(".selectize-control.product .selectize-input.focus")
      if (!focusedInput) {
        // Keyboard was not triggered by the add product selectize input, reset and exit
        document.getElementsByTagName('body')[0].style.transform = 'none'
        return
      }

      if (Math.round(window.innerHeight) > Math.round(event.target.height)) {
        // Keyboard was opened, move document to fit dropdown to visualviewport
        let inputBounds = focusedInput.getBoundingClientRect()
        document.getElementsByTagName('body')[0].style.transform = 'translateY(' + Math.min(0, (event.target.height - (inputBounds.bottom + 180))) + 'px)'
      } else {
        // Keyboard was closed, reset and exit
        document.getElementsByTagName('body')[0].style.transform = 'none'
      }
    }, 100),
    async addProduct () {
      if (!this.products.length) {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/allproducts.json?all=true&posnames=true&apikey=' + this.apiKey)
        } catch(e) {
          return
        }
        this.products = this.filteredProducts = response.data.filter(p => parseInt(p.subtype) !== this.SUBTYPE_CONTENT)
      }
      this.isProductPickerVisible = true
    },
    async addProductItem (allProduct) {
      if (!allProduct) {
        return
      }
      this.isProductPickerVisible = false
      // We need to load the full product data
      let response
      try {
        response = await axios.get(this.baseDomain + allProduct.shopid + '/products/' + allProduct.source_id + '.json')
      } catch (e) {
        return
      }
      const product = response.data
      // We need to open a modal for a) all reservable products, b) buyable products that have variations, e.g. resource pools
      if (productNeedsModal(product)) {
        // Setting this variable will open a modal. And once it's set back to null, it'll be gone, like magic.
        this.productToAdd = product
        this.productToAddShopId = allProduct.shopid
      } else {
        let data = {
          version: this.version,
          locale: this.locale,
          product: product,
          shopId: allProduct.shopid,
          count: 1
        }
        this.$store.dispatch('addToBasket', data)
        .then(() => {
          this.showAddedToBasketNotification(this.$filters.marketingname(product))
        })
        .catch((err) => {
          this.showAddedToBasketError(err)
        })
      }
      this.selectedProduct = null
    },
    cancelAddProduct () {
      this.isProductPickerVisible = false
      this.selectedProduct = null
    },
    productModalClosed () {
      this.productToAdd = null
      this.productToAddShopId = null
    },
    addFreeform () {
      this.isFreeformEditorVisible = true
    },
    addItem (data) {
      data.locale = this.locale
      data.shopId = this.$store.state.shopId
      this.$store.dispatch('addToBasket', data)
      .then(() => {
        this.showAddedToBasketNotification(data.product_name)
      })
      .catch((err) => {
        this.showAddedToBasketError(err)
      })
    },
    showRemainingSeatLabel (itemValue) {
      return itemValue + ' x'
    },
    editCustomer () {
      this.showModal('customerdetails', CustomerDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              customerId: this.selectedCustomer.id,
              modal: true
            }
          }
        },
        events: {
          save: this.setCustomer
        },
        handlers: {},
        width: 1000
      })
    },
    setCustomer (customer) {
      this.selectedCustomer = customer
    },
    editBillingcustomer () {
      this.showModal('billingcustomerdetails', BillingCustomerDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              billingCustomerId: this.selectedBillingcustomer.id,
              modal: true
            }
          }
        },
        events: {
          save: this.setBillingcustomer
        },
        handlers: {},
        width: 1000
      })
    },
    setBillingcustomer (customer) {
      this.selectedBillingcustomer = customer
    },
    loadCustomer (id) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/customers/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          resolve(null)
          return
        }
        resolve(response.data)
      })
    },
    loadBillingCustomer (id) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/billingcustomers/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          resolve(null)
          return
        }
        resolve(response.data)
      })
    },
    confirmDialog (payment) {
      let msg = this._('Are you sure you want to create the invoice now?')
      let willActivateAutomatically = false
      switch (payment) {
        case 'adminnone':
          msg = this._('Are you sure you want to approve the order now?')
          break
        case 'confirm': // Confirmed orders will do their own thing
          msg = this._('Are you sure you want to confirm the order now?')
          break
        case 'admincash': // Cash, card, bill => these will become paid, so we will activate the services in any case
        case 'admincard':
        case 'bill':
          willActivateAutomatically = true
          break
        case 'none': // None => bill with no payment, so let's not activate by default
          break
      }
      const fields = [
        {
          title: this._('Send notifications'),
          type: 'checkbox',
          name: 'notifications',
          defaultValue: '1'
        }
      ]
      if (payment !== 'confirm') {
        if (willActivateAutomatically) {
          fields.push({
            text: this._('Activate sold services immediately'),
            type: 'info',
            name: 'activate'
          })
        } else {
          fields.push({
            title: this._('Activate sold services immediately'),
            type: 'checkbox',
            name: 'activate',
            defaultValue: '0'
          })
        }
      }
      this.showDialog({
        title: msg,
        fields: fields,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Yes'),
            class: 'success',
            icon: 'check-circle',
            handler: (data) => {
              // Ask for trip type for statistics finland
              if (this.statisticsFinlandApplies(this.isStatisticsFinlandCompatible) && !this.triptype) {
                setTimeout(() => {
                  this.askTripTypeDialog(this.save, payment, !parseInt(data.notifications), !!parseInt(data.activate))
                }, 1000)
              } else {
                // Second parameter is skipNotifications, third is activateServices
                // So we do one ! to negate the notifications value and two ! to cast the activateServices to a boolean
                this.save(payment, !parseInt(data.notifications), !!parseInt(data.activate))
              }
            }
          }
        ]
      })
    },
    loadOrder (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/orders/' + id + '.json?items=true&reservations=true&bamboraid=true&messages=true&apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.loading = false
        resolve(response.data)
      })
    },
    async save (payment, skipNotifications = false, activateServices = false) {
      // With statistics finland enabled, customer is required for products that have accommodation type
      if (this.statisticsFinlandApplies(this.isStatisticsFinlandCompatible) && (!this.selectedCustomer && !this.selectedBillingcustomer)) {
        return this.showError(this._('A product has Statistics Finland accommodation type. You must select a billing customer to proceed.'))
      }
      // Ask for trip type for statistics finland
      if (this.statisticsFinlandApplies(this.isStatisticsFinlandCompatible) && !this.triptype) {
        return this.askTripTypeDialog(this.save, payment, skipNotifications, activateServices)
      }
      // Invoicing / approving without payment while rows are selected only applies to those rows: they move to a linked folio
      const folioSplit = payment && payment !== 'confirm' ? this.getPaySelectedSnapshot() : null
      const splitItemIds = folioSplit && folioSplit.isPartial ? folioSplit.itemIds : null
      this.EventBus.$emit('savingReceipt', true)
      if (!splitItemIds) {
        this.EventBus.$emit('hideFloatingReceipt')
      }
      let order
      if (this.activeOrder) {
        order = this.activeOrder
        let response
        try {
          // Putting empty data will recalculate the totals
          // And if we have invoicing details, let's save them too
          let data = {
            id: order.id,
            basketid: this.myBasketId,
            more: order.more,
            yourreference: order.yourreference,
            mark: order.mark,
            paymentterm: order.pay_option1_duedays, // This will probably we overwritten from customer, so we have another check later
            interest: order.interest,
            permanent: 1
          }
          if (this.statisticsFinlandApplies(this.isStatisticsFinlandCompatible) && this.triptype) {
            data.triptype = this.triptype
          }
          const customerImportFields = ['address', 'city', 'company', 'country', 'email', 'evoice', 'evoiceint', 'ident', 'name', 'paymentterm', 'phone', 'zip']
          if (this.selectedCustomer && this.selectedCustomer.ext_id) {
            data.ext_customer_id = this.selectedCustomer.ext_id
          } else {
            data.customer_id = null
          }
          customerImportFields.forEach(f => {
            data[f] = this.selectedCustomer ? this.selectedCustomer[f] : null
          })
          const billingcustomerImportFields = ['address', 'allowmarketing', 'city', 'company', 'country', 'department', 'email', 'billingemail', 'evoice', 'evoiceint', 'ident', 'name', 'paymentterm', 'phone', 'zip']
          if (this.selectedBillingcustomer && this.selectedBillingcustomer.id) {
            data.billingcustomer_id = this.selectedBillingcustomer.id
          } else {
            data.billingcustomer_id = null
          }
          billingcustomerImportFields.forEach(f => {
            data['billing_' + f] = this.selectedBillingcustomer ? this.selectedBillingcustomer[f] : null
          })
          if (order.pay_option1_duedays) {
            data.paymentterm = order.pay_option1_duedays
          }
          response = await axios.put(this.baseDomain + this.shopId + '/orders/' + order.id + '.json?apikey=' + this.apiKey, data)
        } catch(e) {
          this.EventBus.$emit('savingReceipt', false)
          return this.showError(e)
        }
      } else {
        // When a previous attempt already created the order for this split, reuse it instead of posting the basket again
        if (!(splitItemIds && this.orderPosted && this.orderIds[this.shopId])) {
          try {
            await this.postOrders({ isOpen: true })
          } catch(e) {
            this.EventBus.$emit('savingReceipt', false)
            this.showError(e)
            return
          }
        }
        order = await this.loadOrder(this.orderIds[this.shopId])
        if (!order) {
          return
        }
      }
      if (payment) {
        switch (payment) {
          case 'confirm':
            await this.confirmOrder(order, skipNotifications)
            break
          case 'bill':
          case 'none':
          case 'adminnone': {
            const billed = await this.convertToBill(order, payment, skipNotifications, activateServices, splitItemIds)
            if (splitItemIds) {
              if (!billed) {
                this.EventBus.$emit('savingReceipt', false)
                return
              }
              await this.finishFolioSplit(order.identifier)
              this.showNotification(this._('Changes saved successfully!'))
              this.EventBus.$emit('savingReceipt', false)
              return
            }
            break
          }
        }
      }
      this.showNotification(this._('Changes saved successfully!'))
      this.EventBus.$emit('savingReceipt', false)
      this.EventBus.$emit('modifyOrder', {
        order: null
      })
    },
    confirmOrder (order, skipNotifications) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          const data = {
            id: order.id,
            confirm: 1,
            notifications: skipNotifications ? 0 : 1
          }
          response = await axios.put(this.baseDomain + this.shopId + (this.versionStr ? '/' + this.version : '') + '/orders/' + order.id + '.json?apikey=' + this.apiKey + this.versionStr, data)
        } catch(e) {
          this.showError(e)
        }
        resolve()
      })
    },
    convertToBill (order, payment, skipNotifications, activateServices, splitItemIds) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          const data = {
            id: order.id,
            converttobill: 1,
            payment: payment,
            notifications: skipNotifications ? 0 : 1,
            services: activateServices ? 1 : 0
          }
          if (splitItemIds && splitItemIds.length) {
            data.splititems = splitItemIds
          }
          let versionStr = this.versionStr
          if (order.version) {
            versionStr = '&version=' + order.version
          }
          response = await axios.put(this.baseDomain + this.shopId + (this.versionStr ? '/' + this.version : '') + '/orders/' + order.id + '.json?apikey=' + this.apiKey + versionStr, data)
        } catch(e) {
          this.showError(e)
          resolve(false)
          return
        }
        resolve(true)
      })
    },
    selectReceiptType (type) {
      this.receiptType = type
      this.persistReceiptType()
    },
    persistReceiptType () {
      if (!this.receiptTypeStorageKey) {
        return
      }
      try {
        localStorage.setItem(this.receiptTypeStorageKey, this.receiptType)
      } catch (e) {}
    },
    restoreReceiptType () {
      if (!this.receiptTypeStorageKey) {
        return
      }
      try {
        const stored = localStorage.getItem(this.receiptTypeStorageKey)
        if (stored === 'print' || stored === 'email' || stored === 'none') {
          this.receiptType = stored
        }
      } catch (e) {}
    },
    selectTicketType (type) {
      this.ticketType = type
      this.persistTicketType()
    },
    persistTicketType () {
      if (!this.ticketTypeStorageKey) {
        return
      }
      try {
        localStorage.setItem(this.ticketTypeStorageKey, this.ticketType)
      } catch (e) {}
    },
    storedTicketType () {
      if (!this.ticketTypeStorageKey) {
        return null
      }
      try {
        const stored = localStorage.getItem(this.ticketTypeStorageKey)
        if (stored === 'separate' || stored === 'separateemail' || stored === 'combined' || stored === 'combinedemail') {
          return stored
        }
      } catch (e) {}
      return null
    },
    restoreTicketType () {
      const stored = this.storedTicketType()
      if (stored) {
        this.ticketType = stored
      }
    },
    onCustomerSearch (search, loading) {
      loading(true)
      this.findCustomers(loading, search, this)
    },
    findCustomers: debounce((loading, search, $this) => {
      axios.get(`${$this.baseDomain}${$this.shopId}/${$this.locale}/customers.json?sSearch=${escape(search)}&apikey=${$this.apiKey}`)
      .then(response => {
        $this.customers = response.data
        loading(false)
      })
    }, 350),
    isPaymentRemovable (payment) { // eslint-disable-line
      if (payment.resolved) {
        return false
      }
      if (payment.type === 'rounding') {
        return false
      }
      return !this.approving
      // return payment.type !== 'admincard'
    },
    isPaymentRefundable (payment) { // eslint-disable-line
      if (payment.bamboraOrderNumber || payment.vivaOrderNumber) {
        return !this.approving
      }
      return false
    },
    isValuecard(payment) {
      return payment && payment.item && payment.item.valuecard_id
    },
    initCardPayment () {
      if (!!this.settings.pay_option19 && this.contract === 'viva') {
        return this.initPayment('viva')
      } else {
        return this.initPayment('admincard')
      }
    },
    async initPayment (type, data) {
      let $this = this
      this.selectedPayment = type
      this.selectedAmount = this.due
      if (type === 'admincash') {
        let rounded = this.roundToNearest5(this.selectedAmount)
        if (rounded !== '0.00') { // 0.01 and 0.02 should not be rounded down to 0
          this.selectedAmount = rounded
        }
      }
      if ((type == 'billing' || type == 'open') && data) {
        this.selectedBillingcustomer = data
      }
      if (this.isChannelTransaction || type == 'open' || this.isForcedSinglePayment) {
        await this.addPayment()
      } else {
        await nextTick()
        if ($this.$refs && $this.$refs.mobilepayphone) {
          $this.$refs.mobilepayphone.focus()
        } else if ($this.$refs && $this.$refs.amount) {
          $this.$refs.amount.focusAndSelect()
        }
      }
    },
    roundToNearest5 (amount) {
      return (Math.round(amount * 20) / 20).toFixed(2)
    },
    useACodeDialog () {
      this.showDialog({
        title: this._('Use a code'),
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            requiredFields: ['code'],
            handler: (data) => {
              let codeStr = (data.code || '').trim()
              if (!codeStr) {
                return
              }
              let splitCode = codeStr.split(',')
              if (splitCode.length === 1) {
                splitCode = codeStr.split(' ')
              }

              for (let i = 0; i < splitCode.length; i++) {
                let codeStr = splitCode[i]
                if (!codeStr.match(/^http/)) {
                  codeStr = codeStr.replace(/\-/g, '')
                }
                if (!codeStr.match(/^http/) && !codeStr.match(/\//)) {
                  codeStr = this.baseDomain + this.shopId + '/qr/V' + codeStr
                }
                this.EventBus.$emit('manualScan', { code: codeStr })
              }
            }
          }, 
        ],
        fields: [
          {
            title: this._('Code'),
            type: 'text',
            name: 'code'
          }
        ]
      })
    },
    async initOpenBilledVoucher (voucher) {
      let $this = this
      this.selectedPayment = 'billedvoucher'
      this.selectedVoucher = voucher
      this.selectedAmount = this.due
      await nextTick()
      if ($this.$refs && $this.$refs.mobilepayphone) {
        $this.$refs.mobilepayphone.focus()
      } else if ($this.$refs && $this.$refs.amount) {
        $this.$refs.amount.focusAndSelect()
      }
    },
    initVoucher (voucher, customAmount = false) {
      this.selectedVoucher = voucher
      this.selectedPayment = 'voucher'
      if (parseInt(voucher.billingcustomer_id) && parseInt(voucher.open) && !customAmount) {
        this.initOpenBilledVoucher(voucher)
      } else if (parseInt(voucher.billingcustomer_id)) { // Special case: Billing customer vouchers are added to the basket!
        this.cancelPayment()
        let data = {
          shopId: this.$store.state.shopId,
          locale: this.locale,
          voucher: voucher.id,
          count: 1,
          id: voucher.id
        }
        if (customAmount) {
          data.amount = customAmount
        }
        this.$store.dispatch('addToBasket', data)
        .then(() => {
          this.showAddedToBasketNotification(voucher.name)
        })
        .catch((err) => {
          this.showAddedToBasketError(err)
        })
      } else if (parseInt(voucher.open)) {
        this.initPayment('voucher')
      } else {
        this.addPayment()
      }
    },
    checkVouchers (voucher) {
      let $this = this
      return new Promise((resolve, reject) => {
        let basketId = this.myBasketId
        let voucherIdArr = []
        let voucherValueArr = []
        for (let i = 0; i < this.voucherPayments.length; i++) {
          voucherIdArr.push(this.voucherPayments[i].voucher)
          voucherValueArr.push(this.voucherPayments[i].voucher + ':' + this.voucherPayments[i].amount)
        }
        voucherIdArr.push(voucher.id)
        if (this.selectedAmount) {
          voucherValueArr.push(voucher.id + ':' + this.selectedAmount)
        }
        let voucherIdStr = voucherIdArr.join(',')
        let voucherValueStr = ''
        if (voucherValueArr.length) {
          voucherValueStr = '&vouchervalues=' + voucherValueArr.join(';')
        }
        axios.get(`${$this.baseDomain}${$this.shopId}/${$this.locale}/vouchers.json?action=check&basket=${basketId}&voucherids=${voucherIdStr}&apikey=${$this.apiKey}${voucherValueStr}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((e) => {
          reject(e)
        })
      })
    },
    addPayment () {
      if (this.selectedPayment === 'mobilepay' && this.manualMobilepayPhoneNumber) {
        const phone = normalizeMobilepayPhoneNumber(this.manualMobilepayPhoneNumber)
        if (!phone) {
          this.showError(this._('Check the phone number. Include the country code if the number is not Finnish.'))
          return
        }
        this.setMobilepayPhoneNumber(phone)
        this.manualMobilepayPhoneNumber = null
      }
      if (this.selectedPayment == 'billedvoucher') {
        this.initVoucher(this.selectedVoucher, this.selectedAmount)
        this.selectedAmount = 0
        this.selectedPayment = false
        return
      } else if (this.selectedPayment == 'voucher') {
        this.checkVouchers(this.selectedVoucher)
        .then((result) => {
          this.selectedAmount = result.values[this.selectedVoucher.id]
          this.doAddPayment()
        })
        .catch((e) => {
          this.showError(e)
        })
      } else {
        return this.doAddPayment()
      }
    },
    async doAddPayment () {
      if (this.addingPayment) {
        return
      }
      this.addingPayment = true
      let paymentId = null
      let payment = null
      try {
        payment = {
          type: this.selectedPayment,
          amount: this.selectedAmount
        }
        if (this.selectedPayment === 'voucher') {
          payment.voucher = this.selectedVoucher.id
        }
        const basketId = this.basketIds[this.shopId + '-' + this.index]
        let orderIdentifierStr = ''
        if (this.activeOrder) {
          orderIdentifierStr = '&orderidentifier=' + this.activeOrder.identifier
        }
        let response = await axios.post(this.baseDomain + this.shopId + '/baskets/' + basketId + '/pospayments.json?apikey=' + this.apiKey + '&client=' + this.clientid + orderIdentifierStr, payment)
        paymentId = response.data
      } catch(e) {
        console.log('error adding payment', e)
        this.showError(e)
        return
      } finally {
        await this.$store.dispatch('reloadPayments', this.shopId + '-' + this.index)
        if (this.settings.pay_option18_msn_pos && payment && payment.type === 'mobilepay') {
          this.showMobilepayIdentificationDialog(paymentId)
        }
        this.addingPayment = false
      }
      this.selectedPayment = false
      this.selectedVoucher = null
      this.selectedAmount = 0
    },
    getPaySelectedSnapshot () {
      if (!this.paySelectedMode || !this.selectedFolioItemIds.length) {
        return null
      }
      const itemIds = this.selectedFolioItemTreeIds.slice()
      if (!itemIds.length) {
        return null
      }
      return {
        itemIds,
        isPartial: this.isPaySelectedSplit,
        total: this.isPaySelectedSplit ? this.selectedFolioTotal : this.basketTotal
      }
    },
    showMobilepayIdentificationDialog (paymentId) {
      this.showModal('mobilepayidentification', MobilepayIdentification, {
        props: {
          pos: this.pos,
          index: this.index,
          shopId: this.$store.state.shopId,
          baseDomain: this.baseDomain,
          apiKey: this.apiKey
        },
        events: {
          number: async (data) => {
            try {
              await axios.patch(this.baseDomain + this.shopId + '/pospayments/' + paymentId + '.json?apikey=' + this.apiKey + '&client=' + this.clientid, {
                id: paymentId,
                mobilepayNumber: data
              })
            } catch(e) {
              this.showError(e)
            } finally {
              this.$store.dispatch('reloadPayments', this.shopId + '-' + this.index)
            }
          },
          token: async (data) => {
            try {
              await axios.patch(this.baseDomain + this.shopId + '/pospayments/' + paymentId + '.json?apikey=' + this.apiKey + '&client=' + this.clientid, {
                id: paymentId,
                mobilepayToken: data
              })
            } catch(e) {
              this.showError(e)
            } finally {
              this.$store.dispatch('reloadPayments', this.shopId + '-' + this.index)
            }
          },
          close: () => {}
        }
      })      
    },
    /*
    applyRoundingDiff (payment) {
      if (payment && payment.type === 'rounding') {
        return
      }
      let hasCashPayments = false
      for (let i = 0; i < this.payments.length; i++) {
        if (this.payments[i].type === 'rounding') {
          this.removePayment(this.payments[i], true)
          // We remove these immediately so totalPayments gets updated (if this causes problems, create a totalPaymentsWithoutRoundings method instead)
          this.payments.splice(i, 1)
        } else if (this.payments[i].type === 'admincash') {
          hasCashPayments = true
        }
      }
      // diff = the difference between the basket total and current payments
      // diff5 = that difference rounded to the nearest 5 cents
      // roundingDiff = the difference of diff and diff5 is then added as the rounding difference in payments
      // as long as diff is less than 0.03 (including negative amounts - so if the customer pays with a large bill)
      const diff = Math.round((this.basketTotal - this.totalPayments) * 10000) / 10000 // We need to use higher precision in case we get something like 1,005
      const diff5 = this.roundToNearest5(diff)
      const roundingDiff = Math.round((diff - diff5) * 100) / 100
      if (hasCashPayments && roundingDiff && diff < 0.03) {
        let rounding = {
          id: this.pos + '/' + this.index + '/' + new Date().getTime(),
          type: 'rounding',
          amount: roundingDiff
        }
        // Note: We call the handler directly, otherwise two or more receipts in the same view would create an extra rounding payment
        this.handleAddPayment({
          type: 'addPayment',
          data: rounding,
          shopId: this.$store.state.shopId,
          pos: this.pos,
          index: this.index
        })
      }
    },
    */
    cancelPayment () {
      this.selectedPayment = false
      this.selectedVoucher = null
      this.selectedAmount = 0
    },
    async removePayment (payment) {
      try {
        let orderIdentifierStr = ''
        if (this.activeOrder) {
          orderIdentifierStr = '&orderidentifier=' + this.activeOrder.identifier
        }
        await axios.delete(this.baseDomain + this.shopId + '/pospayments/' + payment.id + '.json?apikey=' + this.apiKey + '&client=' + this.clientid + orderIdentifierStr)
        this.$store.dispatch('invalidatePayments', this.shopId + '-' + this.index)
      } catch(e) {
        console.log('error removing payment', e)
        return
      } finally {
        await this.$store.dispatch('reloadPayments', this.shopId + '-' + this.index)
        this.addingPayment = false
      }
      if (payment.type === 'mobilepay') {
        this.setMobilepayPhoneNumber(null)
      }
    },
    /**
     * Remove an orphan basket pospayment without calling external refund APIs.
     * Used when the terminal ID already belongs to a bill payment.
     */
    async dismissPayment (payment) {
      return this.removePayment(payment)
    },
    paymentBelongsToBill (payment) {
      return !!(payment && (parseInt(payment.belongsToBill, 10) || payment.belongsToBill === true))
    },
    isPaymentRefunding (payment) {
      return this.refundingPaymentIds.includes(payment.id)
    },
    async refundPayment (payment) {
      if (!payment.bamboraOrderNumber && !payment.vivaOrderNumber) {
        return
      }
      // A second click while the refund is running would refund the same charge twice
      if (this.isPaymentRefunding(payment)) {
        return
      }
      this.refundingPaymentIds.push(payment.id)
      try {
        await this.refundPaymentOnce(payment)
      } finally {
        this.refundingPaymentIds = this.refundingPaymentIds.filter(id => id !== payment.id)
      }
    },
    async refundPaymentOnce (payment) {
      // Already on a bill: never refund externally — only drop the orphan pospayment from the App
      if (this.paymentBelongsToBill(payment)) {
        await this.dismissPayment(payment)
        return
      }
      if (!await this.confirmPaymentRefund(payment)) {
        return
      }
      const refundData = {}
      if (payment.bamboraOrderNumber) {
        refundData.bamboraOrderNumber = payment.bamboraOrderNumber
      } else if (payment.vivaOrderNumber) {
        refundData.vivaOrderNumber = payment.vivaOrderNumber
      }
      try {
        await axios.post(this.baseDomain + this.shopId + '/refunds/new.json?apikey=' + this.apiKey, refundData)
        await this.removePayment(payment)
      } catch(e) {
        // Backend may refuse with PAYMENT_BELONGS_TO_BILL, or with PAYMENT_NOT_ON_RECEIPT when the payment was already
        // removed from the receipt (the list on screen is out of date): still dismiss the orphan, no extra error noise
        const errorCode = e && e.response && e.response.data && e.response.data.errorCode
        if (errorCode === 'PAYMENT_BELONGS_TO_BILL' || errorCode === 'PAYMENT_NOT_ON_RECEIPT') {
          await this.dismissPayment(payment)
          return
        }
        // Keep the row by default: the charge still exists, so the cashier can retry or finish the sale with it
        this.showDialog({
          title: this._('Refund failed!'),
          text: this._('The payment was not refunded. You can try again later, or remove the payment from the receipt if it has already been refunded some other way.'),
          variant: 'danger',
          width: 800,
          buttons: [
            {
              title: this._('Keep the payment'),
              icon: 'ban',
              handler: () => {}
            },
            {
              title: this._('Remove from receipt'),
              class: 'danger',
              icon: 'trash',
              handler: () => this.dismissPayment(payment)
            }
          ],
          clickToClose: false
        })
      }
    },
    /**
     * A charged payment that is not on any bill: refunding returns real money to the customer,
     * so make the cashier confirm it and point out the alternative of finishing the sale.
     */
    confirmPaymentRefund (payment) {
      return new Promise((resolve) => {
        this.showDialog({
          title: this._('Refund the payment to the customer?'),
          text: this._('This payment of %s has been charged, but it is not part of any completed sale. If the customer is still buying, add the products and approve the sale instead. A refund returns the money to the customer and cannot be undone.').replace('%s', this.$filters.currency(payment.amount, this.basketCurrency)),
          variant: 'danger',
          width: 800,
          buttons: [
            {
              title: this._('Cancel'),
              icon: 'ban',
              handler: () => resolve(false)
            },
            {
              title: this._('Refund'),
              class: 'danger',
              icon: 'undo',
              handler: () => resolve(true)
            }
          ],
          clickToClose: false
        })
      })
    },
    /**
     * Leftover payments that already belong to a bill were paid for a sale that is finished.
     * Dismiss them so they can neither be refunded nor count towards the next sale.
     */
    async cleanupBillOwnedOrphanPayments () {
      if (!this.payments || !this.payments.length) {
        return
      }
      const orphans = this.payments.filter(p => this.paymentBelongsToBill(p))
      if (!orphans.length) {
        return
      }
      // Avoid re-entrancy: removePayment → reloadPayments → cleanup again
      this._skipBillOwnedCleanup = true
      try {
        for (const payment of orphans) {
          await this.dismissPayment(payment)
        }
      } finally {
        this._skipBillOwnedCleanup = false
      }
    },
    async reloadPayments (basketShopIdWithIndex) {
      if (this.floatingReceipt && !this.primary) {
        return
      }
      await this.$store.dispatch('reloadPayments', basketShopIdWithIndex)
      if (!this._skipBillOwnedCleanup) {
        await this.cleanupBillOwnedOrphanPayments()
      }
    },
    async removeVirtualPayment (payment) {
      let item = payment.item
      let shopId = this.shopId
      await this.$store.dispatch('deleteItemFromBasket', {
        id: item.id,
        item: item,
        shopId: shopId,
        index: this.index
      })
      // This probably does nothing
      this.$emit('deleteItemFromBasket', { item: item, shopId: shopId })
    },
    addValueCard () {
      let data = {
        shopId: this.$store.state.shopId,
        locale: this.locale,
        valuecard: this.scannedValuecard.code,
        count: this.selectedValuecardCount,
        id: this.scannedValuecard.id
      }
      if (!parseInt(this.scannedValuecard.singleuse) && this.selectedValuecardAmount) {
        data.amount = this.selectedValuecardAmount
      }
      let cardName = this.scannedValuecard.name
      this.$store.dispatch('addToBasket', data)
      .then(() => {
        this.showAddedToBasketNotification(cardName)
        this.$modal.hide('valuecardModal')
      })
      .catch((err) => {
        this.showAddedToBasketError(err)
      })
    },
    async approveWithPaymentLink () {
      return this.approve({ sendPaymentLink: true })
    },
    async approveWithConfirmationLink () {
      return this.approve({ sendConfirmationLink: true })
    },
    async approve (opts) {
      const folioSplit = (opts && opts.folioSplit) || this.pendingFolioSplit || this.getPaySelectedSnapshot()
      const isPartialFolio = !!(folioSplit && folioSplit.isPartial)
      // When paying selected items, only the selected rows end up on the folio that gets reported
      const isStatisticsFinlandCompatible = isPartialFolio ? this.hasStatisticsFinlandItems(folioSplit.itemIds) : this.isStatisticsFinlandCompatible
      // With statistics finland enabled, customer is required for products that have accommodation type
      if (this.statisticsFinlandApplies(isStatisticsFinlandCompatible) && (!this.selectedCustomer && !this.selectedBillingcustomer)) {
        return this.showError(this._('A product has Statistics Finland accommodation type. You must select a billing customer to proceed.'))
      }
      // Ask for trip type for statistics finland
      if (this.statisticsFinlandApplies(isStatisticsFinlandCompatible) && !this.triptype) {
        return this.askTripTypeDialog(this.approve, opts)
      }
      this.pendingFolioSplit = folioSplit
      this.approving = true
      this.orderPosted = false
      this.EventBus.$emit('lock')
      this.terminalData = {}
      this.$socket.emit('message', {
        type: 'approve',
        data: {},
        shopId: this.$store.state.shopId,
        pos: this.pos,
        index: this.index
      })
      // New: Only use the old process when we have exactly one card payment
      this.bamboraOrderNumber = false
      this.vivaOrderNumber = false
      let vivaChargeSucceeded = false
      if (this.unresolvedVivaPayments.length == 1) {
        try {
          await this.processVivaPayments()
          vivaChargeSucceeded = true // The terminal has charged the customer - from here on we must never silently drop state
        } catch(e) {
          console.log('payment failed', e)
          this.showError(e)
          return this.cancelApprove()
        }
      } else if (this.unresolvedMobilepayPayments.length == 1) {
        try {
          await this.processMobilepayPayments()
        } catch(e) {
          console.log('payment failed', e)
          this.showError(e)
          return this.cancelApprove()
        }
      } else if (this.unresolvedBamboraPayments.length == 1) {
        try {
          await this.processBamboraPayments()
        } catch(e) {
          console.log('payment failed', e)
          if (e && e.code && e.code == '1') {
            this.showError(e) // A failed payment is always an error
          } else {
            this.showError(e)
          }
          return this.cancelApprove()
        }
      }
      let returnable = this.returnable
      // A resolved Viva payment means the terminal charge already succeeded (now or on an earlier
      // attempt that got interrupted) - money has moved and can't be undone, so from here on this
      // approve() call must not be allowed to silently hang or lose track of that payment/basket.
      // The timeouts and retries only apply to Viva; other providers keep waiting for the requests.
      const isRecoveryScope = vivaChargeSucceeded || this.hasResolvedVivaPayment
      if (!this.orderPosted) { // ERP process must post orders before processing payments, so this should not be done again
        try {
          const postOpts = isPartialFolio ? Object.assign({}, opts || {}, { isOpen: true }) : opts
          if (postOpts && postOpts.folioSplit) {
            delete postOpts.folioSplit
          }
          if (isRecoveryScope) {
            await this.withTimeout(this.postOrders(postOpts), 15000, { errorMessage: this._('Posting the order timed out.') })
          } else {
            await this.postOrders(postOpts)
          }
        } catch (e) {
          console.log('posting orders failed', e)
          if (isRecoveryScope) {
            this.captureVivaRecoveryIssue('postOrders-failed', e)
            this.showError(this._('The payment terminal charge succeeded, but posting the order failed. Please try Approve again - the payment will not be charged twice.'))
          } else if (isPartialFolio) {
            this.showError(e || this._('The order could not be created.'))
          } else {
            this.showError(this._('The sale could not be finalized. Please try again.'))
          }
          return this.cancelApprove(isRecoveryScope)
        }
      }
      let folioSplitDone = false
      try {
        if (isRecoveryScope) {
          // finalizeOrders() operates on already-known orderIds and the backend never bills an order
          // twice, so retrying it after a transient network blip is safe. A retry first checks whether
          // the previous attempt went through even though its response was lost.
          let attempt = 0
          let refused = null
          await this.retryWithBackoff(async () => {
            if (attempt++ > 0 && await this.ordersAreBilled()) {
              return
            }
            try {
              await this.withTimeout(this.finalizeOrders(returnable), 15000, { errorMessage: this._('Finalizing the order timed out.') })
            } catch (e) {
              // A refusal won't change on a retry
              if (this.isBilledPaymentRefusal(e)) {
                refused = e
                return
              }
              throw e
            }
          }, 3, [1500, 3000])
          if (refused) {
            throw refused
          }
        } else if (isPartialFolio) {
          await this.finalizeFolioSplit(returnable, folioSplit.itemIds)
          folioSplitDone = true
        } else {
          await this.finalizeOrders(returnable)
        }
      } catch(e) {
        console.log('finalize failed', e)
        if (this.isBilledPaymentRefusal(e)) {
          // A card payment on the receipt was already billed in an earlier sale (an out-of-date payment list).
          // Show why, and reload the payments: the fresh list no longer has the earlier sale's payment.
          this.showError(e)
          await this.reloadPayments(this.shopId + '-' + this.index)
          if (isPartialFolio) {
            this.approving = false
            this.EventBus.$emit('unlock')
            return
          }
          return this.cancelApprove(isRecoveryScope)
        }
        if (isPartialFolio) {
          this.showError(e)
          this.approving = false
          this.EventBus.$emit('unlock')
          return
        }
        // The sale may have been billed even though the response never arrived. Cancelling it would
        // put the billed products back on the receipt, so finish the sale normally instead.
        if (!await this.ordersAreBilled()) {
          if (isRecoveryScope) {
            this.captureVivaRecoveryIssue('finalizeOrders-failed', e)
            this.showError(this._('The payment terminal charge succeeded, but the sale could not be finalized. Please try Approve again - the payment will not be charged twice.'))
          } else {
            this.showError(this._('The sale could not be finalized. Please try again.'))
          }
          return this.cancelApprove(isRecoveryScope)
        }
        this.captureVivaRecoveryIssue('finalizeOrders-billed-after-error', e)
      }
      await this.clearPayments()
      this.receiptEmail = ''
      if (this.ticketType === 'combinedemail') {
        this.selectTicketType('combined')
      }
      if (this.ticketType === 'separateemail') {
        this.selectTicketType('separate')
      }
      this.pendingFolioSplit = null
      if (!folioSplitDone) {
        this.clearCustomer()
        this.resetTmpOrder()
        if (this.activeOrder) {
          this.EventBus.$emit('modifyOrder', {
            order: null
          })
        }
      }
      this.modifiedItems = []
      this.EventBus.$emit('unlock')
    },
    /**
     * The backend refused to bill the sale because one of its card payments already belongs to another bill
     */
    isBilledPaymentRefusal (e) {
      return !!(e && e.response && e.response.data && e.response.data.errorCode === 'PAYMENT_BELONGS_TO_BILL')
    },
    async cancelApprove (isRecoveryScope) {
      if (this.orderPosted && this.orderIds[this.shopId]) {
        // Posting the order moved the products off the basket; deleting the order puts them back.
        // Without that the receipt would be left empty with only the payments on it, so if the
        // connection is down, keep retrying in the background until the products are back.
        const order = {
          orderId: this.orderIds[this.shopId],
          basketId: this.basketIds[this.shopId + '-' + this.index]
        }
        if (!await this.restoreOrderToBasket(order, isRecoveryScope)) {
          this.setUnrestoredOrder(order)
          this.showError(this._('The products could not be returned to the receipt. They will come back automatically once the connection works again.'))
          this.scheduleOrderRestore()
        }
      }
      this.$socket.emit('message', {
        type: 'cancelapprove',
        data: {},
        shopId: this.$store.state.shopId,
        pos: this.pos,
        index: this.index
      })
      // Never clear payments/products here - a resolved terminal payment must stay so a retried
      // Approve can't accidentally charge the terminal a second time. Just unlock the receipt
      // (without waiting for the socket echo, which doesn't arrive while the connection is down).
      this.approving = false
      this.EventBus.$emit('unlock')
    },
    /**
     * Delete a cancelled sale's order so that its products return to the basket. Returns false only
     * when it could not reach the backend, so that the caller can try again later.
     */
    async restoreOrderToBasket (order, isRecoveryScope) {
      try {
        await this.retryWithBackoff(() => axios.delete(this.baseDomain + this.shopId + '/orders/' + order.orderId + '.json?basket=' + order.basketId + '&apikey=' + this.apiKey), 3, [1000, 3000])
        return true
      } catch (e) {
        console.log('error deleting order after cancelled approve', e)
        if (isRecoveryScope) {
          this.captureVivaRecoveryIssue('cancelApprove-deleteOrder-failed', e)
        }
        const status = e && e.response ? e.response.status : 0
        const errorCode = e && e.response && e.response.data && e.response.data.errorCode
        if (errorCode === 'ORDER_ALREADY_BILLED') {
          // The sale went through after all, so the payments on the receipt belong to its bill
          await this.clearPayments()
          return true
        }
        // Network errors and server errors are worth retrying, anything else won't get better
        return !!status && status < 500
      }
    },
    unrestoredOrderStorageKey () {
      if (!this.shopId || !this.pos || !this.index) {
        return null
      }
      return 'johku-pos-unrestored-order-' + this.shopId + '-' + this.pos + '-' + this.index
    },
    setUnrestoredOrder (order) {
      this.unrestoredOrder = order
      const key = this.unrestoredOrderStorageKey()
      if (!key) {
        return
      }
      try {
        if (order) {
          localStorage.setItem(key, JSON.stringify(order))
        } else {
          localStorage.removeItem(key)
        }
      } catch (e) {}
    },
    /**
     * Pick up a cancelled sale whose products could not be returned before the POS was reloaded
     */
    resumeOrderRestore () {
      if (this.floatingReceipt && !this.primary) {
        return
      }
      const key = this.unrestoredOrderStorageKey()
      if (!key) {
        return
      }
      try {
        const stored = JSON.parse(localStorage.getItem(key))
        if (stored && stored.orderId && stored.basketId) {
          this.unrestoredOrder = stored
          this.scheduleOrderRestore(0)
        }
      } catch (e) {}
    },
    scheduleOrderRestore (delay) {
      clearTimeout(this.orderRestoreTimer)
      this.orderRestoreTimer = setTimeout(async () => {
        const order = this.unrestoredOrder
        if (!order || this.restoringOrder) {
          return
        }
        this.restoringOrder = true
        try {
          if (await this.restoreOrderToBasket(order)) {
            this.setUnrestoredOrder(null)
            await this.$store.dispatch('reloadBasket', this.shopId + '-' + this.index)
            this.showNotification(this._('The products were returned to the receipt.'))
          } else {
            this.scheduleOrderRestore()
          }
        } finally {
          this.restoringOrder = false
        }
      }, delay === undefined ? 10000 : delay)
    },
    // Manual, opt-in safety net for a receipt stuck locked after a Viva terminal charge succeeded.
    // Deliberately does nothing except release the lock: no products or payments are ever removed,
    // so the existing unresolvedVivaPayments check still protects against charging twice.
    unlockStuckVivaReceipt () {
      if (!this.hasResolvedVivaPayment) {
        return
      }
      this.captureVivaRecoveryIssue('manual-unlock-used', { errorMessage: 'Cashier manually unlocked a stuck Viva receipt' })
      this.approving = false
      this.EventBus.$emit('unlock')
    },
    /**
     * Store a completed terminal charge on its basket payment. Retried, because a lost update would
     * make the payment look unpaid after a reload. If it still fails, paymentForBill() carries the
     * charge to the bill from what this receipt recorded during the charge.
     */
    async markPaymentResolved (payment, data) {
      try {
        await this.retryWithBackoff(() => axios.patch(`${this.baseDomain}${this.shopId}/${this.locale}/pospayments/${payment.id}.json?apikey=${this.apiKey}&client=${this.clientid}`, Object.assign({
          id: payment.id,
          resolved: true
        }, data)), 3, [1000, 2000])
      } catch(e) {
        console.log('error updating payment', e)
        this.captureVivaRecoveryIssue('markPaymentResolved-failed', e)
      }
    },
    /**
     * A basket payment as it is sent to the bill. The terminal charge identifiers must end up on the
     * bill payment: that is what links the bill to the charge, so a leftover payment row can't be
     * refunded once the sale has been billed. Fill them in from this receipt's own record of the
     * charge in case the payments in the store are out of date. Terminal data is deliberately not
     * filled in: on the bill it prints the terminal's receipt on the POS receipt.
     */
    paymentForBill (payment) {
      const p = { ...payment }
      if (!p.bamboraOrderNumber && this.bamboraOrderNumbers[p.id]) {
        p.bamboraOrderNumber = this.bamboraOrderNumbers[p.id]
      }
      if (!p.vivaOrderNumber && this.vivaOrderNumbers[p.id]) {
        p.vivaOrderNumber = this.vivaOrderNumbers[p.id]
      }
      if (!p.mobilepayReference && this.mobilepayReferences[p.id]) {
        p.mobilepayReference = this.mobilepayReferences[p.id]
      }
      if (p.terminalData) {
        p.terminalData = typeof p.terminalData === 'string'
          ? JSON.parse(p.terminalData)
          : p.terminalData
      }
      return p
    },
    /**
     * Whether every order of the current sale has been billed. Used after a failed finalize, because
     * the request may have succeeded even though its response was lost.
     */
    async ordersAreBilled () {
      const shopIds = Object.keys(this.orderIds || {})
      if (!shopIds.length) {
        return false
      }
      // ORDER_BILLED_AND_NOT_CONFIRMED, ORDER_BILLED_AND_CONFIRMED, and ORDER_CONFIRMED when finalizing only confirms the orders
      const doneStates = this.isBilling ? [1, 2, 4] : [2, 4]
      try {
        const responses = await Promise.all(shopIds.map(shopId => axios.get(`${this.baseDomain}${shopId}/${this.version}/orders/${this.orderIds[shopId]}.json`)))
        return responses.every(response => response.data && doneStates.includes(parseInt(response.data.confirmed, 10)))
      } catch(e) {
        return false
      }
    },
    async processVivaPayments () {
      let $this = this
      let result = false
      let payment = this.vivaPayments[0]
      await new Promise((resolve, reject) => {
        result = $this.processVivaCard(resolve, reject, payment)
      })
      await this.markPaymentResolved(payment, {
        terminalData: $this.terminalData[payment.id],
        vivaOrderNumber: $this.vivaOrderNumbers[payment.id]
      })
      return result
    },
    async processMobilepayPayments () {
      let $this = this
      let result = false
      let payment = this.mobilepayPayments[0]
      await new Promise((resolve, reject) => {
        result = $this.processMobilepay(resolve, reject, payment)
      })
      await this.markPaymentResolved(payment, {
        mobilepayReference: $this.mobilepayReferences[payment.id]
      })
      return result
    },
    async processBamboraPayments () {
      let $this = this
      let result = false
      let payment = this.bamboraPayments[0]
      await new Promise((resolve, reject) => {
        if ($this.mobilePaymentAmount > 0) {
          result = $this.processMobilePayment(resolve, reject, payment)
        } else if ($this.cardAmount == 0 || !$this.paymentTerminalId || $this.paymentTerminalId == 'external') {
          resolve()
          return
        } else {
          result = $this.processBamboraCard(resolve, reject, payment)
        }
      })
      await this.markPaymentResolved(payment, {
        terminalData: $this.terminalData[payment.id],
        bamboraOrderNumber: $this.bamboraOrderNumbers[payment.id]
      })
      return result
    },
    async resolveSingleCardPayment (payment) {
      let $this = this
      try {
        let result = false
        await new Promise((resolve, reject) => {
          if (payment.type === 'viva') {
            result = $this.processVivaCard(resolve, reject, payment)
          } else if (payment.type === 'mobilepay') {
            result = $this.processMobilepay(resolve, reject, payment)
          } else if (payment.type === 'admincard') {
            result = $this.processBamboraCard(resolve, reject, payment)
          } else if (payment.type === 'mobilepay' || payment.type === 'pivo' || payment.type === 'siirto') {
            result = $this.processMobilePayment(resolve, reject, payment)
          } else if (payment.type === 'masterpass' || payment.type === 'virtualcard') {
            result = $this.processMasterPass(resolve, reject, payment)
          }
        })
        const data = {
          terminalData: $this.terminalData[payment.id],
        }
        if (payment.type === 'viva') {
          data.vivaOrderNumber = $this.vivaOrderNumbers[payment.id]
        } else if (payment.type === 'admincard') {
          data.bamboraOrderNumber = $this.bamboraOrderNumbers[payment.id]
        } else if (payment.type === 'mobilepay') {
          data.mobilepayReference = $this.mobilepayReferences[payment.id]
        }
        await this.markPaymentResolved(payment, data)
        return result
      } catch(e) {
        this.showError(e)
      }
    },
    getPaymentError (code) {
      // The return URL gives the code as a string, but compare the same way whatever the type
      switch (String(code)) {
        case '1':
          return this._('The payment was cancelled.')
        case '4':
          return this._('Transaction status could not be updated.')
        case '10':
          return this._('Bambora has a maintenance break.')
        default:
          return this._('There was an unknown error.')
      }
    },
    getChannelTransactionAmountStr () {
      let totals = this.basketTotals
      let deliveryTotals = this.deliveryTotals
      let amountArr = []
      for (var basketShopId in totals) {
        if (Object.prototype.hasOwnProperty.call(totals, basketShopId)) {
          if (parseFloat(totals[basketShopId])) {
            let productAmount = new Decimal(totals[basketShopId])
            let deliveryAmount = new Decimal(deliveryTotals[basketShopId])
            let currAmount = productAmount.add(deliveryAmount)
            amountArr.push(basketShopId + ':' + currAmount.toNumber())
          }
        }
      }
      return amountArr.join(';')
    },
    formatMobilepayPhoneNumber (phone) {
      if (!phone) {
        return ''
      }
      if (!phone.match(/^\+/)) {
        phone = '+' + phone
      }
      return phone
    },
    getMobilepayPhoneNumber () {
      return this.mobilepayPhoneNumber
    },
    async processMobilepay (resolve, reject, payment) {
      let shopId = this.$store.state.shopId
      let amountStr = this.cardAmount
      if (payment) {
        amountStr = parseFloat(payment.amount)
      }
      let phone = null
      let customerToken = null
      if (payment.mobilepayToken) {
        customerToken = payment.mobilepayToken
      } else if (payment.mobilepayNumber) {
        phone = payment.mobilepayNumber
        if (!phone) {
          reject({ errorMessage: this._('Please enter a phone number for the payment or scan the MobilePay QR code.') })
          return
        }
      }
      let response
      try {
        let request = {
          plugin: 'app',
          method: 'Create',
          userFlow: 'PUSH_MESSAGE',
          amount: amountStr,
          paymentId: payment.id
        }
        if (phone) {
          request.phone = phone
        } else if (customerToken) {
          request.customerToken = customerToken
        }
        response = await axios.post(`${this.baseDomain}${shopId}/${this.locale}/mobilepayhandler.json?apikey=${this.apiKey}`, request)
      } catch(e) {
        reject({ errorMessage: this._('There was an error initializing the payment.') })
        return
      }
      const reference = response.data.reference
      this.$socket.emit('message', 
        {
          type: 'mobilepayInit',
          shopId: shopId,
          reference: reference
        }
      )
      this.showModal('paymentterminal', MobilepayPaymentTerminal, {
        props: {
          shopId: shopId,
          reference: reference,
          amount: Math.round(amountStr * 100),
          pollUrl: `${this.baseDomain}${shopId}/${this.locale}/mobilepayhandler.json?apikey=${this.apiKey}&plugin=app`
        },
        events: {
          success: async () => {
            let response
            try {
              response = await this.captureMobilepayPayment(reference)
            } catch(e) {
              console.log('error capturing mobilepay payment', e)
              reject(response)
              return
            }
            this.mobilepayReferences[payment.id] = reference
            resolve(true)
          },
          close: (response) => {
            this.abortMobilepaySession(reference)
            reject(response)
          },
          abort: (response) => {
            this.abortMobilepaySession(reference)
            reject(response)
          }
        },
        clickToClose: false
      })      
    },
    async captureMobilepayPayment (reference) {
      let response
      try {
        response = await axios.post(`${this.baseDomain}${this.$store.state.shopId}/${this.locale}/mobilepayhandler.json?apikey=${this.apiKey}`, {
          plugin: 'app',
          method: 'Capture',
          reference: reference
        })
      } catch(e) {
        throw e
      }
      return response.data
    },
    async abortMobilepaySession (reference) {
      let response
      try {
        const data = {
          plugin: 'app',
          method: 'Cancel',
          reference: reference
        }
        response = await axios.post(`${this.baseDomain}${this.$store.state.shopId}/${this.locale}/mobilepayhandler.json?apikey=${this.apiKey}`, data)
        console.log('abortMobilepaySession success', response.data)
      } catch(e) {
        console.log('abortMobilepaySession exception', e)
      }
    },
    async processVivaCard (resolve, reject, payment) {
      let shopId = this.$store.state.shopId
      let amountStr = this.cardAmount
      if (payment) {
        amountStr = parseFloat(payment.amount)
      }
      let response
      try {
        response = await axios.post(`${this.baseDomain}${shopId}/${this.locale}/vivahandler.json?apikey=${this.apiKey}`, 
          {
            method: 'createSalesRequest',
            terminal: this.paymentTerminalId, 
            pos: this.pos,
            domain: this.hostName,
            amount: amountStr
          }
        )
      } catch(e) {
        reject({ errorMessage: this._('There was an error initializing the payment.') })
        return
      }
      let sessionId = response.data
      let sessionResolved = false
      this.$socket.emit('message', 
        {
          type: 'vivaInit',
          shopId: shopId,
          terminal: this.paymentTerminalId,
          session: sessionId
        }
      )
      this.showModal('paymentterminal', VivaPaymentTerminal, {
        props: {
          method: 'getSessionDetails',
          shopId: shopId,
          terminal: this.paymentTerminalId,
          session: sessionId,
          amount: Math.round(amountStr * 100),
          pollUrl: `${this.baseDomain}${shopId}/${this.locale}/vivahandler.json?apikey=${this.apiKey}`,
          callbackUrl: `${this.baseDomain}api/viva/autoclose/`
        },
        events: {
          success: async (response) => {
            sessionResolved = true
            this.vivaOrderNumber = response.orderCode
            if (payment) {
              this.terminalData[payment.id] = response
              this.vivaOrderNumbers[payment.id] = response.orderCode
            }
            this.addVivaBreadcrumb('viva-terminal-charge-succeeded', { sessionId: sessionId, orderCode: response.orderCode, paymentId: payment ? payment.id : null })
            resolve()
          },
          close: (response) => {
            if (sessionResolved) {
              return
            }
            this.abortVivaSession(sessionId)
            reject(response)
          },
          abort: (response) => {
            if (sessionResolved) {
              return
            }
            this.abortVivaSession(sessionId)
            reject(response)
          }
        },
        clickToClose: false
      })
    },
    async abortVivaSession (sessionId) {
      let response
      try {
        const data = {
          method: 'abortSession',
          sessionId: sessionId,
          pos: this.pos
        }
        response = await axios.post(`${this.baseDomain}${this.$store.state.shopId}/${this.locale}/vivahandler.json?apikey=${this.apiKey}`, data)
        console.log('abortVivaSession success', response)
      } catch(e) {
        console.log('abortVivaSession exception', e)
      }
    },
    async processBamboraCard (resolve, reject, payment) {
      let $this = this
      let shopId = this.$store.state.shopId
      let amountStr = shopId + ':' + $this.cardAmount
      if (payment) {
        amountStr = shopId + ':' + parseFloat(payment.amount)
      }
      if (this.isChannelTransaction) {
        amountStr = this.getChannelTransactionAmountStr()
      }
      if (this.paymentterminal !== this.paymentTerminalId) {
        let response
        try {
          response = await axios.post(`${$this.baseDomain}${shopId}/${$this.locale}/bamborahandler/custom.json?action=terminal&apikey=${$this.apiKey}`, 
            {
              terminal: $this.paymentTerminalId, 
              domain: $this.hostName,
              amounts: amountStr
            }
          )
        } catch(e) {
          if (e && e.response && e.response.data && e.response.data.errorCode === 'TERMINAL_IN_USE') {
            clearTimeout($this.terminalUseTimeout)
            $this.terminalUseCounter++
            if ($this.terminalUseCounter > 2) {
              $this.showTerminalInUseDialog('cacca 2')
              $this.terminalUseCounter = 0
            } else {
              $this.terminalUseTimeout = setTimeout(() => {
                $this.terminalUseCounter = 0
              }, 5000)
            }
            reject(e)
            return
          }
          reject({ errorMessage: $this._('There was an error initializing the payment.') })
          return
        }
        let terminalSession = Date.now()
        this.$socket.emit('message', {
          type: 'bamboraInit',
          url: response.data.items.payment_url,
          shopId: shopId,
          terminal: this.paymentTerminalId,
          session: terminalSession
        })
        this.showModal('paymentterminal', PaymentTerminal, {
          props: {
            shopId: shopId,
            terminal: this.paymentTerminalId,
            session: terminalSession
          },
          events: {
            done: async () => {
              let checkResponse
              let retries = 4
              const makeRequest = async () => {
                try {
                  checkResponse = await axios.post(`${$this.baseDomain}${shopId}/${$this.locale}/bamborahandler/custom.json?action=check&apikey=${$this.apiKey}`,
                    {
                      terminal: $this.paymentTerminalId,
                      order_number: response.data.items.ORDER_NUMBER
                    }
                  )
                  $this.showNotification($this._('The payment was successfully processed.'))
                  $this.bamboraOrderNumber = response.data.items.ORDER_NUMBER
                  if (payment) {
                    $this.terminalData[payment.id] = checkResponse.data
                    $this.bamboraOrderNumbers[payment.id] = response.data.items.ORDER_NUMBER
                    $this.handlePaymentBrandNotification(checkResponse.data)
                  }
                  resolve()
                } catch(e) {
                  if (retries > 0) {
                    // Exponential backoff
                    setTimeout(makeRequest, Math.pow(2, 4 - retries) * 1000)
                    retries--
                  } else {
                    reject({ errorMessage: $this._('Unable to confirm that the payment was successful.') })
                  }
                }
              }
              makeRequest()
            }
          },
          handlers: {},
          width: 1000,
          clickToClose: false
        })
      } else {
        let response
        try {
          response = await axios.post(`${$this.baseDomain}${shopId}/${$this.locale}/bamborahandler/custom.json?action=terminal&apikey=${$this.apiKey}&client=${this.clientid}`, 
            {
              terminal: $this.paymentTerminalId, 
              domain: $this.hostName,
              amounts: amountStr
            }
          )
        } catch(e) {
          if (e && e.response && e.response.data && e.response.data.errorCode === 'TERMINAL_IN_USE') {
            clearTimeout($this.terminalUseTimeout)
            $this.terminalUseCounter++
            if ($this.terminalUseCounter > 2) {
              $this.showTerminalInUseDialog()
              $this.terminalUseCounter = 0
            } else {
              $this.terminalUseTimeout = setTimeout(() => {
                $this.terminalUseCounter = 0
              }, 5000)
            }
            reject(e)
            return
          }
          reject({ errorMessage: $this._('There was an error initializing the payment.') })
          return
        }
        const orderNumber = response.data.items.ORDER_NUMBER
        const terminal = $this.paymentTerminalId
        const checkQuery = { terminal: terminal, order_number: orderNumber }
        $this.paymentIframeSrc = response.data.items.payment_url
        $this.cardPaymentActive = true
        // The result normally arrives over the websocket: Visma Pay's return page relays it to this till. That message can
        // get lost, for example while the till's socket reconnects, so if it hasn't come after a while, ask Visma Pay
        // directly. Whichever answers first finishes the payment (JDEV-3310).
        let finished = false
        let pollTimer = null
        const pollStarted = Date.now()
        const finish = () => {
          finished = true
          clearTimeout(pollTimer)
        }
        const fail = (error) => {
          $this.resetPaymentIframe()
          reject(error)
          $this.releasePaymentTerminal(terminal)
        }
        var handler = function (e) {
          let response = e.data.detail
          if (Number(response.ORDER_NUMBER) !== Number(orderNumber) || finished) {
            return
          }
          finish()
          // RETURN_CODE comes from the return URL as a string; a missing code is verified with Visma Pay below
          const returnCode = Number(response.RETURN_CODE)
          if (response.RETURN_CODE !== undefined && response.RETURN_CODE !== '' && returnCode !== 0) {
            fail({ errorMessage: $this.getPaymentError(response.RETURN_CODE), code: response.RETURN_CODE })
            return
          }
          $this.checkPaymentStatus(shopId, orderNumber, payment, checkQuery, resolve, reject)
        }
        this.EventBus.$on('bamborastatechanged', handler)
        const poll = async () => {
          if (finished) {
            return
          }
          const status = await this.pollPaymentStatus(shopId, orderNumber)
          if (finished) {
            return
          }
          if (status.paid) {
            finish()
            this.checkPaymentStatus(shopId, orderNumber, payment, checkQuery, resolve, reject)
            return
          }
          if (status.failed) {
            finish()
            fail(status.error)
            return
          }
          if (Date.now() - pollStarted > BAMBORA_POLL_TIMEOUT_MS) {
            finish()
            fail({ errorMessage: this._('The card payment could not be confirmed. Check the payment terminal before charging again: if it shows the payment as approved, the customer has already paid.') })
            return
          }
          pollTimer = setTimeout(poll, BAMBORA_POLL_INTERVAL_MS)
        }
        pollTimer = setTimeout(poll, BAMBORA_POLL_DELAY_MS)
      }
    },
    /**
     * Ask Visma Pay whether a terminal payment has been paid. Without the terminal in the query, so that the backend
     * doesn't release the terminal lock while the customer is still paying.
     */
    async pollPaymentStatus (shopId, orderNumber) {
      try {
        await axios.post(`${this.baseDomain}${shopId}/${this.locale}/bamborahandler/custom.json?action=check&apikey=${this.apiKey}`, { order_number: orderNumber })
        return { paid: true }
      } catch(e) {
        const data = e && e.response && e.response.data
        if (data && data.errorCode === 'PAYMENT_FAILED') {
          return { failed: true, error: data }
        }
        // Still in progress, no final answer yet, or a network error: try again
        return {}
      }
    },
    checkPaymentStatus(shopId, orderNumber, payment, query, resolve, reject) {
      let checkResponse
      let retries = 4
      const makeRequest = async () => {
        try {
          checkResponse = await axios.post(`${this.baseDomain}${shopId}/${this.locale}/bamborahandler/custom.json?action=check&apikey=${this.apiKey}`, query)
          this.resetPaymentIframe()
          this.bamboraOrderNumber = orderNumber
          if (payment) {
            this.terminalData[payment.id] = checkResponse.data
            this.bamboraOrderNumbers[payment.id] = orderNumber
            this.handlePaymentBrandNotification(checkResponse.data)
          }
          if (query.terminal) {
            this.releasePaymentTerminal(query.terminal)
          }
          resolve()
        } catch(e) {
          const errorCode = e.response && e.response.data && e.response.data.errorCode
          // Check succeeded but payment failed. Visma Pay may not have finished the payment yet when the result arrives,
          // so an in-progress or unknown status is retried like a network error.
          if (e.response && e.response.status === 400 && errorCode !== 'PAYMENT_IN_PROGRESS' && errorCode !== 'PAYMENT_STATUS_UNKNOWN') {
            this.resetPaymentIframe()
            reject(e.response.data)
            if (query.terminal) {
              this.releasePaymentTerminal(query.terminal)
            }
            return
          }
          if (retries > 0) {
            // Exponential backoff
            setTimeout(makeRequest, Math.pow(2, 4 - retries) * 1000)
            retries--
          } else {
            this.resetPaymentIframe()
            reject({ errorMessage: this._('Unable to confirm that the payment was successful.') })
            if (query.terminal) {
              this.releasePaymentTerminal(query.terminal)
            }
          }
        }
      }
      makeRequest()
    },
    handlePaymentBrandNotification(data) {
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      const notifyBrands = ['Edenred']
      if (data.source && data.source.brand && notifyBrands.includes(data.source.brand)) {
        this.showWarning(this._('The card used in the payment was %s.').replace('%s', data.source.brand))
      }
    },
    releasePaymentTerminal(identifier) {
      const shopId = this.$store.state.shopId
      axios.post(`${this.baseDomain}${shopId}/${this.locale}/bamborahandler/custom.json?action=release&apikey=${this.apiKey}`, 
        {
          terminal: identifier
        }
      )
    },
    showTerminalInUseDialog() {
      this.showDialog({
        title: this._('The payment terminal is currently in use.'),
        text: this._('If you are sure the terminal is not being used by anyone else, you may manually unlock the terminal.'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Release lock'),
            class: 'danger',
            icon: 'unlock',
            handler: () => {
              this.releasePaymentTerminal(this.paymentTerminalId)
            }
          }
        ],
        clickToClose: true
      })
    },
    async processMobilePayment (resolve, reject, payment) {
      if (this.mobilePaymentType == 'masterpass' || this.mobilePaymentType == 'creditcards') {
        return this.processMasterPass(resolve, reject, payment)
      }
      let $this = this
      let shopId = this.$store.state.shopId
      let amountStr = shopId + ':' + $this.mobilePaymentAmount
      if (payment) {
        amountStr = shopId + ':' + parseFloat(payment.amount)
      }
      if (this.isChannelTransaction) {
        amountStr = this.getChannelTransactionAmountStr()
      } 
      let response
      try {
        response = await axios.post(`${$this.baseDomain}${shopId}/${$this.locale}/bamborahandler/custom.json?action=mobile&selected=${$this.mobilePaymentType}&apikey=${$this.apiKey}&client=${this.clientid}`, 
          {
            domain: $this.hostName,
            amounts: amountStr
          }
        )
      } catch(e) {
        reject({ errorMessage: $this._('There was an error initializing the payment.') })
        return
      }
      const orderNumber = response.data.items.ORDER_NUMBER
      $this.paymentIframeSrc = response.data.items.payment_url
      $this.cardPaymentActive = true
      var handler = function (e) {
        let response = e.data.detail
        if (Number(response.ORDER_NUMBER) !== Number(orderNumber)) {
          return
        }
        if (response.RETURN_CODE > 0) {
          $this.resetPaymentIframe()
          reject({ errorMessage: $this.getPaymentError(response.RETURN_CODE), code: response.RETURN_CODE } )
          return
        }
        $this.checkPaymentStatus(shopId, orderNumber, payment, { order_number: orderNumber }, resolve, reject)
      }
      this.EventBus.$on('bamborastatechanged', handler)
    },
    async processMasterPass (resolve, reject, payment) { // Exception for VirtualCard (and legacy MasterPass): this needs to open a new window!
      let $this = this
      let shopId = this.$store.state.shopId
      let amountStr = shopId + ':' + $this.mobilePaymentAmount
      if (payment) {
        amountStr = shopId + ':' + parseFloat(payment.amount)
      }
      if (this.isChannelTransaction) {
        amountStr = this.getChannelTransactionAmountStr()
      }
      const newWindow = window.open('') // eslint-disable-line
      const timer = setInterval(() => {
        if (!newWindow || newWindow.closed) {
          clearInterval(timer)
          console.log('Payment window closed manually, aborting.')
          reject({ errorMessage: $this.getPaymentError('1'), code: '1' })
        }
      }, 250)
      let response
      try {
        response = await axios.post(`${$this.baseDomain}${shopId}/${$this.locale}/bamborahandler/custom.json?action=mobile&selected=${$this.mobilePaymentType}&apikey=${$this.apiKey}&client=${this.clientid}`, 
          {
            domain: $this.hostName,
            amounts: amountStr
          }
        )
      } catch(e) {
        reject({ errorMessage: $this._('There was an error initializing the payment.') })
        return
      }
      const orderNumber = response.data.items.ORDER_NUMBER
      newWindow.location.href = response.data.items.payment_url
      $this.cardPaymentActive = true
      var handler = function (e) {
        let response = e.data.detail
        if (Number(response.ORDER_NUMBER) !== Number(orderNumber)) {
          return
        }
        clearInterval(timer)
        newWindow.close()
        if (response.RETURN_CODE > 0) {
          $this.resetPaymentIframe()
          reject({ errorMessage: $this.getPaymentError(response.RETURN_CODE), code: response.RETURN_CODE } )
          return
        }
        $this.checkPaymentStatus(shopId, orderNumber, payment, { order_number: orderNumber }, resolve, reject)
      }
      this.EventBus.$on('bamborastatechanged', handler)
    },
    togglePaySelectedMode () {
      this.paySelectedMode = !this.paySelectedMode
      if (!this.paySelectedMode) {
        this.selectedFolioItemIds = []
        this.pendingFolioSplit = null
      }
    },
    hasStatisticsFinlandItems (itemIds) {
      const selected = (itemIds || []).map(id => parseInt(id, 10))
      return this.folioBasketItems.some(item => selected.indexOf(parseInt(item.id, 10)) !== -1 && item.product && item.product.accommodationtype)
    },
    isFolioItemSelectable (item) {
      if (!item || !item.id || item.item_id || item.modifier_id || item.discount_id || parseInt(item.isdelivery)) {
        return false
      }
      if (this.activeOrder && (this.activeOrder.origin === 'channex-boo' || this.activeOrder.origin === 'channex-air') && (item.reservation_datestart || item.originalreservation_id)) {
        return false
      }
      return true
    },
    isFolioItemSelected (item) {
      if (!item || !item.id) {
        return false
      }
      return this.selectedFolioItemIds.indexOf(parseInt(item.id, 10)) !== -1
    },
    isFolioItemInSelection (item) {
      // Selected items plus the sub-items that move with them
      return !!(item && item.id) && this.selectedFolioItemTreeIds.indexOf(parseInt(item.id, 10)) !== -1
    },
    toggleFolioItem (item) {
      if (!item || !item.id || item.item_id || item.modifier_id || this.isFolioSelectionLocked) {
        return
      }
      const id = parseInt(item.id, 10)
      if (this.isFolioItemSelected(item)) {
        this.selectedFolioItemIds = this.selectedFolioItemIds.filter(selectedId => selectedId !== id)
      } else {
        this.selectedFolioItemIds = [...this.selectedFolioItemIds, id]
      }
    },
    buildFinalizePayload (orderId, returnable) {
      const data = {
        client: this.clientid,
        shop: this.shopId,
        pos: this.pos,
        id: orderId,
        payment: this.paymentType,
        notifications: true,
        printReceipt: false,
        printTickets: false,
        printManifest: 'auto',
        emailReceipt: false,
        emailTickets: false,
        printCombined: false,
        emailTarget: false
      }
      if (this.statisticsFinlandApplies(true) && this.triptype) {
        data.triptype = this.triptype
      }
      if (this.receiptType == 'email') {
        data.emailReceipt = true
        data.emailTarget = this.receiptEmail
      } else if (this.receiptType == 'print') {
        data.printReceipt = true
      }
      switch (this.ticketType) {
        case 'separate':
          data.printTickets = true
          break
        case 'combined':
          data.printTickets = true
          data.printCombined = true
          break
        case 'separateemail':
          data.emailTarget = this.receiptEmail
          data.emailTickets = true
          break
        case 'combinedemail':
          data.emailTarget = this.receiptEmail
          data.printCombined = true
          data.emailTickets = true
          break
      }
      data.converttobill = true
      data.newPayment = this.payments.map(payment => this.paymentForBill(payment))
      if (returnable > 0) {
        data.newPayment.push({
          id: this.pos + '/' + this.index + '/' + new Date().getTime(),
          type: 'admincash',
          amount: '-' + returnable
        })
      }
      return data
    },
    async finalizeFolioSplit (returnable, itemIds) {
      const shopId = this.shopId
      let orderIdentifier = this.pendingSplitOrderId || this.orderIds[shopId]
      if (!orderIdentifier && this.activeOrder) {
        orderIdentifier = this.activeOrder.identifier
      }
      if (!orderIdentifier) {
        throw new Error(this._('The order could not be created.'))
      }
      const splitItemIds = (itemIds && itemIds.length) ? itemIds : this.selectedFolioItemTreeIds
      this.pendingSplitOrderId = orderIdentifier
      const orderResponse = await axios.get(`${this.baseDomain}${shopId}/${this.version}/orders/${orderIdentifier}.json`)
      const orderId = orderResponse.data.id
      const data = this.buildFinalizePayload(orderId, returnable)
      data.splititems = splitItemIds
      await axios({
        method: 'put',
        data,
        url: `${this.baseDomain}${shopId}/${this.version}/orders/${orderId}.json?client=${this.clientid}`
      })
      await this.finishFolioSplit(orderIdentifier)
    },
    async finishFolioSplit (orderIdentifier) {
      const shopId = this.shopId
      const remaining = await axios.get(`${this.baseDomain}${shopId}/${this.version}/orders/${orderIdentifier}.json`)
      this.paySelectedMode = false
      this.selectedFolioItemIds = []
      this.pendingSplitOrderId = null
      this.orderPosted = false
      this.orderIds = {}
      // Must run before the switch, while the basket still holds the payments that were billed on the folio
      await this.clearPayments()
      await this.switchReceiptToOpenOrder(remaining.data)
    },
    async switchReceiptToOpenOrder (order) {
      if (this.floatingReceipt && !this.primary) {
        return
      }
      this.index = 1
      this.$store.dispatch('setActiveBasket', 1)
      this.setActiveOrder(order)
      await new Promise((resolve) => {
        this.initAdminBasket(order.identifier, resolve)
      })
      if (!this.activeOrder) {
        this.initBasket()
      }
    },
    postOrders (opts) {
      this.orderPosted = true
      let $this = this
      this.orderFailures = 0
      this.orderSuccesses = 0
      this.orderIds = {}
      return new Promise((resolve, reject) => {
        let basketArr = []
        let shopIds = []
        for (var shopIdWithIndex in $this.basketIds) {
          if (Object.prototype.hasOwnProperty.call($this.basketIds, shopIdWithIndex)) {
            let siArr = shopIdWithIndex.split('-')
            let shopId = siArr[0]
            let index = siArr[1]
            if ((!this.basketItems || !this.basketItems[shopIdWithIndex] || !this.basketItems[shopIdWithIndex].length) && shopId !== this.shopId) {
              continue
            }
            shopIds.push(shopId)
            let basketId = $this.basketIds[shopIdWithIndex]
            let data = Object.assign({}, $this.selectedCustomer)
            delete data.sharedBillingcustomer
            delete data.identifier // Remove this or it might override the order identifier
            if ($this.selectedCustomer && $this.selectedCustomer.ext_id) {
              data.ext_customer_id = $this.selectedCustomer.ext_id
            } else {
              data.ext_customer_id = null
            }
            if ($this.selectedBillingcustomer && $this.selectedBillingcustomer.id) {
              if (shopId !== this.shopId) { // We can't save our local billing customer id to the external shop, it won't match!
                data.billingcustomer = Object.assign({}, this.selectedBillingcustomer) // Instead we send the full data, backend will do the matching
                delete data.billingcustomer.sharedCustomer // Though these attributes should not be sent
                delete data.billingcustomer.netvisorid
              } else {
                data.billingcustomer_id = this.selectedBillingcustomer.id
              }
            }
            data.version = this.version
            data.terms_accepted = 1
            if ($this.shopId === shopId) {
              data.master = 1
            } else {
              data.master = 0
            }
            if ($this.totalOrders > 1) {
              data.consolidated = 1
            } else {
              data.consolidated = 0
            }
            if ($this.isOpen || (opts && opts.isOpen)) {
              data.payment = 'open'
            }
            if ($this.more) {
              data.more = $this.more
            }
            if ($this.yourreference) {
              data.yourreference = $this.yourreference
            }
            if ($this.mark) {
              data.mark = $this.mark
            }
            if ($this.paymentterm) {
              data.pay_option1_duedays = $this.paymentterm
            }
            if ($this.interest) {
              data.interest = $this.interest
            }
            if (opts && opts.sendPaymentLink && $this.shopId === shopId) {
              data.sendpaymentlink = 1
            }
            if (opts && opts.sendConfirmationLink && $this.shopId === shopId) {
              data.sendconfirmationlink = 1
            }
            if (this.statisticsFinlandApplies(true) && this.triptype) {
              data.triptype = this.triptype
            }
            data.global = 1
            data.permanent = true
            data.origin = $this.shopId
            data.pos = $this.pos
            // let dataStr = qs.stringify(data)
            let orderIdentifierStr = ''
            if (this.activeOrder) {
              orderIdentifierStr = '&orderidentifier=' + this.activeOrder.identifier
            }
            basketArr.push(axios({
              method: 'post',
              url: `${$this.baseDomain}${shopId}/${$this.version}/orders/${basketId}.json?client=${$this.clientid}${orderIdentifierStr}`,
              data
            }))
          }
        }
        $this.totalPostedOrders = $this.totalOrders // Take a snapshot of the computed property so that it doesn't change before we compare
        // Wait for every request so that a failure always settles the promise (and the orders that
        // were created are known to cancelApprove())
        Promise.allSettled(basketArr).then((results) => {
          let firstError = null
          for (let i = 0; i < results.length; i++) {
            if (results[i].status === 'fulfilled') {
              $this.orderSuccesses++
              $this.orderIds[shopIds[i]] = results[i].value.data
            } else {
              $this.orderFailures++
              firstError = firstError || results[i].reason
            }
          }
          if (!$this.orderFailures && $this.orderSuccesses >= $this.totalPostedOrders) {
            $this.triptype = null
            resolve()
          } else {
            reject(firstError)
          }
        })
      })
    },
    async finalizeOrders (returnable) {
      this.orderFailures = 0
      this.orderSuccesses = 0
      if (this.isOpen && this.totalPostedOrders === 1) {
        return
      }
      const shopIdArr = Object.keys(this.orderIds)
      // Any failure below must reject, so that the sale is never treated as done when it isn't
      const orderResponses = await Promise.all(shopIdArr.map(shopId => axios({
        method: 'get',
        url: `${this.baseDomain}${shopId}/${this.version}/orders/${this.orderIds[shopId]}.json`
      })))
      const orderDataArr = orderResponses.map(response => response.data)
      const requests = orderDataArr.map((order, i) => {
        const shopId = shopIdArr[i]
        if (this.isOpen) {
          return axios({
            method: 'get',
            url: `${this.baseDomain}${shopId}/${this.version}/orders/${order.identifier}.json?client=${this.clientid}`
          })
        }
        let data = {
          client: this.clientid,
          shop: this.shopId, // Send the master shop id so that we know where to print to
          pos: this.pos,
          id: order.id,
          payment: this.paymentType,
          notifications: true,
          printReceipt: false,
          printTickets: false,
          printManifest: 'auto',
          emailReceipt: false,
          emailTickets: false,
          printCombined: false,
          emailTarget: false
        }
        if (this.receiptType == 'email') {
          data.emailReceipt = true
          data.emailTarget = this.receiptEmail
        } else if (this.receiptType == 'print') {
          data.printReceipt = true
        }
        switch (this.ticketType) {
          case 'separate':
            data.printTickets = true
            break
          case 'combined':
            data.printTickets = true
            data.printCombined = true
            break
          case 'separateemail':
            data.emailTarget = this.receiptEmail
            data.emailTickets = true
            break
          case 'combinedemail':
            data.emailTarget = this.receiptEmail
            data.printCombined = true
            data.emailTickets = true
            break
        }
        if (this.isBilling) {
          data.confirm = true
        } else {
          data.converttobill = true
        }
        if (orderDataArr.length > 1) { // Cross-selling, so everything will be paid in full if we get this far
          const payment = this.paymentForBill(this.payments[0])
          let p = {
            id: payment.id,
            resolved: payment.resolved,
            type: payment.type,
            amount: parseFloat(order.totalWithDelivery),
          }
          if (payment.bamboraOrderNumber) {
            p.bamboraOrderNumber = payment.bamboraOrderNumber
          }
          if (payment.vivaOrderNumber) {
            p.vivaOrderNumber = payment.vivaOrderNumber
          }
          if (payment.terminalData) {
            p.terminalData = payment.terminalData
          }
          data.newPayment = [p]
        } else {
          data.newPayment = this.payments.map(payment => this.paymentForBill(payment))
        }
        if (returnable > 0) {
          data.newPayment.push({
            id: this.pos + '/' + this.index + '/' + new Date().getTime(),
            type: 'admincash',
            amount: '-' + returnable
          })
        }
        return axios({
          method: 'put',
          data: data,
          url: `${this.baseDomain}${shopId}/${this.version}/orders/${order.id}.json?client=${this.clientid}`
        })
      })
      const results = await Promise.allSettled(requests)
      const failed = results.filter(result => result.status === 'rejected')
      this.orderFailures = failed.length
      this.orderSuccesses = results.length - failed.length
      if (failed.length) {
        throw failed[0].reason
      }
      this.EventBus.$emit('purchase', {
        shopIds: shopIdArr,
        items: orderDataArr
      })
      if (orderDataArr.length > 1) { // Cross-selling, we need to create consolidated order(s) manually since this is the POS process
        let master = false
        let masterShopId = false
        for (let j = 0; j < orderDataArr.length; j++) {
          if (parseInt(orderDataArr[j].master)) {
            master = orderDataArr[j]
            masterShopId = shopIdArr[j]
            break
          }
        }
        if (master) {
          for (let j = 0; j < orderDataArr.length; j++) {
            let order = orderDataArr[j]
            if (!parseInt(order.master) || !parseInt(order.hidden)) {
              let data = {
                local_order_id: order.id,
                order_id: master.id,
                shop_id: shopIdArr[j],
                orderdate: order.orderdate,
                total: order.totalWithDelivery,
                totalVatFree: order.totalWithDeliveryVatFree,
                pos: this.pos
              }
              axios({
                method: 'post',
                data: data,
                url: `${this.baseDomain}${masterShopId}/${this.version}/consolidatedorders.json?apikey=${this.apiKey}`
              })
            }
          }
        }
      }
    },
    resetPaymentIframe () {
      this.EventBus.$off('bamborastatechanged')
      this.cardPaymentActive = false
      this.paymentIframeSrc = 'about:blank'
      this.paymentIframeClass = ''
    },
    paymentIframeLoaded () {
      this.paymentIframeClass = 'loaded'
    },
    confirmOrderDeletion () {
      return new Promise((resolve, reject) => {
        this.showDialog({
          title: this._('Are you sure you want to delete the order? Deletion can\'t be undone.'),
          width: 800,
          buttons: [
            {
              title: this._('Cancel'),
              icon: 'ban',
              handler: reject
            },
            {
              title: this._('Delete order'),
              class: 'danger',
              icon: 'trash',
              handler: resolve
            }
          ],
          clickToClose: false
        })
      })
    },
    async deleteBasketItems () {
      let deleteOrder = false
      if (this.isOpenOrder && this.activeOrder && this.activeOrder.id) {
        try {
          await this.confirmOrderDeletion()
          deleteOrder = this.activeOrder.id
        } catch(e) {
          return
        }
      }
      for (var shopId in this.myBasketItems) {
        if (Object.prototype.hasOwnProperty.call(this.myBasketItems, shopId)) {
          this.$store.dispatch('deleteAllItemsFromBasket', {
            shopId: shopId,
            index: this.index
          })
        }
      }
      await this.clearPayments()
      this.receiptEmail = ''
      this.selectedCustomer = null
      this.selectedBillingcustomer = null
      this.modifiedItems = []
      this.EventBus.$emit('modifyOrder', {
        order: null
      })
      if (deleteOrder) {
        try {
          await axios.delete(this.baseDomain + this.shopId + '/orders/' + deleteOrder + '.json?apikey=' + this.apiKey)
        } catch(e) {
          this.showError(this._('Deleting the order failed!'))
        }
      }
    },
    toggleReceiptHeader () {
      this.headerExpanded = !this.headerExpanded
    },
    setPrivateCustomer () {
      this.backupBillingCustomer = this.selectedBillingcustomer
      this.selectedBillingcustomer = null
    },
    setCorporateCustomer () {
      if (this.backupBillingCustomer) {
        this.selectedBillingcustomer = this.backupBillingCustomer
      } else {
        this.customerSelectorDialog('billing')
      }
    },
    clearCustomer () {
      this.headerExpanded = false
      this.selectedBillingcustomer = null
      this.selectedCustomer = null
      this.backupBillingCustomer = null
      this.triptype = null
      this.setMobilepayPhoneNumber(null)
      this.setMobilepayToken(null)
    },
    resetTmpOrder () {
      this.tmpOrder = {
        more: '',
        yourreference: '',
        mark: '',
        paymentterm: '',
        interest: '',
      }
    },
    processScannedValuecard() {
      // Streamlined value card code processing, instead of using the modal
      if (this.isScannedValuecardValid && !this.valuecardModalOpen) {
        this.addValueCard()
      }
    },
    async loadValuecardDetails(payment) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/valuecards/' + payment.item.valuecard_id + '.json?details=true&apikey=' + this.apiKey)
      } catch(e) {}
      if (response && response.data) {
        this.EventBus.$emit('valueCardInfo', response.data)
      }
    },
    showValueCardNotification(valuecard) {
      if(valuecard) {
        let message = (selectedValuecard.shopTitle ? selectedValuecard.shopTitle + ': ' : '') + selectedValuecard.name + '<br>'
        if (isStandardValuecard) {
          message += this._('Remaining value') + ': ' + this.$filters.currency(selectedValuecard.remainingvalue, this.basketCurrency) + (selectedValuecard.remainingcount > 1 ? 'x '+ selectedValuecard.remainingcount : '')
        } else {
          message += this._('Remaining uses') + ': ' + selectedValuecard.remainingcount
        }
        if (this.scannedValuecard.personal) {
          message += '<br>' + this._('This value card is only usable by') + this.scannedValuecard.personal
        }
        this.showCustomNotification(message, { autoClose: 10000 })
      }
    },
    getSeatDescription (seat) {
      if (seat.header || seat.title) {
        return (seat.header ? seat.header + ' / ' : '') + seat.title
      }
      return seat.name
    },
    throttledUpdateShipitDeliveryPrices: throttle(function () { this.updateShipitDeliveryPrices() }, 500, { leading: false, trailing: true }),
    async updateShipitDeliveryPrices () {
      const postCode = this.getShipitPostCode()
      const country = this.getShipitCountry()
      for (let shopId in this.shipitDeliverymethods) {
        for (let dm of this.shipitDeliverymethods[shopId]) {
          if (!postCode || !country) {
            this.allSettings[shopId + '-' + this.locale].sharedDeliverymethod.find(d => parseInt(d.id) === parseInt(dm.id)).price = 0
            continue
          }
          const key = postCode + '-' + country + '-' + dm.id
          if (this.shipitPriceCache[key]) {
            this.shipitPriceCache[key]
          } else {
            let response
            try {
              response = await axios.get(this.baseDomain + shopId + '/shipithandler/shippingmethods.json?postcode=' + postCode + '&country=' + country + '&deliverymethod_id=' + dm.id)
              this.shipitPriceCache[key] = response.data.methods
            } catch(e) {
              return
            }
          }
          if (this.shipitPriceCache[key][0]) {
            const method = this.shipitPriceCache[key][0]
            this.allSettings[shopId + '-' + this.locale].sharedDeliverymethod.find(d => parseInt(d.id) === parseInt(dm.id)).price = method.price
          }
        }
      }
    },
    getShipitPostCode () {
      let postCode
      if (this.selectedBillingcustomer) {
        postCode = this.selectedBillingcustomer.zip
      }
      if (!postCode && this.selectedCustomer) {
        postCode = this.selectedCustomer.zip
      }
      return postCode
    },
    getShipitCountry () {
      let country
      if (this.selectedBillingcustomer) {
        country = this.selectedBillingcustomer.country
      }
      if (!country && this.selectedCustomer) {
        country = this.selectedCustomer.country
      }
      return country
    },
    async printDeliveryManifest (shipment) {
      const deliveryId = shipment.delivery.id
      if (!this.activeOrder || !this.activeOrder.id) {
        this.EventBus.$off('modifyOrderComplete')
        this.EventBus.$on('modifyOrderComplete', () => {
          shipment.active = false
          this.activateShipment(this.shopId, shipment)
          this.EventBus.$off('modifyOrderComplete')
        })
        try {
          await this.convertToOpenOrder()
        } catch(e) {
          this.showError(this._('Unable to convert to open order.'))
          this.EventBus.$off('modifyOrderComplete')
          return
        }
      }
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/orders/' + this.activeOrder.id + '/print.json?print=manifest&deliveries=' + deliveryId + '&client=' + this.clientid + '&pos=' + this.pos + '&apikey=' + this.apiKey)
      } catch(e) {
        // We fail silently, yay?
      }
      shipment.active = false
    },
    convertToOpenOrder() {
      return new Promise(async (resolve, reject) => {
        try {
          await this.postOrders({ isOpen: true })
        } catch(e) {
          reject(e)
          return
        }
        let order = await this.loadOrder(this.orderIds[this.shopId])
        if (!order) {
          reject()
          return
        }
        this.EventBus.$emit('modifyOrder', {
          order,
          preventFloatingReceiptPopup: true
        })
        resolve()
      })
    },
    /*
    handleAddPayment(message) {
      if (!message || !message.data) {
        return
      }
      // Don't re-add payments that we already have
      if (this.payments.find(p => p.id === message.data.id)) {
        return
      }
      this.payments.push(message.data)
      this.applyRoundingDiff(message.data)
      // this.persist('payments', this.payments)
      if (this.selectedCustomer && this.selectedCustomer.sharedBillingcustomer && message.data.billingCustomer) {
        for (let i = 0; i < this.selectedCustomer.sharedBillingcustomer.length; i++) {
          let bc = this.selectedCustomer.sharedBillingcustomer[i]
          if (bc.id == message.data.billingCustomer) {
            this.selectedBillingcustomer = bc
          }
        }
      }
      this.addingPayment = false
      if (parseInt(this.selfService)) {
        this.approve()
      }
    },
    */
    statisticsFinlandApplies (compatible) {
      return this.isFeatureEnabled('statisticsfinland') && this.hasStatisticsFinlandCredentials && !!compatible
    },
    askTripTypeDialog (callback, ...args) {
      this.showDialog({
        title: this._('Select trip type'),
        text: this._('The order includes a product with statistics finland accommodation type. A trip type selection is required to proceed.'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {
              return this.showError(this._('The order includes a product with statistics finland accommodation type. A trip type selection is required to proceed.'))
            }
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            requiredFields: ['triptype'],
            handler: (data) => {
              if (data.triptype) {
                this.triptype = data.triptype
                return callback(...args)
              } else {
                return this.showError(this._('The order includes a product with statistics finland accommodation type. A trip type selection is required to proceed.'))
              }
            }
          }
        ],
        fields: [
          {
            title: this._('Trip type'),
            type: 'select',
            name: 'triptype',
            defaultValue: this.defaultTripType,
            options: [{
              value: 'leisure',
              name: this._('Leisure trip')
            },
            {
              value: 'business',
              name: this._('Business trip')
            }]
          }
        ]
      })
    },
    memoizeDebounce: function(func, wait = 0, options = {}) {
      var mem = memoize(function() {
        return debounce(func, wait, options)
      }, options.resolver)
      return function() { mem.apply(this, arguments).apply(this, arguments) }
    },
    /*
    applyShipitPrice (deliverymethod) {
      console.log('applyshipitprice', deliverymethod)
      const postCode = this.getShipitPostCode()
      const country = this.getShipitCountry()
      if (!postCode || !country || !deliverymethod || !deliverymethod.id) {
        return deliverymethod
      }
      const key = postCode + '-' + country + '-' + deliverymethod.id
      if (this.shipitPriceCache[key]) {
        console.log('found cache', deliverymethod)
        deliverymethod.price = this-shipitPriceCache[key]
      }
      return deliverymethod
    }
    */
  },
  components: {
    Multiselect,
    PhoneNumberInput
  },
  watch: {
    /*
    locked (newValue, oldValue) {
      if(oldValue !== null && newValue) {
        this.clearReceipt()
      }
      if(oldValue === null && newValue) {
        this.getComponentLock(true)
      }
    },*/
    isFolioSplitAvailable (available) {
      if (!available && this.paySelectedMode && !this.approving) {
        this.paySelectedMode = false
        this.selectedFolioItemIds = []
        this.pendingFolioSplit = null
      }
    },
    myBasketItems () {
      // Scroll to bottom on item changes - insert code here
    },
    basketsWithItems: {
      deep: true,
      handler () {
        this.pruneModifiedItems()
      }
    },
    shipitDeliverymethods: {
      deep: true,
      handler (newValue) {
        this.throttledUpdateShipitDeliveryPrices()
      }
    },
    selectedCustomer: {
      deep: true,
      handler (newValue) {
        this.throttledUpdateShipitDeliveryPrices()
      }
    },
    selectedBillingcustomer: {
      deep: true,
      handler (newValue) {
        this.throttledUpdateShipitDeliveryPrices()
      }
    }
    /*
    shopsWithActiveShipments: {
      deep: true,
      handler (newValue, oldValue) {
        if (JSON.stringify(newValue) === JSON.stringify(oldValue) || !oldValue || !oldValue.length || newValue.length < 2) {
          console.log('ignore new', newValue)
          console.log('ignore old', oldValue)
          return
        }
        const shopId = oldValue[0]
        let orderIdentifierStr = ''
        if (this.activeOrder) {
          orderIdentifierStr = '&orderidentifier=' + this.activeOrder.identifier
        }
        const otherData = {
          identifier: this.basketIds[shopId + '-' + this.index],
          delivery_id: null
        }
        axios.put(this.baseDomain + shopId + '/baskets/' + this.basketIds[shopId + '-' + this.index] + '.json?client=' + this.clientid + '&shop=' + this.shopId + orderIdentifierStr, otherData)
      }
    }
    */
  },
  /*
  watch: {
    selectedCustomer (newValue) {
      if (newValue && parseInt(newValue.billingcustomer_id) && newValue.sharedBillingcustomer && newValue.sharedBillingcustomer.length) {
        this.selectedBillingcustomer = newValue.sharedBillingcustomer.find(bc => parseInt(bc.id, 10) === parseInt(newValue.billingcustomer_id, 10))
      } else {
        this.selectedBillingcustomer = null
      }
    }
  },
  */
  updated () {
    if (this.index && this.index !== this.data.index) {
      this.initBasket()
    }
  },
  beforeUnmount() {
    if(window && window.visualViewport) {
      window.visualViewport.removeEventListener("resize", this.viewportHandler);
    }
    clearTimeout(this.orderRestoreTimer)
  },
  beforeMount () {
    this.restoreReceiptType()
    this.restoreTicketType()
  },
  mounted () {
    /*if (process.browser) {
      if ("virtualKeyboard" in navigator) {
        navigator.virtualKeyboard.overlaysContent = true
      }
    }*/
    if(window && window.visualViewport) {
      window.visualViewport.addEventListener("resize", this.viewportHandler);
    }
    if (this.defaulttickettype && !this.storedTicketType()) {
      this.ticketType = this.defaulttickettype
    }
    if (this.isNetvisorConfigured && this.isBillingEnabled) {
      this.loadAccounts()
    }
    this.loadProductTypes()
    this.reloadPaymentsDebounced = this.memoizeDebounce(this.reloadPayments, 200)
    this.initBasket(false, async () => {
      await this.reloadPayments(this.shopId + '-' + this.index)
      this.resumeOrderRestore()
    })
    if(!this.events) {
      let events = {}
      /*
      events['addPayment'] = (message) => {
        if (message.pos === this.pos && message.index === this.index) {
          this.handleAddPayment(message)
        }
      }
      events['clearPayments'] = (message) => {
        if (message.pos === this.pos && message.index === this.index) {
          this.clearPayments()
        }
      }
      events['removePayment'] = (message) => {
        if (message.pos === this.pos && message.index === this.index) {
          for (var i = 0; i < this.payments.length; i++) {
            if (this.payments[i].id == message.data.id) {
              if (this.payments[i].type == 'billing' || this.payments[i].type == 'open') {
                this.selectedBillingcustomer = null
              }
              this.payments.splice(i, 1)
              this.applyRoundingDiff()
              this.persist('payments', this.payments)
              return
            }
          }
          this.addingPayment = false
        }
      },
      */
      events['closeOrderEditor'] = (message) => {
        if (message && this.activeOrder && parseInt(message.order_id, 10) === parseInt(this.activeOrder.id, 10)) {
          this.clearReceipt()
        }
      },
      events['approve'] = (message) => {
        if (message.pos === this.pos && message.index === this.index) {
          this.approving = true
        }
      }
      events['setCustomer'] = (message) => {
        if (message.data) {
          this.receiptEmail = message.data.email ? message.data.email : ''
        }
        if (message.pos === this.pos && message.index === this.index && (message.clientid !== this.clientid || message.tabid !== this.tabid)) {
          this.customerPropagated = true
          this.selectedCustomer = message.data
          this.customerPropagated = false
        }
      }
      events['clearCustomer'] = (message) => {
        if (message.pos === this.pos && message.index === this.index && (message.clientid !== this.clientid || message.tabid !== this.tabid)) {
          this.receiptEmail = ''
          this.customerPropagated = true
          this.selectedCustomer = null
          this.customerPropagated = false
        }
      }
      events['setBillingcustomer'] = (message) => {
        if (message.data) {
          this.receiptEmail = message.data.email ? message.data.email : ''
        }
        if (message.pos === this.pos && message.index === this.index && (message.clientid !== this.clientid || message.tabid !== this.tabid)) {
          this.billingcustomerPropagated = true
          this.selectedBillingcustomer = message.data
          this.billingcustomerPropagated = false
        }
      }
      events['clearBillingcustomer'] = (message) => {
        if (message.pos === this.pos && message.index === this.index && (message.clientid !== this.clientid || message.tabid !== this.tabid)) {
          this.receiptEmail = ''
          this.billingcustomerPropagated = true
          this.selectedBillingcustomer = null
          this.billingcustomerPropagated = false
        }
      }
      events['cancelapprove'] = (message) => {
        if (message.pos === this.pos && message.index === this.index) {
          this.approving = false
        }
      }
      events['ticketScanned'] = (message) => {
        this.scannedTicket = message
        if (this.isScannedTicketValid) {
          this.$modal.show('ticketModal')
        }
      }
      events['valueCardInfo'] = (message) => {
        this.selectedValuecard = message
        this.$modal.show('valuecardInfoModal')
      }
      events['valuecardScanned'] = (message) => {
        if(this.valuecardModalOpen) {
          return
        }
        if (this.floatingReceipt && !this.primary) { // Don't do anything if we have a floating receipt and this is not it
          return
        }
        this.scannedValuecard = message
        let found = false
        if (this.scannedValuecard && this.scannedValuecard.sharedShop && this.scannedValuecard.sharedShop.length) {
          if (this.scannedValuecard.sharedShop[0].shopid !== this.shopId) {
            this.scannedValuecard.shopTitle = this.scannedValuecard.sharedShop[0].title
          }
          for (var i = 0; i < this.scannedValuecard.sharedShop.length; i++) {
            if (this.scannedValuecard.sharedShop[i].shopid == this.shopId) {
              found = true
              break
            }
          }
        }
        if (found) {
          this.selectedValuecardCount = 1
          if (this.scannedValuecard.remainingvalue === 0 && this.scannedValuecard.remainingcount > 0) {
            this.processScannedValuecard()
          } else {
            this.selectedValuecardAmount = Math.min(this.scannedValuecard.remainingvalue, this.displayedTotal)
            this.$modal.show('valuecardModal')
          }
        } else {
          this.$modal.show('valuecardErrorModal')
        }
      }
      events['modifyOrder'] = async (message) => {
        this.uiLocked = true
        const order = message.order
        if (!order) {
          this.releaseComponentLock()
          this.setActiveOrder(null)
          this.clearCustomer()
          this.resetTmpOrder()
          this.closeAdminBasket(() => {
            this.EventBus.$emit('modifyOrderComplete')
          })
          this.EventBus.$emit('hideFloatingReceipt')
          return
        }
        this.setActiveOrder(order)
        if(!message.propagated) {
          this.getComponentLock()
        }
        setTimeout(() => {
          if (this.floatingReceipt && !this.primary) { // Don't do anything if we have a floating receipt and this is not it
            return
          }
          if (this.shipments && Object.keys(this.shipments).length) {
            let basketShopId = Object.keys(this.shipments)[0]
            let shipment = this.shipments[basketShopId][0]
            this.activateShipment(basketShopId, shipment)
          }
        }, 500)

        if (order.customer_id) {
          this.selectedCustomer = await this.loadCustomer(order.customer_id)
        } else {
          this.selectedCustomer = null
        }
        if (order.billingcustomer_id) {
          this.selectedBillingcustomer = await this.loadBillingCustomer(order.billingcustomer_id)
        } else {
          this.selectedBillingcustomer = null
        }
        this.initAdminBasket(order.identifier, () => {
          this.EventBus.$emit('modifyOrderComplete')
        })
        if (!this.isAdminReceiptVisible && !message.preventFloatingReceiptPopup) {
          this.EventBus.$emit('showFloatingReceipt')
        }
      }
      events['modifyOrderComplete'] = () => {
        this.uiLocked = false
      }
      events['savingReceipt'] = (status) => {
        this.uiLocked = status
        this.saving = status
      }
      events['productUpdate'] = () => {
        this.products = []
      }
      events['lock'] = () => {
        this.uiLocked = true
      }
      events['unlock'] = () => {
        this.uiLocked = false
      }
      events['paymentlinkActivate'] = (data) => {
        if (data && data.data && this.activeOrder && this.activeOrder.id === data.data.id) {
          this.clearReceipt()
          this.showError(this._('The payment link has already been activated. Unlock the order for modification?'))
        }
      }
      events['pospaymentUpdate'] = (data) => {
        if (data && data.data && data.data.basketidentifier && data.data.basketidentifier === this.basketIds[this.shopId + '-' + this.index]) {
          this.reloadPaymentsDebounced(this.shopId + '-' + this.index)
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}

</script>

<style>
.customer-selector {
   display: flex; 
   flex-wrap: nowrap;
}
.customer-selector > .dropdown {
  flex-grow: 1;
}
.customer-selector > button {
  flex-shrink: 1;
}
input[type=email]:invalid {
  border-color: rgba(239, 20, 20, 0.8);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(239, 20, 20, 0.8);
  outline: 0 none;  
}
#paymentIframe {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%; 
  height: 100%;
  z-index: 10000001;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 50px;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
}
#paymentIframe iframe {
  position: relative;
  top: 0;
  left: 0;
  border: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
}
#paymentIframe iframe.loaded {
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.6);
}
.discount-selector .multiselect__content-wrapper {
  min-width: 300px;
}
.multiselect__content-wrapper {
  width: auto !important;
}
</style>
<style scoped>
.card-list-item {
  flex: none;
  height: 0;
  margin: 0;
  padding: 0;
}
.empty-basket button .fa {
  margin-bottom: 0;
  opacity: 1;
}
.shipment-header, .shipment-footer {
  cursor: pointer;
}
.btn.resolved-payment-part {
  padding: 1px 3px 0px 3px;
  margin-right: 3px;
}
.cart-totals-singlerow .cart-total-wrap {
  flex: 1 1 auto;
  min-width: 0;
}
.folio-split-actions {
  flex: none;
  align-self: center;
}
.folio-split-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 32px;
  min-width: 0;
  height: 32px;
  padding: 0;
  line-height: 1;
}
.folio-split-trigger .fa {
  width: auto;
  font-size: 16px;
}
.cart-totals-singlerow.folio-selected-totals {
  background: #e8f1f8;
}
.cart-total-price .cart-total-desc.folio-remaining-desc {
  font-weight: normal;
  font-size: 12px;
  padding-bottom: 0;
}
.folio-select-banner {
  position: sticky;
  top: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0 -15px;
  padding: 8px 15px;
  background: #e8f1f8;
  border-bottom: 1px solid #cfd8dc;
}
.folio-select-banner-text {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}
</style>